import React from "react";

export const ProcedureIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M2 16H18V2H2V16ZM11.41 7.75L12.82 9.17L15.99 6L17.41 7.42L12.82 12L10 9.16L11.41 7.75ZM3 4H8V6H3V4ZM3 8H8V10H3V8ZM3 12H8V14H3V12Z"
          fill="#172B4D"
        />
        <path
          d="M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM18 16H2V2H18V16Z"
          fill="#172B4D"
        />
        <path
          d="M17.41 7.42L15.99 6L12.82 9.17L11.41 7.75L10 9.16L12.82 12L17.41 7.42Z"
          fill="#172B4D"
        />
        <path d="M8 4H3V6H8V4Z" fill="#172B4D" />
        <path d="M8 8H3V10H8V8Z" fill="#172B4D" />
        <path d="M8 12H3V14H8V12Z" fill="#172B4D" />
      </svg>
    </>
  );
};
export const ArrowIcon = ({ color = "#788CA5" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4707 15.4698C13.397 15.5385 13.3379 15.6213 13.2969 15.7133C13.2559 15.8053 13.2338 15.9046 13.2321 16.0053C13.2303 16.106 13.2488 16.2061 13.2865 16.2994C13.3243 16.3928 13.3804 16.4777 13.4516 16.5489C13.5228 16.6201 13.6077 16.6762 13.7011 16.714C13.7945 16.7517 13.8945 16.7702 13.9952 16.7684C14.0959 16.7667 14.1952 16.7446 14.2872 16.7036C14.3792 16.6626 14.462 16.6035 14.5307 16.5298L18.5307 12.5298C18.6711 12.3892 18.75 12.1986 18.75 11.9998C18.75 11.8011 18.6711 11.6105 18.5307 11.4698L14.5307 7.46985C14.462 7.39616 14.3792 7.33706 14.2872 7.29607C14.1952 7.25507 14.0959 7.23303 13.9952 7.23126C13.8945 7.22948 13.7945 7.248 13.7011 7.28572C13.6077 7.32344 13.5228 7.37959 13.4516 7.45081C13.3804 7.52203 13.3243 7.60686 13.2865 7.70025C13.2488 7.79364 13.2303 7.89367 13.2321 7.99437C13.2338 8.09507 13.2559 8.19439 13.2969 8.28638C13.3379 8.37838 13.397 8.46118 13.4707 8.52985L16.1907 11.2498H6.50066C6.30175 11.2498 6.11098 11.3289 5.97033 11.4695C5.82968 11.6102 5.75066 11.8009 5.75066 11.9998C5.75066 12.1988 5.82968 12.3895 5.97033 12.5302C6.11098 12.6708 6.30175 12.7498 6.50066 12.7498H16.1907L13.4707 15.4698Z"
          fill={color}
        />
      </svg>
    </>
  );
};
export const NoDashboardIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.23 0H5.77L0.5 5.27V12.73L5.77 18H13.23L18.5 12.73V5.27L13.23 0ZM16.5 11.9L12.4 16H6.6L2.5 11.9V6.1L6.6 2H12.4L16.5 6.1V11.9Z"
          fill="#788CA5"
        />
        <path
          d="M9.5 14C10.0523 14 10.5 13.5523 10.5 13C10.5 12.4477 10.0523 12 9.5 12C8.94771 12 8.5 12.4477 8.5 13C8.5 13.5523 8.94771 14 9.5 14Z"
          fill="#788CA5"
        />
        <path d="M8.5 4H10.5V11H8.5V4Z" fill="#788CA5" />
      </svg>
    </>
  );
};
export const EditPencil = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const CategortDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8083 4.16667L15.8333 8.19167V15.8333H4.16667V4.16667H11.8083ZM11.8083 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V8.19167C17.5 7.75 17.325 7.325 17.0083 7.01667L12.9833 2.99167C12.675 2.675 12.25 2.5 11.8083 2.5ZM5.83333 12.5H14.1667V14.1667H5.83333V12.5ZM5.83333 9.16667H14.1667V10.8333H5.83333V9.16667ZM5.83333 5.83333H11.6667V7.5H5.83333V5.83333Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const ShowInstanceIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 5.83333H14.1667V7.5H9.16667V5.83333ZM9.16667 9.16667H14.1667V10.8333H9.16667V9.16667ZM9.16667 12.5H14.1667V14.1667H9.16667V12.5ZM5.83333 5.83333H7.5V7.5H5.83333V5.83333ZM5.83333 9.16667H7.5V10.8333H5.83333V9.16667ZM5.83333 12.5H7.5V14.1667H5.83333V12.5ZM16.75 2.5H3.25C2.83333 2.5 2.5 2.83333 2.5 3.25V16.75C2.5 17.0833 2.83333 17.5 3.25 17.5H16.75C17.0833 17.5 17.5 17.0833 17.5 16.75V3.25C17.5 2.83333 17.0833 2.5 16.75 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const NoCommentsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="420"
        height="199"
        viewBox="0 0 350 199"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_24104_51201)">
          <rect
            x="21"
            y="31.1562"
            width="248.237"
            height="64.692"
            rx="8"
            fill="white"
          />
          <rect
            x="21.5"
            y="31.6562"
            width="247.237"
            height="63.692"
            rx="7.5"
            stroke="#E4E6EA"
          />
        </g>
        <circle cx="49.5815" cy="62.7504" r="19.558" fill="#E9F2FF" />
        <circle
          cx="49.5815"
          cy="62.7504"
          r="19.058"
          stroke="#0C66E4"
          stroke-opacity="0.3"
        />
        <rect
          x="85.6875"
          y="47.7061"
          width="160.978"
          height="10.5312"
          rx="5.26562"
          fill="#E9F2FF"
        />
        <rect
          x="85.6875"
          y="67.2637"
          width="75.2232"
          height="10.5312"
          rx="5.26562"
          fill="#E9F2FF"
        />
        <g filter="url(#filter1_d_24104_51201)">
          <rect
            x="109.766"
            y="82.3076"
            width="248.237"
            height="64.692"
            rx="8"
            fill="white"
          />
          <rect
            x="110.266"
            y="82.8076"
            width="247.237"
            height="63.692"
            rx="7.5"
            stroke="#E4E6EA"
          />
        </g>
        <circle
          cx="138.347"
          cy="113.902"
          r="19.058"
          fill="#E9F2FF"
          stroke="#0C66E4"
        />
        <rect
          x="174.461"
          y="98.8564"
          width="160.978"
          height="10.5312"
          rx="5.26562"
          fill="#E9F2FF"
        />
        <rect
          x="174.461"
          y="118.414"
          width="75.2232"
          height="10.5312"
          rx="5.26562"
          fill="#E9F2FF"
        />
        <defs>
          <filter
            id="filter0_d_24104_51201"
            x="0.700001"
            y="0.856251"
            width="332.834"
            height="149.292"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="22" dy="12" />
            <feGaussianBlur stdDeviation="21.15" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0470588 0 0 0 0 0.4 0 0 0 0 0.894118 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_24104_51201"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_24104_51201"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_24104_51201"
            x="91.7656"
            y="54.3076"
            width="328.234"
            height="144.692"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="22" dy="12" />
            <feGaussianBlur stdDeviation="20" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0470588 0 0 0 0 0.4 0 0 0 0 0.894118 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_24104_51201"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_24104_51201"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
export const LogTabIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.25 3.33366 2.5 4.08366 2.5 5.00033V16.667C2.5 17.5837 3.25 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V8.33366H15.8333V16.667ZM4.16667 6.66699V5.00033H15.8333V6.66699H4.16667ZM5.83333 10.0003H14.1667V11.667H5.83333V10.0003ZM5.83333 13.3337H11.6667V15.0003H5.83333V13.3337Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const CommentIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6641 14.3087L15.6891 13.3337H3.33073V3.33366H16.6641V14.3087ZM16.6641 1.66699H3.33073C2.41406 1.66699 1.66406 2.41699 1.66406 3.33366V13.3337C1.66406 14.2503 2.41406 15.0003 3.33073 15.0003H14.9974L18.3307 18.3337V3.33366C18.3307 2.41699 17.5807 1.66699 16.6641 1.66699Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const FlagDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.88333 4.58341L10.2167 6.25008H14.5833V11.2501H11.7833L11.45 9.58342H5.41667V4.58341H9.88333ZM11.25 2.91675H3.75V17.0834H5.41667V11.2501H10.0833L10.4167 12.9167H16.25V4.58341H11.5833L11.25 2.91675Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const LocationDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0013 1.66675C6.7763 1.66675 4.16797 4.27508 4.16797 7.50008C4.16797 11.8751 10.0013 18.3334 10.0013 18.3334C10.0013 18.3334 15.8346 11.8751 15.8346 7.50008C15.8346 4.27508 13.2263 1.66675 10.0013 1.66675ZM5.83464 7.50008C5.83464 5.20008 7.7013 3.33341 10.0013 3.33341C12.3013 3.33341 14.168 5.20008 14.168 7.50008C14.168 9.90008 11.768 13.4917 10.0013 15.7334C8.26797 13.5084 5.83464 9.87508 5.83464 7.50008Z"
          fill="#788CA5"
        />
        <path
          d="M10.0013 9.58342C11.1519 9.58342 12.0846 8.65068 12.0846 7.50008C12.0846 6.34949 11.1519 5.41675 10.0013 5.41675C8.85071 5.41675 7.91797 6.34949 7.91797 7.50008C7.91797 8.65068 8.85071 9.58342 10.0013 9.58342Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const CommentUploadIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const CommentSendIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.51 21L22.5 12L1.51 3L1.5 10L16.5 12L1.5 14L1.51 21Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const AreaDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 15.5H18.5V17H2V15.5H3.5V2.75C3.5 2.55109 3.57902 2.36032 3.71967 2.21967C3.86032 2.07902 4.05109 2 4.25 2H16.25C16.4489 2 16.6397 2.07902 16.7803 2.21967C16.921 2.36032 17 2.55109 17 2.75V15.5ZM15.5 15.5V3.5H5V15.5H15.5ZM7.25 8.75H9.5V10.25H7.25V8.75ZM7.25 5.75H9.5V7.25H7.25V5.75ZM7.25 11.75H9.5V13.25H7.25V11.75ZM11 11.75H13.25V13.25H11V11.75ZM11 8.75H13.25V10.25H11V8.75ZM11 5.75H13.25V7.25H11V5.75Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const SchoolIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_22371_65941)">
          <path
            d="M15.832 5.83333H14.1654V7.5H15.832V5.83333Z"
            fill="#788CA5"
          />
          <path
            d="M15.832 9.16667H14.1654V10.8333H15.832V9.16667Z"
            fill="#788CA5"
          />
          <path d="M15.832 12.5H14.1654V14.1667H15.832V12.5Z" fill="#788CA5" />
          <path
            d="M0.832031 9.16667V17.5H5.83203V13.3333H7.4987V17.5H12.4987V9.16667L6.66536 5L0.832031 9.16667ZM10.832 15.8333H9.16536V11.6667H4.16536V15.8333H2.4987V10L6.66536 7.08333L10.832 10V15.8333Z"
            fill="#788CA5"
          />
          <path
            d="M8.33203 2.5V4.14167L9.9987 5.33333V4.16667H17.4987V15.8333H14.1654V17.5H19.1654V2.5H8.33203Z"
            fill="#788CA5"
          />
        </g>
        <defs>
          <clipPath id="clip0_22371_65941">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const DetailsAssetIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_22654_14906)">
          <path
            d="M2.4987 3.33325C2.4987 2.87492 2.8737 2.49992 3.33203 2.49992H4.9987V0.833252H3.33203C1.9487 0.833252 0.832031 1.94992 0.832031 3.33325V4.99992H2.4987V3.33325Z"
            fill="#788CA5"
          />
          <path
            d="M2.4987 16.6666V14.9999H0.832031V16.6666C0.832031 18.0499 1.9487 19.1666 3.33203 19.1666H4.9987V17.4999H3.33203C2.8737 17.4999 2.4987 17.1249 2.4987 16.6666Z"
            fill="#788CA5"
          />
          <path
            d="M16.6654 0.833252H14.9987V2.49992H16.6654C17.1237 2.49992 17.4987 2.87492 17.4987 3.33325V4.99992H19.1654V3.33325C19.1654 1.94992 18.0487 0.833252 16.6654 0.833252Z"
            fill="#788CA5"
          />
          <path
            d="M17.4987 16.6666C17.4987 17.1249 17.1237 17.4999 16.6654 17.4999H14.9987V19.1666H16.6654C18.0487 19.1666 19.1654 18.0499 19.1654 16.6666V14.9999H17.4987V16.6666Z"
            fill="#788CA5"
          />
          <path
            d="M15.832 12.3916V7.60825C15.832 7.00825 15.5154 6.45825 14.9987 6.16658L10.832 3.76658C10.5737 3.61659 10.2904 3.54158 9.9987 3.54158C9.70703 3.54158 9.4237 3.61659 9.16536 3.76658L4.9987 6.15825C4.48203 6.45825 4.16536 7.00825 4.16536 7.60825V12.3916C4.16536 12.9916 4.48203 13.5416 4.9987 13.8333L9.16536 16.2332C9.4237 16.3833 9.70703 16.4583 9.9987 16.4583C10.2904 16.4583 10.5737 16.3833 10.832 16.2332L14.9987 13.8333C15.5154 13.5416 15.832 12.9916 15.832 12.3916ZM9.16536 14.3083L5.83203 12.3916V8.53325L9.16536 10.4749V14.3083ZM9.9987 9.03325L6.6987 7.10825L9.9987 5.20825L13.2987 7.10825L9.9987 9.03325ZM14.1654 12.3916L10.832 14.3083V10.4749L14.1654 8.53325V12.3916Z"
            fill="#788CA5"
          />
        </g>
        <defs>
          <clipPath id="clip0_22654_14906">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const QRcodeBlueIcon = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0625 8.9375V13.0625H8.9375V8.9375H13.0625ZM15.125 6.875H6.875V15.125H15.125V6.875ZM13.0625 19.9375V24.0625H8.9375V19.9375H13.0625ZM15.125 17.875H6.875V26.125H15.125V17.875ZM24.0625 8.9375V13.0625H19.9375V8.9375H24.0625ZM26.125 6.875H17.875V15.125H26.125V6.875ZM17.875 17.875H19.9375V19.9375H17.875V17.875ZM19.9375 19.9375H22V22H19.9375V19.9375ZM22 17.875H24.0625V19.9375H22V17.875ZM17.875 22H19.9375V24.0625H17.875V22ZM19.9375 24.0625H22V26.125H19.9375V24.0625ZM22 22H24.0625V24.0625H22V22ZM24.0625 19.9375H26.125V22H24.0625V19.9375ZM24.0625 24.0625H26.125V26.125H24.0625V24.0625ZM30.25 9.625H27.5V5.5H23.375V2.75H30.25V9.625ZM30.25 30.25V23.375H27.5V27.5H23.375V30.25H30.25ZM2.75 30.25H9.625V27.5H5.5V23.375H2.75V30.25ZM2.75 2.75V9.625H5.5V5.5H9.625V2.75H2.75Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const PrimaryIcon = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.9987 4.99992C10.9154 4.99992 11.6654 5.74992 11.6654 6.66659C11.6654 7.58325 10.9154 8.33325 9.9987 8.33325C9.08203 8.33325 8.33203 7.58325 8.33203 6.66659C8.33203 5.74992 9.08203 4.99992 9.9987 4.99992ZM9.9987 12.4999C12.2487 12.4999 14.832 13.5749 14.9987 14.1666V14.9999H4.9987V14.1749C5.16536 13.5749 7.7487 12.4999 9.9987 12.4999ZM9.9987 3.33325C8.15703 3.33325 6.66536 4.82492 6.66536 6.66659C6.66536 8.50825 8.15703 9.99992 9.9987 9.99992C11.8404 9.99992 13.332 8.50825 13.332 6.66659C13.332 4.82492 11.8404 3.33325 9.9987 3.33325ZM9.9987 10.8333C7.7737 10.8333 3.33203 11.9499 3.33203 14.1666V16.6666H16.6654V14.1666C16.6654 11.9499 12.2237 10.8333 9.9987 10.8333Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const SecondaryIcon = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.9987 11.2499C11.8396 11.2499 13.332 9.75753 13.332 7.91658C13.332 6.07564 11.8396 4.58325 9.9987 4.58325C8.15775 4.58325 6.66536 6.07564 6.66536 7.91658C6.66536 9.75753 8.15775 11.2499 9.9987 11.2499Z"
          fill="#788CA5"
        />
        <path
          d="M9.9987 12.9166C7.7737 12.9166 3.33203 14.0333 3.33203 16.2499V17.9166H16.6654V16.2499C16.6654 14.0333 12.2237 12.9166 9.9987 12.9166Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const ImgPhotos = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.8039 6.83758V25.9829H7.84312V6.83758H29.8039ZM29.8039 4.10254H7.84312C6.11763 4.10254 4.70587 5.33331 4.70587 6.83758V25.9829C4.70587 27.4872 6.11763 28.7179 7.84312 28.7179H29.8039C31.5293 28.7179 32.9411 27.4872 32.9411 25.9829V6.83758C32.9411 5.33331 31.5293 4.10254 29.8039 4.10254ZM22.1803 16.2188L17.4745 21.5111L14.1176 17.9692L9.41174 23.2478H28.2352L22.1803 16.2188Z"
          fill="#788CA5"
        />
        <path
          d="M29.4118 23.0771C24.5412 23.0771 20.5883 26.5233 20.5883 30.7695C20.5883 35.0156 24.5412 38.4618 29.4118 38.4618C34.2824 38.4618 38.2353 35.0156 38.2353 30.7695C38.2353 26.5233 34.2824 23.0771 29.4118 23.0771ZM33.8236 31.5387H30.2941V34.6156H28.5294V31.5387H25V30.0002H28.5294V26.9233H30.2941V30.0002H33.8236V31.5387Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const CreateIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        height="24"
        width="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0z" fill="none"></path>
        <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" fill="currentColor"></path>
      </svg>
    </>
  );
};
export const TeamsIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5013 11.4584C5.5513 11.4584 1.66797 12.4334 1.66797 14.3751V15.8334H13.3346V14.3751C13.3346 12.4334 9.4513 11.4584 7.5013 11.4584ZM3.61797 14.1667C4.31797 13.6834 6.00964 13.1251 7.5013 13.1251C8.99297 13.1251 10.6846 13.6834 11.3846 14.1667H3.61797ZM7.5013 10.0001C9.10964 10.0001 10.418 8.69175 10.418 7.08341C10.418 5.47508 9.10964 4.16675 7.5013 4.16675C5.89297 4.16675 4.58464 5.47508 4.58464 7.08341C4.58464 8.69175 5.89297 10.0001 7.5013 10.0001ZM7.5013 5.83341C8.19297 5.83341 8.7513 6.39175 8.7513 7.08341C8.7513 7.77508 8.19297 8.33341 7.5013 8.33341C6.80964 8.33341 6.2513 7.77508 6.2513 7.08341C6.2513 6.39175 6.80964 5.83341 7.5013 5.83341ZM13.368 11.5084C14.3346 12.2084 15.0013 13.1417 15.0013 14.3751V15.8334H18.3346V14.3751C18.3346 12.6917 15.418 11.7334 13.368 11.5084ZM12.5013 10.0001C14.1096 10.0001 15.418 8.69175 15.418 7.08341C15.418 5.47508 14.1096 4.16675 12.5013 4.16675C12.0513 4.16675 11.6346 4.27508 11.2513 4.45841C11.7763 5.20008 12.0846 6.10841 12.0846 7.08341C12.0846 8.05841 11.7763 8.96675 11.2513 9.70841C11.6346 9.89175 12.0513 10.0001 12.5013 10.0001Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const LocationDropDownIconBlue = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="#0c66e4"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="#0c66e4"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
      </svg>
    </>
  );
};
export const OrderTypeIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99297 1.66675C5.39297 1.66675 1.66797 5.40008 1.66797 10.0001C1.66797 14.6001 5.39297 18.3334 9.99297 18.3334C14.6013 18.3334 18.3346 14.6001 18.3346 10.0001C18.3346 5.40008 14.6013 1.66675 9.99297 1.66675ZM10.0013 16.6667C6.31797 16.6667 3.33464 13.6834 3.33464 10.0001C3.33464 6.31675 6.31797 3.33341 10.0013 3.33341C13.6846 3.33341 16.668 6.31675 16.668 10.0001C16.668 13.6834 13.6846 16.6667 10.0013 16.6667Z"
          fill="#788CA5"
        />
        <path
          d="M10.418 5.83342H9.16797V10.8334L13.543 13.4584L14.168 12.4334L10.418 10.2084V5.83342Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const DateDetailsIcon = ({
  height = "20",
  width = "20",
  color = "#788CA5",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 3.33341H15V1.66675H13.3333V3.33341H6.66667V1.66675H5V3.33341H4.16667C3.24167 3.33341 2.50833 4.08341 2.50833 5.00008L2.5 16.6667C2.5 17.5834 3.24167 18.3334 4.16667 18.3334H15.8333C16.75 18.3334 17.5 17.5834 17.5 16.6667V5.00008C17.5 4.08341 16.75 3.33341 15.8333 3.33341ZM15.8333 16.6667H4.16667V8.33342H15.8333V16.6667ZM15.8333 6.66675H4.16667V5.00008H15.8333V6.66675ZM7.5 11.6667H5.83333V10.0001H7.5V11.6667ZM10.8333 11.6667H9.16667V10.0001H10.8333V11.6667ZM14.1667 11.6667H12.5V10.0001H14.1667V11.6667ZM7.5 15.0001H5.83333V13.3334H7.5V15.0001ZM10.8333 15.0001H9.16667V13.3334H10.8333V15.0001ZM14.1667 15.0001H12.5V13.3334H14.1667V15.0001Z"
          fill={color}
        />
      </svg>
    </>
  );
};
export const CloseIconWO = ({ color = "#788CA5" }) => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.5C3.8525 0.5 0.5 3.8525 0.5 8C0.5 12.1475 3.8525 15.5 8 15.5C12.1475 15.5 15.5 12.1475 15.5 8C15.5 3.8525 12.1475 0.5 8 0.5ZM11.75 10.6925L10.6925 11.75L8 9.0575L5.3075 11.75L4.25 10.6925L6.9425 8L4.25 5.3075L5.3075 4.25L8 6.9425L10.6925 4.25L11.75 5.3075L9.0575 8L11.75 10.6925Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const LocationDropDownIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="#44546F"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 1.66663C6.77484 1.66663 4.1665 4.27496 4.1665 7.49996C4.1665 11.875 9.99984 18.3333 9.99984 18.3333C9.99984 18.3333 15.8332 11.875 15.8332 7.49996C15.8332 4.27496 13.2248 1.66663 9.99984 1.66663ZM5.83317 7.49996C5.83317 5.19996 7.69984 3.33329 9.99984 3.33329C12.2998 3.33329 14.1665 5.19996 14.1665 7.49996C14.1665 9.89996 11.7665 13.4916 9.99984 15.7333C8.2665 13.5083 5.83317 9.87496 5.83317 7.49996Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="#44546F"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 9.58329C11.1504 9.58329 12.0832 8.65055 12.0832 7.49996C12.0832 6.34937 11.1504 5.41663 9.99984 5.41663C8.84924 5.41663 7.9165 6.34937 7.9165 7.49996C7.9165 8.65055 8.84924 9.58329 9.99984 9.58329Z"
          fill="black"
          fill-opacity="0.2"
        />
      </svg>
    </>
  );
};
export const ResizeHandleIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="6" height="2" fill="#555" />
        <rect x="2" y="6" width="6" height="2" fill="#555" />
        <rect x="2" y="10" width="6" height="2" fill="#555" />
        <rect x="2" y="14" width="6" height="2" fill="#555" />
      </svg>
    </>
  );
};
export const SubLocationDropDownIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="#44546F"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="#44546F"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="black"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="black"
          fill-opacity="0.2"
        />
      </svg>
    </>
  );
};
export const SubLocationDropDownBlueIcon = ({
  width = "20",
  height = "18",
}) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="#0c66e4"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 3.33329C11.6082 3.33329 14.1665 4.49996 14.1665 7.62496C14.1665 9.42496 12.7332 11.5166 9.99984 13.725C7.2665 11.5166 5.83317 9.41663 5.83317 7.62496C5.83317 4.49996 8.3915 3.33329 9.99984 3.33329ZM9.99984 1.66663C7.27484 1.66663 4.1665 3.71663 4.1665 7.62496C4.1665 10.225 6.10817 12.9666 9.99984 15.8333C13.8915 12.9666 15.8332 10.225 15.8332 7.62496C15.8332 3.71663 12.7248 1.66663 9.99984 1.66663Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="#0c66e4"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
        <path
          d="M9.99984 5.83329C9.08317 5.83329 8.33317 6.58329 8.33317 7.49996C8.33317 8.41663 9.08317 9.16663 9.99984 9.16663C10.4419 9.16663 10.8658 8.99103 11.1783 8.67847C11.4909 8.36591 11.6665 7.94199 11.6665 7.49996C11.6665 7.05793 11.4909 6.63401 11.1783 6.32145C10.8658 6.00889 10.4419 5.83329 9.99984 5.83329ZM4.1665 16.6666H15.8332V18.3333H4.1665V16.6666Z"
          fill="#0c66e4"
          fill-opacity="0.2"
        />
      </svg>
    </>
  );
};
export const AdminGreyIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
        <path
          d="M11.085 24.5V23.85C11.085 23.51 11.245 23.19 11.495 23.04C13.185 22.03 15.115 21.5 17.085 21.5C17.115 21.5 17.135 21.5 17.165 21.51C17.265 20.81 17.465 20.14 17.755 19.53C17.535 19.51 17.315 19.5 17.085 19.5C14.665 19.5 12.405 20.17 10.475 21.32C9.59502 21.84 9.08502 22.82 9.08502 23.85V26.5H18.345C17.925 25.9 17.595 25.22 17.375 24.5H11.085Z"
          fill="#44546F"
        />
        <path
          d="M17.085 18.5C19.295 18.5 21.085 16.71 21.085 14.5C21.085 12.29 19.295 10.5 17.085 10.5C14.875 10.5 13.085 12.29 13.085 14.5C13.085 16.71 14.875 18.5 17.085 18.5ZM17.085 12.5C18.185 12.5 19.085 13.4 19.085 14.5C19.085 15.6 18.185 16.5 17.085 16.5C15.985 16.5 15.085 15.6 15.085 14.5C15.085 13.4 15.985 12.5 17.085 12.5Z"
          fill="#44546F"
        />
        <path
          d="M27.835 22.5C27.835 22.28 27.805 22.08 27.775 21.87L28.915 20.86L27.915 19.13L26.465 19.62C26.145 19.35 25.785 19.14 25.385 18.99L25.085 17.5H23.085L22.785 18.99C22.385 19.14 22.025 19.35 21.705 19.62L20.255 19.13L19.255 20.86L20.395 21.87C20.365 22.08 20.335 22.28 20.335 22.5C20.335 22.72 20.365 22.92 20.395 23.13L19.255 24.14L20.255 25.87L21.705 25.38C22.025 25.65 22.385 25.86 22.785 26.01L23.085 27.5H25.085L25.385 26.01C25.785 25.86 26.145 25.65 26.465 25.38L27.915 25.87L28.915 24.14L27.775 23.13C27.805 22.92 27.835 22.72 27.835 22.5ZM24.085 24.5C22.985 24.5 22.085 23.6 22.085 22.5C22.085 21.4 22.985 20.5 24.085 20.5C25.185 20.5 26.085 21.4 26.085 22.5C26.085 23.6 25.185 24.5 24.085 24.5Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};
export const DownArrow = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.23268 8.29492L13.3327 12.8749L18.4327 8.29492L19.9993 9.70492L13.3327 15.7049L6.66602 9.70492L8.23268 8.29492Z"
        fill={color}
      />
    </svg>
  );
};
export const FullArrow = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 9.16667V2.5H10.8333L13.575 5.24167L5.24167 13.575L2.5 10.8333V17.5H9.16667L6.425 14.7583L14.7583 6.425L17.5 9.16667Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const PhotoSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#F5F5F5" />
      <rect
        x="-15.5"
        y="-7.5"
        width="441"
        height="39"
        rx="7.5"
        fill="#F5F6F8"
      />
      <rect
        x="-15.5"
        y="-7.5"
        width="441"
        height="39"
        rx="7.5"
        stroke="#E4E6EA"
      />
      <path
        d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const RefreshSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.2849C6 11.6349 6.67 10.1349 7.76 9.04491L6.34 7.62491C4.9 9.07491 4 11.0749 4 13.2849C4 17.3649 7.05 20.7249 11 21.2149V19.1949C8.17 18.7149 6 16.2549 6 13.2849ZM20 13.2849C20 8.86491 16.42 5.28491 12 5.28491C11.94 5.28491 11.88 5.29491 11.82 5.29491L12.91 4.20491L11.5 2.78491L8 6.28491L11.5 9.78491L12.91 8.37491L11.83 7.29491C11.89 7.29491 11.95 7.28491 12 7.28491C15.31 7.28491 18 9.97491 18 13.2849C18 16.2549 15.83 18.7149 13 19.1949V21.2149C16.95 20.7249 20 17.3649 20 13.2849Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const DetailArrowSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29492 19.1003L12.8749 14.0003L8.29492 8.90032L9.70492 7.33366L15.7049 14.0003L9.70492 20.667L8.29492 19.1003Z"
        fill="white"
        transform="rotate(-90 12 14)"
      ></path>
    </svg>
  );
};
export const HashSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="2" fill="#E9F2FF" />
      <path
        d="M22.5 12L23 10H19L20 6H18L17 10H13L14 6H12L11 10H7L6.5 12H10.5L9.5 16H5.5L5 18H9L8 22H10L11 18H15L14 22H16L17 18H21L21.5 16H17.5L18.5 12H22.5ZM15.5 16H11.5L12.5 12H16.5L15.5 16Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const ArrowDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.825 6.9126L10 10.7293L6.175 6.9126L5 8.0876L10 13.0876L15 8.0876L13.825 6.9126Z"
        fill="white"
      />
    </svg>
  );
};
export const TextSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7619 0.626889C11.2675 0.142222 10.9171 0 10.2183 0H1.35639C0.382618 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382618 20 1.35639 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7619 0.626889ZM15.8138 18.4824C15.8138 18.7371 15.7118 18.8369 15.4521 18.8369H1.54815C1.28839 18.8369 1.18639 18.7369 1.18639 18.4824V14.1807H15.8136L15.8138 18.4824ZM3.34655 9.92622V9.16667H6.4823V9.92622H5.36822V13.1667H4.44227V9.92622H3.34655ZM6.82049 9.16667H7.87949L8.23672 9.89667C8.35777 10.14 8.44866 10.3358 8.54545 10.5613H8.55769C8.65448 10.306 8.7329 10.128 8.83604 9.89667L9.18103 9.16667H10.2341L9.08401 11.1193L10.2949 13.1667H9.22954L8.86029 12.4427C8.7091 12.1638 8.61209 11.9562 8.49694 11.7247H8.48493C8.39993 11.9562 8.29724 12.1638 8.17008 12.4427L7.83098 13.1667H6.77788L7.95815 11.1429L6.82049 9.16667ZM10.5179 9.92622V9.16667H13.6537V9.92622H12.5398V13.1667H11.6139V9.92622H10.5179ZM15.8138 8.15267H1.18639V1.51756C1.18639 1.26289 1.28816 1.16311 1.54815 1.16311H10.58C10.7097 1.16311 10.7609 1.21311 10.7609 1.34022V4.78711C10.7609 5.74178 11.1435 6.11689 12.1171 6.11689H15.633C15.7628 6.11689 15.8138 6.16711 15.8138 6.29422V8.15267Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const DuedateIcon = ({
  height = "24",
  width = "24",
  color = "#f64e60",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33594 9.99992H8.66927V11.3333H7.33594V9.99992ZM7.33594 4.66659H8.66927V8.66659H7.33594V4.66659ZM7.99594 1.33325C4.31594 1.33325 1.33594 4.31992 1.33594 7.99992C1.33594 11.6799 4.31594 14.6666 7.99594 14.6666C11.6826 14.6666 14.6693 11.6799 14.6693 7.99992C14.6693 4.31992 11.6826 1.33325 7.99594 1.33325ZM8.0026 13.3333C5.05594 13.3333 2.66927 10.9466 2.66927 7.99992C2.66927 5.05325 5.05594 2.66659 8.0026 2.66659C10.9493 2.66659 13.3359 5.05325 13.3359 7.99992C13.3359 10.9466 10.9493 13.3333 8.0026 13.3333Z"
        fill={color}
      />
    </svg>
  );
};
export const PlusIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke="currentColor"
      height="24"
      fill="none"
      class="svg"
    >
      <line y2="19" y1="5" x2="12" x1="12"></line>
      <line y2="12" y1="12" x2="19" x1="5"></line>
    </svg>
  );
};
export const SchedualWOIcon = ({ width = "24", height = "24" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const DottedClock = ({ width = "24", height = "24" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3266 14.5276L12.0766 15.8326C11.3566 16.1626 10.5691 16.3801 9.75156 16.4626V14.9476C10.3066 14.8801 10.8316 14.7376 11.3266 14.5276ZM3.05406 9.7501H1.53906C1.62156 10.5751 1.83906 11.3551 2.16906 12.0751L3.47406 11.3251C3.26406 10.8301 3.12156 10.3051 3.05406 9.7501ZM11.3266 3.4726L12.0766 2.1676C11.3566 1.8376 10.5766 1.6201 9.75156 1.5376V3.0526C10.3066 3.1201 10.8316 3.2626 11.3266 3.4726ZM14.9491 8.2501H16.4641C16.3816 7.4251 16.1641 6.6451 15.8341 5.9251L14.5291 6.6751C14.7391 7.1701 14.8816 7.6951 14.9491 8.2501ZM6.67656 14.5276L5.92656 15.8326C6.64656 16.1626 7.43406 16.3801 8.25156 16.4626V14.9476C7.69656 14.8801 7.17156 14.7376 6.67656 14.5276ZM8.25156 3.0526V1.5376C7.42656 1.6201 6.64656 1.8376 5.92656 2.1676L6.67656 3.4726C7.17156 3.2626 7.69656 3.1201 8.25156 3.0526ZM13.7716 5.3776L15.0766 4.6201C14.6041 3.9676 14.0266 3.3901 13.3741 2.9176L12.6166 4.2226C13.0591 4.5601 13.4416 4.9426 13.7716 5.3776ZM3.47406 6.6751L2.16906 5.9251C1.83906 6.6451 1.62156 7.4251 1.53906 8.2501H3.05406C3.12156 7.6951 3.26406 7.1701 3.47406 6.6751ZM14.9491 9.7501C14.8816 10.3051 14.7391 10.8301 14.5291 11.3251L15.8341 12.0751C16.1641 11.3551 16.3816 10.5676 16.4641 9.7501H14.9491ZM12.6241 13.7701L13.3816 15.0751C14.0341 14.6026 14.6116 14.0251 15.0841 13.3726L13.7791 12.6151C13.4416 13.0576 13.0591 13.4401 12.6241 13.7701ZM5.37906 4.2301L4.62906 2.9176C3.96906 3.3976 3.39906 3.9676 2.92656 4.6276L4.23156 5.3851C4.56156 4.9426 4.94406 4.5601 5.37906 4.2301ZM4.23156 12.6226L2.92656 13.3726C3.39906 14.0251 3.97656 14.6026 4.62906 15.0751L5.38656 13.7701C4.94406 13.4401 4.56156 13.0576 4.23156 12.6226ZM9.75156 5.2501H8.25156V9.3076L11.4691 12.5251L12.5266 11.4676L9.75156 8.6926V5.2501Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const PlusClock = ({ width = "24", height = "24" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 6V10.5L10.65 12.675L11.25 11.775L8.25 9.975V6H7.125Z"
        fill="#0C66E4"
      />
      <path
        d="M13.065 9C13.1025 9.2475 13.125 9.495 13.125 9.75C13.125 12.675 10.8 15 7.875 15C4.95 15 2.625 12.675 2.625 9.75C2.625 6.825 4.95 4.5 7.875 4.5C8.4 4.5 8.9025 4.575 9.375 4.7175V3.1725C8.895 3.06 8.3925 3 7.875 3C4.125 3 1.125 6 1.125 9.75C1.125 13.5 4.125 16.5 7.875 16.5C11.625 16.5 14.625 13.5 14.625 9.75C14.625 9.495 14.61 9.2475 14.58 9H13.065Z"
        fill="#0C66E4"
      />
      <path
        d="M14.625 3.75V1.5H13.125V3.75H10.875V5.25H13.125V7.5H14.625V5.25H16.875V3.75H14.625Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const ExeSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6174 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8549 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7114 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM6.15491 10.7393V11.4753H4.65392V12.4247H6.33035V13.1664H3.72776V9.16644H6.2458V9.90822H4.65392V10.7391L6.15491 10.7393ZM6.69936 9.16667H7.75857L8.1158 9.89667C8.23684 10.14 8.32773 10.3358 8.42429 10.5613H8.43653C8.53355 10.306 8.61197 10.128 8.71488 9.89667L9.06009 9.16667H10.1132L8.96308 11.1193L10.1737 13.1667H9.10837L8.73913 12.4427C8.58772 12.1638 8.49093 11.9562 8.37579 11.7247H8.36355C8.27877 11.9562 8.17587 12.1638 8.04848 12.4427L7.70961 13.1667H6.65629L7.83677 11.1429L6.69936 9.16667ZM13.0968 10.7393V11.4753H11.5954V12.4247H13.272V13.1664H10.6694V9.16644H13.1875V9.90822H11.5954V10.7391L13.0968 10.7393ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const CSVSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6174 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8549 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7114 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM5.63017 12.4413C5.89991 12.4413 6.19933 12.3838 6.37568 12.3149L6.51055 12.9998C6.34644 13.0802 5.97629 13.1667 5.49508 13.1667C4.1276 13.1667 3.42267 12.3322 3.42267 11.2269C3.42267 9.90311 4.38577 9.16667 5.58325 9.16667C6.04701 9.16667 6.39925 9.25889 6.55769 9.33933L6.37568 10.0358C6.19367 9.96111 5.94116 9.892 5.62428 9.892C4.91391 9.892 4.36197 10.3122 4.36197 11.1756C4.36197 11.9522 4.83163 12.4413 5.63017 12.4413ZM8.08316 11.4802C7.42583 11.2558 6.9972 10.8989 6.9972 10.3349C6.9972 9.67311 7.56069 9.16667 8.49411 9.16667C8.94041 9.16667 9.26885 9.25889 9.50391 9.36244L9.30467 10.0702C9.146 9.99556 8.86425 9.886 8.47688 9.886C8.08951 9.886 7.9016 10.0587 7.9016 10.2602C7.9016 10.5076 8.12464 10.6169 8.63532 10.8069C9.33413 11.06 9.66257 11.4171 9.66257 11.9638C9.66257 12.6142 9.15212 13.1667 8.06593 13.1667C7.61396 13.1667 7.16743 13.0516 6.94461 12.9307L7.12663 12.2056C7.36712 12.3264 7.73681 12.4473 8.11852 12.4473C8.52947 12.4473 8.74661 12.2804 8.74661 12.0271C8.74639 11.7853 8.55871 11.6473 8.08316 11.4802ZM9.93185 9.23H10.9122L11.3936 10.8702C11.5285 11.3307 11.652 11.7738 11.7461 12.2573H11.7635C11.8633 11.7911 11.9864 11.3307 12.1217 10.8876L12.6265 9.23H13.5773L12.2445 13.1091H11.1996L9.93185 9.23ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const DocSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7116 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM2.88501 13.0862V9.28178C3.21323 9.23 3.64117 9.20133 4.09247 9.20133C4.84296 9.20133 5.32961 9.33356 5.71064 9.61511C6.12113 9.914 6.37885 10.3909 6.37885 11.0749C6.37885 11.8162 6.10323 12.3278 5.7222 12.6438C5.30581 12.9829 4.67296 13.1438 3.89935 13.1438C3.43581 13.1436 3.1076 13.1151 2.88501 13.0862ZM6.78232 11.1956C6.78232 10.0347 7.53871 9.16667 8.70491 9.16667C9.91848 9.16667 10.5806 10.0576 10.5806 11.1264C10.5806 12.3967 9.79517 13.1667 8.64031 13.1667C7.46799 13.1667 6.78232 12.2989 6.78232 11.1956ZM13.1888 12.4367C13.4583 12.4367 13.7575 12.3793 13.9337 12.3102L14.0683 12.9942C13.904 13.0747 13.5347 13.1609 13.054 13.1609C11.6881 13.1609 10.9845 12.3276 10.9845 11.224C10.9845 9.90222 11.946 9.16644 13.1424 9.16644C13.605 9.16644 13.957 9.25844 14.1152 9.33889L13.9337 10.0344C13.7514 9.95978 13.4996 9.89067 13.1832 9.89067C12.4735 9.89067 11.9224 10.3102 11.9224 11.1722C11.9227 11.9484 12.3919 12.4367 13.1888 12.4367ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#788CA5"
      />
      <path
        d="M9.63736 11.1554C9.63736 10.4601 9.29736 9.8623 8.68174 9.8623C8.0779 9.8623 7.72656 10.4256 7.72656 11.1783C7.72656 11.937 8.08991 12.4714 8.68786 12.4714C9.29124 12.4714 9.63736 11.9081 9.63736 11.1554Z"
        fill="#788CA5"
      />
      <path
        d="M4.18562 9.87354C3.98638 9.87354 3.85741 9.89087 3.78125 9.90798V12.4424C3.85741 12.4598 3.98072 12.4598 4.09201 12.4598C4.90076 12.4655 5.42844 12.0289 5.42844 11.1033C5.43456 10.2989 4.9538 9.87354 4.18562 9.87354Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const ZipSvg = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7619 0.626889C11.2675 0.142222 10.9171 0 10.2183 0H1.35639C0.382618 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382618 20 1.35639 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7619 0.626889ZM15.8138 18.4824C15.8138 18.7371 15.7118 18.8369 15.4521 18.8369H1.54815C1.28839 18.8369 1.18639 18.7369 1.18639 18.4824V14.1807H15.8136L15.8138 18.4824ZM4.50778 9.93844V9.19622H7.44587V9.71467L5.55975 12.4009V12.4244H7.47625V13.1667H4.32758V12.6836L6.25608 9.962V9.93844H4.50778ZM8.05221 13.1667V9.19622H8.97159V13.1667H8.05221ZM9.76448 13.1667V9.24911C10.0471 9.202 10.4434 9.16667 11.0023 9.16667C11.5672 9.16667 11.97 9.27267 12.2402 9.48489C12.4986 9.68511 12.6726 10.0149 12.6726 10.4038C12.6726 10.7927 12.5405 11.1224 12.3 11.3464C11.9877 11.6351 11.5248 11.7647 10.984 11.7647C10.8638 11.7647 10.7557 11.7589 10.6714 11.7471V13.1669L9.76448 13.1667ZM15.8138 8.15267H1.18639V1.51756C1.18639 1.26289 1.28816 1.16311 1.54815 1.16311H10.58C10.7097 1.16311 10.7609 1.21311 10.7609 1.34022V4.78711C10.7609 5.74178 11.1435 6.11689 12.1171 6.11689H15.633C15.7628 6.11689 15.8138 6.16711 15.8138 6.29422V8.15267Z"
        fill="#788CA5"
      />
      <path
        d="M11.7656 10.4273C11.7656 10.062 11.5072 9.84399 11.0509 9.84399C10.8643 9.84399 10.7383 9.86177 10.6719 9.87955V11.0518C10.7503 11.0695 10.8464 11.0753 10.9788 11.0753C11.4652 11.0753 11.7656 10.8338 11.7656 10.4273Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const ProcedureDetailsIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.668 2.5H3.33464C2.41797 2.5 1.66797 3.25 1.66797 4.16667V15.8333C1.66797 16.75 2.41797 17.5 3.33464 17.5H16.668C17.5846 17.5 18.3346 16.75 18.3346 15.8333V4.16667C18.3346 3.25 17.5846 2.5 16.668 2.5ZM16.668 15.8333H3.33464V4.16667H16.668V15.8333Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1763 8.68333L14.993 7.5L12.3513 10.1417L11.1763 8.95833L10.0013 10.1333L12.3513 12.5L16.1763 8.68333Z"
        fill={color}
      />
      <path d="M8.33464 5.83333H4.16797V7.5H8.33464V5.83333Z" fill={color} />
      <path
        d="M8.33464 9.16667H4.16797V10.8333H8.33464V9.16667Z"
        fill={color}
      />
      <path d="M8.33464 12.5H4.16797V14.1667H8.33464V12.5Z" fill={color} />
    </svg>
  );
};
export const PartsDetailsIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.54167 4.99996H5.20833V7.49996H13.5417V4.99996H15.2083V9.16663H16.875V4.99996C16.875 4.08329 16.125 3.33329 15.2083 3.33329H11.725C11.375 2.36663 10.4583 1.66663 9.375 1.66663C8.29167 1.66663 7.375 2.36663 7.025 3.33329H3.54167C2.625 3.33329 1.875 4.08329 1.875 4.99996V16.6666C1.875 17.5833 2.625 18.3333 3.54167 18.3333H8.54167V16.6666H3.54167V4.99996ZM9.375 3.33329C9.83333 3.33329 10.2083 3.70829 10.2083 4.16663C10.2083 4.62496 9.83333 4.99996 9.375 4.99996C8.91667 4.99996 8.54167 4.62496 8.54167 4.16663C8.54167 3.70829 8.91667 3.33329 9.375 3.33329Z"
        fill="#788CA5"
      />
      <path
        d="M16.875 10.4166L12.3 15L9.79167 12.5L8.54167 13.75L12.3 17.5L18.125 11.6666L16.875 10.4166Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const LaborIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.40495 14.5833V14.0416C3.40495 13.7583 3.53828 13.4916 3.74661 13.3666C5.15495 12.525 6.76328 12.0833 8.40495 12.0833C8.42995 12.0833 8.44662 12.0833 8.47162 12.0916C8.55495 11.5083 8.72162 10.95 8.96328 10.4416C8.77995 10.425 8.59662 10.4166 8.40495 10.4166C6.38828 10.4166 4.50495 10.975 2.89661 11.9333C2.16328 12.3666 1.73828 13.1833 1.73828 14.0416V16.25H9.45495C9.10495 15.75 8.82995 15.1833 8.64662 14.5833H3.40495Z"
        fill={color}
      />
      <path
        d="M8.40495 9.58329C10.2466 9.58329 11.7383 8.09163 11.7383 6.24996C11.7383 4.40829 10.2466 2.91663 8.40495 2.91663C6.56328 2.91663 5.07161 4.40829 5.07161 6.24996C5.07161 8.09163 6.56328 9.58329 8.40495 9.58329ZM8.40495 4.58329C9.32162 4.58329 10.0716 5.33329 10.0716 6.24996C10.0716 7.16663 9.32162 7.91663 8.40495 7.91663C7.48828 7.91663 6.73828 7.16663 6.73828 6.24996C6.73828 5.33329 7.48828 4.58329 8.40495 4.58329Z"
        fill={color}
      />
      <path
        d="M17.3633 12.9166C17.3633 12.7333 17.3383 12.5666 17.3133 12.3916L18.2633 11.55L17.4299 10.1083L16.2216 10.5166C15.9549 10.2916 15.6549 10.1166 15.3216 9.99163L15.0716 8.74996H13.4049L13.1549 9.99163C12.8216 10.1166 12.5216 10.2916 12.2549 10.5166L11.0466 10.1083L10.2133 11.55L11.1633 12.3916C11.1383 12.5666 11.1133 12.7333 11.1133 12.9166C11.1133 13.1 11.1383 13.2666 11.1633 13.4416L10.2133 14.2833L11.0466 15.725L12.2549 15.3166C12.5216 15.5416 12.8216 15.7166 13.1549 15.8416L13.4049 17.0833H15.0716L15.3216 15.8416C15.6549 15.7166 15.9549 15.5416 16.2216 15.3166L17.4299 15.725L18.2633 14.2833L17.3133 13.4416C17.3383 13.2666 17.3633 13.1 17.3633 12.9166ZM14.2383 14.5833C13.3216 14.5833 12.5716 13.8333 12.5716 12.9166C12.5716 12 13.3216 11.25 14.2383 11.25C15.1549 11.25 15.9049 12 15.9049 12.9166C15.9049 13.8333 15.1549 14.5833 14.2383 14.5833Z"
        fill={color}
      />
    </svg>
  );
};
export const CostIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3.05L13 2L12 3.05L11 2L10 3.05L9 2L8 3.05L7 2L6 3.05L5 2V11.8H3V13.9C3 15.062 3.89333 16 5 16H13C14.1067 16 15 15.062 15 13.9V2L14 3.05ZM11 14.6H5C4.63333 14.6 4.33333 14.285 4.33333 13.9V13.2H11V14.6ZM13.6667 13.9C13.6667 14.285 13.3667 14.6 13 14.6C12.6333 14.6 12.3333 14.285 12.3333 13.9V11.8H6.33333V4.1H13.6667V13.9Z"
        fill={color}
      />
    </svg>
  );
};
export const PartDetailIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.54167 4.99996H5.20833V7.49996H13.5417V4.99996H15.2083V9.16663H16.875V4.99996C16.875 4.08329 16.125 3.33329 15.2083 3.33329H11.725C11.375 2.36663 10.4583 1.66663 9.375 1.66663C8.29167 1.66663 7.375 2.36663 7.025 3.33329H3.54167C2.625 3.33329 1.875 4.08329 1.875 4.99996V16.6666C1.875 17.5833 2.625 18.3333 3.54167 18.3333H8.54167V16.6666H3.54167V4.99996ZM9.375 3.33329C9.83333 3.33329 10.2083 3.70829 10.2083 4.16663C10.2083 4.62496 9.83333 4.99996 9.375 4.99996C8.91667 4.99996 8.54167 4.62496 8.54167 4.16663C8.54167 3.70829 8.91667 3.33329 9.375 3.33329Z"
        fill={color}
      />
      <path
        d="M16.875 10.4166L12.3 15L9.79167 12.5L8.54167 13.75L12.3 17.5L18.125 11.6666L16.875 10.4166Z"
        fill={color}
      />
    </svg>
  );
};
export const LogIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4987 2.5083H2.4987C1.58203 2.5083 0.832031 3.2583 0.832031 4.17497V7.49997H2.4987V4.1583H17.4987V15.85H2.4987V12.5H0.832031V15.8416C0.832031 16.7583 1.58203 17.4916 2.4987 17.4916H17.4987C18.4154 17.4916 19.1654 16.7583 19.1654 15.8416V4.17497C19.1654 3.24997 18.4154 2.5083 17.4987 2.5083ZM9.16536 13.3333L12.4987 9.99997L9.16536 6.66663V9.16663H0.832031V10.8333H9.16536V13.3333ZM17.4987 2.5083H2.4987C1.58203 2.5083 0.832031 3.2583 0.832031 4.17497V7.49997H2.4987V4.1583H17.4987V15.85H2.4987V12.5H0.832031V15.8416C0.832031 16.7583 1.58203 17.4916 2.4987 17.4916H17.4987C18.4154 17.4916 19.1654 16.7583 19.1654 15.8416V4.17497C19.1654 3.24997 18.4154 2.5083 17.4987 2.5083ZM9.16536 13.3333L12.4987 9.99997L9.16536 6.66663V9.16663H0.832031V10.8333H9.16536V13.3333Z"
        fill={color}
      />
    </svg>
  );
};
export const PopelChatIcon = () => {
  return (
    <svg
      width="89"
      height="89"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16699 73.8327V63.566C4.16699 61.4882 4.70171 59.5785 5.77116 57.8368C6.8406 56.0952 8.26144 54.766 10.0337 53.8493C13.8225 51.9549 17.6725 50.5341 21.5837 49.5868C25.4948 48.6396 29.467 48.166 33.5003 48.166C37.5337 48.166 41.5059 48.6396 45.417 49.5868C49.3281 50.5341 53.1781 51.9549 56.967 53.8493C58.7392 54.766 60.1601 56.0952 61.2295 57.8368C62.2989 59.5785 62.8337 61.4882 62.8337 63.566V73.8327H4.16699ZM70.167 73.8327V62.8327C70.167 60.1438 69.4184 57.5619 67.9212 55.0868C66.4239 52.6119 64.3003 50.4882 61.5503 48.716C64.667 49.0827 67.6003 49.7091 70.3503 50.5952C73.1003 51.4813 75.667 52.566 78.0503 53.8493C80.2503 55.0716 81.9309 56.4313 83.092 57.9285C84.2531 59.4257 84.8337 61.0605 84.8337 62.8327V73.8327H70.167ZM33.5003 44.4993C29.467 44.4993 26.0142 43.0632 23.142 40.191C20.2698 37.3188 18.8337 33.866 18.8337 29.8327C18.8337 25.7993 20.2698 22.3466 23.142 19.4743C26.0142 16.6021 29.467 15.166 33.5003 15.166C37.5337 15.166 40.9864 16.6021 43.8587 19.4743C46.7309 22.3466 48.167 25.7993 48.167 29.8327C48.167 33.866 46.7309 37.3188 43.8587 40.191C40.9864 43.0632 37.5337 44.4993 33.5003 44.4993ZM70.167 29.8327C70.167 33.866 68.7309 37.3188 65.8587 40.191C62.9864 43.0632 59.5337 44.4993 55.5003 44.4993C54.8281 44.4993 53.9726 44.423 52.9337 44.2702C51.8948 44.1174 51.0392 43.9494 50.367 43.766C52.017 41.8105 53.2851 39.641 54.1712 37.2577C55.0573 34.8743 55.5003 32.3993 55.5003 29.8327C55.5003 27.266 55.0573 24.791 54.1712 22.4077C53.2851 20.0243 52.017 17.8549 50.367 15.8993C51.2226 15.5938 52.0781 15.3952 52.9337 15.3035C53.7892 15.2118 54.6448 15.166 55.5003 15.166C59.5337 15.166 62.9864 16.6021 65.8587 19.4743C68.7309 22.3466 70.167 25.7993 70.167 29.8327ZM11.5003 66.4994H55.5003V63.566C55.5003 62.8938 55.3323 62.2827 54.9962 61.7327C54.6601 61.1827 54.217 60.7549 53.667 60.4493C50.367 58.7994 47.0364 57.5619 43.6753 56.7369C40.3142 55.9118 36.9226 55.4994 33.5003 55.4994C30.0781 55.4994 26.6864 55.9118 23.3253 56.7369C19.9642 57.5619 16.6337 58.7994 13.3337 60.4493C12.7837 60.7549 12.3406 61.1827 12.0045 61.7327C11.6684 62.2827 11.5003 62.8938 11.5003 63.566V66.4994ZM33.5003 37.166C35.517 37.166 37.2434 36.448 38.6795 35.0118C40.1156 33.5757 40.8337 31.8493 40.8337 29.8327C40.8337 27.816 40.1156 26.0896 38.6795 24.6535C37.2434 23.2174 35.517 22.4993 33.5003 22.4993C31.4837 22.4993 29.7573 23.2174 28.3212 24.6535C26.885 26.0896 26.167 27.816 26.167 29.8327C26.167 31.8493 26.885 33.5757 28.3212 35.0118C29.7573 36.448 31.4837 37.166 33.5003 37.166Z"
        fill="#172B4D"
        fill-opacity="0.5"
      />
    </svg>
  );
};

export const ChatEmptyIcon = () => {
  return (
    <svg
      width="89"
      height="89"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.833 63.4573L69.543 59.1673H15.1663V15.1673H73.833V63.4573ZM73.833 7.83398H15.1663C11.133 7.83398 7.83301 11.134 7.83301 15.1673V59.1673C7.83301 63.2006 11.133 66.5006 15.1663 66.5006H66.4997L81.1663 81.1673V15.1673C81.1663 11.134 77.8663 7.83398 73.833 7.83398Z"
        fill="#172B4D"
        fill-opacity="0.5"
      />
    </svg>
  );
};
export const DetailsViewIcon = ({ color = "#44546F" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 9.175L2.5 9.16667V10.8333H17.5V9.175ZM2.5 13.3333H12.5V15H2.5V13.3333ZM17.5 5H2.5V6.675L17.5 6.66667V5Z"
        fill={color}
      />
    </svg>
  );
};

export const BlackClockIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="#172B4D"
      />
      <path
        d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
        fill="#172B4D"
      />
    </svg>
  );
};

export const BlackCostIcon = ({ color = "#788CA5" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM15 20H6C5.45 20 5 19.55 5 19V18H15V20ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const CorrectiveIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14C8 14.55 8.45 15 9 15C9.55 15 10 14.55 10 14C10 13.45 9.55 13 9 13C8.45 13 8 13.45 8 14ZM8 0V4H10V2.08C13.39 2.57 16 5.47 16 9C16 12.87 12.87 16 9 16C5.13 16 2 12.87 2 9C2 7.32 2.59 5.78 3.58 4.58L9 10L10.41 8.59L3.61 1.79V1.81C1.42 3.45 0 6.05 0 9C0 13.97 4.02 18 9 18C13.97 18 18 13.97 18 9C18 4.03 13.97 0 9 0H8ZM15 9C15 8.45 14.55 8 14 8C13.45 8 13 8.45 13 9C13 9.55 13.45 10 14 10C14.55 10 15 9.55 15 9ZM3 9C3 9.55 3.45 10 4 10C4.55 10 5 9.55 5 9C5 8.45 4.55 8 4 8C3.45 8 3 8.45 3 9Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const PdfGreyIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25339 9.84912C8.05097 9.84912 7.92019 9.86645 7.8429 9.88423V12.4558C7.92019 12.4731 8.04508 12.4731 8.15819 12.4731C8.97895 12.4789 9.51411 12.0356 9.51411 11.0967C9.52 10.2807 9.03221 9.84912 8.25339 9.84912Z"
        fill="#788CA5"
      />
      <path
        d="M5.45767 10.4142C5.45767 10.0527 5.20222 9.83691 4.75002 9.83691C4.56574 9.83691 4.44062 9.85447 4.37534 9.87203V11.0325C4.4524 11.0498 4.5476 11.0556 4.67862 11.0556C5.16028 11.0556 5.45767 10.8165 5.45767 10.4142Z"
        fill="#788CA5"
      />
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7116 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1809H15.8136V18.4824ZM3.47729 13.126V9.24822C3.75677 9.20156 4.14936 9.16667 4.70243 9.16667C5.26139 9.16667 5.65987 9.27178 5.92756 9.48133C6.18324 9.67956 6.35573 10.0064 6.35573 10.3911C6.35573 10.776 6.22495 11.1027 5.98717 11.324C5.678 11.6098 5.21991 11.738 4.68452 11.738C4.56575 11.738 4.45853 11.732 4.37535 11.7204V13.126H3.47729ZM6.93283 13.1082V9.24822C7.2658 9.19578 7.69987 9.16667 8.15796 9.16667C8.91911 9.16667 9.41279 9.30089 9.79948 9.58644C10.2159 9.88978 10.4774 10.3736 10.4774 11.0678C10.4774 11.8198 10.198 12.3389 9.81127 12.6596C9.38921 13.0036 8.74684 13.1669 7.96167 13.1669C7.49201 13.1667 7.15881 13.1376 6.93283 13.1082ZM13.4221 10.8224V11.5453H11.9823V13.126H11.0722V9.19578H13.5227V9.92467H11.9823V10.8227L13.4221 10.8224ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const PdfBlueIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7116 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1809H15.8136V18.4824ZM3.47729 13.126V9.24822C3.75677 9.20156 4.14936 9.16667 4.70243 9.16667C5.26139 9.16667 5.65987 9.27178 5.92756 9.48133C6.18324 9.67956 6.35573 10.0064 6.35573 10.3911C6.35573 10.776 6.22495 11.1027 5.98717 11.324C5.678 11.6098 5.21991 11.738 4.68452 11.738C4.56575 11.738 4.45853 11.732 4.37535 11.7204V13.126H3.47729ZM6.93283 13.1082V9.24822C7.2658 9.19578 7.69987 9.16667 8.15796 9.16667C8.91911 9.16667 9.41279 9.30089 9.79948 9.58644C10.2159 9.88978 10.4774 10.3736 10.4774 11.0678C10.4774 11.8198 10.198 12.3389 9.81127 12.6596C9.38921 13.0036 8.74684 13.1669 7.96167 13.1669C7.49201 13.1667 7.15881 13.1376 6.93283 13.1082ZM13.4221 10.8224V11.5453H11.9823V13.126H11.0722V9.19578H13.5227V9.92467H11.9823V10.8227L13.4221 10.8224ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const VideoGreyIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 5V13L12 9L7 5ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const DocGreyIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7116 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM2.88501 13.0862V9.28178C3.21323 9.23 3.64117 9.20133 4.09247 9.20133C4.84296 9.20133 5.32961 9.33356 5.71064 9.61511C6.12113 9.914 6.37885 10.3909 6.37885 11.0749C6.37885 11.8162 6.10323 12.3278 5.7222 12.6438C5.30581 12.9829 4.67296 13.1438 3.89935 13.1438C3.43581 13.1436 3.1076 13.1151 2.88501 13.0862ZM6.78232 11.1956C6.78232 10.0347 7.53871 9.16667 8.70491 9.16667C9.91848 9.16667 10.5806 10.0576 10.5806 11.1264C10.5806 12.3967 9.79517 13.1667 8.64031 13.1667C7.46799 13.1667 6.78232 12.2989 6.78232 11.1956ZM13.1888 12.4367C13.4583 12.4367 13.7575 12.3793 13.9337 12.3102L14.0683 12.9942C13.904 13.0747 13.5347 13.1609 13.054 13.1609C11.6881 13.1609 10.9845 12.3276 10.9845 11.224C10.9845 9.90222 11.946 9.16644 13.1424 9.16644C13.605 9.16644 13.957 9.25844 14.1152 9.33889L13.9337 10.0344C13.7514 9.95978 13.4996 9.89067 13.1832 9.89067C12.4735 9.89067 11.9224 10.3102 11.9224 11.1722C11.9227 11.9484 12.3919 12.4367 13.1888 12.4367ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const PlannedIcon = ({ width = "15px", height = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00732 13.6707H1.46341V6.35366H11.7073V9.55854L13.1707 8.09512V3.42683C13.1707 2.62195 12.5122 1.96341 11.7073 1.96341H10.9756V0.5H9.5122V1.96341H3.65854V0.5H2.19512V1.96341H1.46341C0.65122 1.96341 0.00731707 2.62195 0.00731707 3.42683L0 13.6707C0 14.4756 0.65122 15.1341 1.46341 15.1341H7.47073L6.00732 13.6707ZM1.46341 3.42683H11.7073V4.89024H1.46341V3.42683ZM9.90732 15.5L7.31707 12.9098L8.34878 11.878L9.9 13.4293L13.0024 10.3268L14.0341 11.3585L9.90732 15.5Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const CloseNoteIcon = ({ width = "15px", height = "16px" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66536 13.3334H13.332V15.0001H6.66536V13.3334ZM6.66536 10.0001H13.332V11.6667H6.66536V10.0001ZM11.6654 1.66675H4.9987C4.08203 1.66675 3.33203 2.41675 3.33203 3.33341V16.6667C3.33203 17.5834 4.0737 18.3334 4.99036 18.3334H14.9987C15.9154 18.3334 16.6654 17.5834 16.6654 16.6667V6.66675L11.6654 1.66675ZM14.9987 16.6667H4.9987V3.33341H10.832V7.50008H14.9987V16.6667Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const UnPlannedIcon = ({ width = "14", height = "16" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 2H11.5V0.5H10V2H4V0.5H2.5V2H1.75C0.925 2 0.25 2.675 0.25 3.5V14C0.25 14.825 0.925 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM12.25 14H1.75V6.5H12.25V14ZM1.75 5V3.5H12.25V5H1.75ZM4.1725 12.0575L4.9675 12.8525L6.7975 11.0225L8.6275 12.8525L9.4225 12.0575L7.5925 10.2275L9.4225 8.3975L8.6275 7.6025L6.7975 9.4325L4.9675 7.6025L4.1725 8.3975L6.0025 10.2275L4.1725 12.0575Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const LoaderImg1 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="#E9F2FF"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="#E9F2FF"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="#E9F2FF"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#E9F2FF"
      />
    </svg>
  );
};
export const LoaderImg2 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_745)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="#E9F2FF"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="#E9F2FF"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#E9F2FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_745"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg3 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_753)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="#E9F2FF"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="#E9F2FF"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint1_linear_16134_753)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#E9F2FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_753"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_753"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LoaderImg4 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_761)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="url(#paint1_linear_16134_761)"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="#E9F2FF"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint2_linear_16134_761)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#E9F2FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_761"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_761"
          x1="54.5"
          y1="70.5"
          x2="75"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16134_761"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg5 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_769)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="url(#paint1_linear_16134_769)"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="url(#paint2_linear_16134_769)"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint3_linear_16134_769)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#E9F2FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_769"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_769"
          x1="54.5"
          y1="70.5"
          x2="75"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16134_769"
          x1="21.5"
          y1="70.5"
          x2="42"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_16134_769"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg6 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_777)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="url(#paint1_linear_16134_777)"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="url(#paint2_linear_16134_777)"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint3_linear_16134_777)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="url(#paint4_linear_16134_777)"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="black"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_777"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_777"
          x1="54.5"
          y1="70.5"
          x2="75"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16134_777"
          x1="21.5"
          y1="70.5"
          x2="42"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_16134_777"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_16134_777"
          x1="44.001"
          y1="50.4"
          x2="52.201"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg7 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_785)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="url(#paint1_linear_16134_785)"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="url(#paint2_linear_16134_785)"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint3_linear_16134_785)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#E9F2FF"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="url(#paint4_linear_16134_785)"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="black"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_785"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_785"
          x1="54.5"
          y1="70.5"
          x2="75"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16134_785"
          x1="21.5"
          y1="70.5"
          x2="42"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_16134_785"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_16134_785"
          x1="44.001"
          y1="50.4"
          x2="52.201"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg8 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="url(#paint0_linear_16134_793)"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="url(#paint1_linear_16134_793)"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="url(#paint2_linear_16134_793)"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="url(#paint3_linear_16134_793)"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="url(#paint4_linear_16134_793)"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="url(#paint5_linear_16134_793)"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="black"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16134_793"
          x1="21.5"
          y1="37.5"
          x2="42"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16134_793"
          x1="54.5"
          y1="70.5"
          x2="75"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16134_793"
          x1="21.5"
          y1="70.5"
          x2="42"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_16134_793"
          x1="54.5"
          y1="37.5"
          x2="75"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_16134_793"
          x1="26.001"
          y1="59.4"
          x2="67.9088"
          y2="33.3622"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_16134_793"
          x1="44.001"
          y1="50.4"
          x2="52.201"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C66E4" />
          <stop offset="1" stop-color="#E9F2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LoaderImg9 = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="95.0001" height="95" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="95.0001"
        height="95"
        rx="7.5"
        stroke="#E9F2FF"
      />
      <path
        d="M27 39C27.7956 39 28.5587 38.6839 29.1213 38.1213C29.6839 37.5587 30 36.7956 30 36V31.5C30 31.1022 30.158 30.7206 30.4393 30.4393C30.7206 30.158 31.1022 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27C39 26.2043 38.6839 25.4413 38.1213 24.8787C37.5587 24.3161 36.7956 24 36 24H31.5C29.5109 24 27.6032 24.7902 26.1967 26.1967C24.7902 27.6032 24 29.5109 24 31.5V36C24 36.7956 24.3161 37.5587 24.8787 38.1213C25.4413 38.6839 26.2043 39 27 39Z"
        fill="#0C66E4"
      />
      <path
        d="M69 57C68.2043 57 67.4413 57.3161 66.8787 57.8787C66.3161 58.4413 66 59.2043 66 60V64.5C66 64.8978 65.842 65.2793 65.5606 65.5606C65.2793 65.842 64.8978 66 64.5 66H60C59.2043 66 58.4413 66.3161 57.8787 66.8787C57.3161 67.4413 57 68.2043 57 69C57 69.7956 57.3161 70.5587 57.8787 71.1213C58.4413 71.6839 59.2043 72 60 72H64.5C65.4849 72 66.4602 71.806 67.3701 71.4291C68.2801 71.0522 69.1068 70.4997 69.8033 69.8033C70.4997 69.1068 71.0522 68.2801 71.4291 67.3701C71.806 66.4602 72 65.4849 72 64.5V60C72 59.2043 71.6839 58.4413 71.1213 57.8787C70.5587 57.3161 69.7956 57 69 57Z"
        fill="#0C66E4"
      />
      <path
        d="M36 66H31.5C31.1022 66 30.7206 65.842 30.4393 65.5606C30.158 65.2793 30 64.8978 30 64.5V60C30 59.2043 29.6839 58.4413 29.1213 57.8787C28.5587 57.3161 27.7956 57 27 57C26.2043 57 25.4413 57.3161 24.8787 57.8787C24.3161 58.4413 24 59.2043 24 60V64.5C24 65.4849 24.194 66.4602 24.5709 67.3701C24.9478 68.2801 25.5003 69.1068 26.1967 69.8033C26.8931 70.4997 27.7199 71.0522 28.6299 71.4291C29.5398 71.806 30.5151 72 31.5 72H36C36.7956 72 37.5587 71.6839 38.1213 71.1213C38.6839 70.5587 39 69.7956 39 69C39 68.2043 38.6839 67.4413 38.1213 66.8787C37.5587 66.3161 36.7956 66 36 66Z"
        fill="#0C66E4"
      />
      <path
        d="M64.5 24H60C59.2043 24 58.4413 24.3161 57.8787 24.8787C57.3161 25.4413 57 26.2043 57 27C57 27.7956 57.3161 28.5587 57.8787 29.1213C58.4413 29.6839 59.2043 30 60 30H64.5C64.8978 30 65.2793 30.158 65.5606 30.4393C65.842 30.7206 66 31.1022 66 31.5V36C66 36.7956 66.3161 37.5587 66.8787 38.1213C67.4413 38.6839 68.2043 39 69 39C69.7956 39 70.5587 38.6839 71.1213 38.1213C71.6839 37.5587 72 36.7956 72 36V31.5C72 30.5151 71.806 29.5398 71.4291 28.6299C71.0522 27.7199 70.4997 26.8931 69.8033 26.1967C69.1068 25.5003 68.2801 24.9478 67.3701 24.5709C66.4602 24.194 65.4849 24 64.5 24Z"
        fill="#0C66E4"
      />
      <path
        d="M48.001 33.75C38.4685 33.75 31.501 43.125 31.501 48C31.501 52.875 38.4685 62.25 48.001 62.25C57.5334 62.25 64.5009 52.875 64.5009 48C64.5009 43.125 57.5334 33.75 48.001 33.75ZM48.001 56.25C41.701 56.25 37.501 49.3725 37.501 48C37.501 46.6275 41.701 39.75 48.001 39.75C54.3009 39.75 58.5009 46.6275 58.5009 48C58.5009 49.3725 54.3009 56.25 48.001 56.25Z"
        fill="#0C66E4"
      />
      <path
        d="M48.001 51C49.6578 51 51.001 49.6568 51.001 48C51.001 46.3431 49.6578 45 48.001 45C46.3441 45 45.001 46.3431 45.001 48C45.001 49.6568 46.3441 51 48.001 51Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const GreyWOIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.79922 15.4167V6.25H15.5992V8.99167C16.1752 9.175 16.7192 9.44167 17.1992 9.8V6.25C17.1992 5.325 16.4872 4.58333 15.5992 4.58333H12.3992V2.91667C12.3992 1.99167 11.6872 1.25 10.7992 1.25H7.59922C6.71122 1.25 5.99922 1.99167 5.99922 2.91667V4.58333H2.79922C1.91122 4.58333 1.20722 5.325 1.20722 6.25L1.19922 15.4167C1.19922 16.3417 1.91122 17.0833 2.79922 17.0833H8.94322C8.70322 16.5667 8.54322 16.0083 8.46322 15.4167H2.79922ZM7.59922 2.91667H10.7992V4.58333H7.59922V2.91667Z"
        fill="#788CA5"
      />
      <path
        d="M13.9992 10.4167C11.7912 10.4167 9.99922 12.2833 9.99922 14.5833C9.99922 16.8833 11.7912 18.75 13.9992 18.75C16.2072 18.75 17.9992 16.8833 17.9992 14.5833C17.9992 12.2833 16.2072 10.4167 13.9992 10.4167ZM15.3192 16.5417L13.5992 14.75V12.0833H14.3992V14.4083L15.8792 15.95L15.3192 16.5417Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const GreyFileIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="12"
      height="22"
      viewBox="0 0 12 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5V16.5C10 18.71 8.21 20.5 6 20.5C3.79 20.5 2 18.71 2 16.5V4C2 2.62 3.12 1.5 4.5 1.5C5.88 1.5 7 2.62 7 4V14.5C7 15.05 6.55 15.5 6 15.5C5.45 15.5 5 15.05 5 14.5V5H3.5V14.5C3.5 15.88 4.62 17 6 17C7.38 17 8.5 15.88 8.5 14.5V4C8.5 1.79 6.71 0 4.5 0C2.29 0 0.5 1.79 0.5 4V16.5C0.5 19.54 2.96 22 6 22C9.04 22 11.5 19.54 11.5 16.5V5H10Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const UpArrow = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29492 19.1003L12.8749 14.0003L8.29492 8.90032L9.70492 7.33366L15.7049 14.0003L9.70492 20.667L8.29492 19.1003Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const UpArrowAr = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.705 8.90016L11.125 14.0002L15.705 19.1002L14.295 20.6668L8.295 14.0002L14.295 7.3335L15.705 8.90016Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const LinkBlueIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 4.6665H8.66659V5.99984L11.3333 5.99984C12.4333 5.99984 13.3333 6.89984 13.3333 7.99984C13.3333 9.09984 12.4333 9.99984 11.3333 9.99984H8.66659V11.3332H11.3333C13.1733 11.3332 14.6666 9.83984 14.6666 7.99984C14.6666 6.15984 13.1733 4.6665 11.3333 4.6665ZM7.33325 9.99984H4.66659C3.56659 9.99984 2.66659 9.09984 2.66659 7.99984C2.66659 6.89984 3.56659 5.99984 4.66659 5.99984L7.33325 5.99984V4.6665L4.66659 4.6665C2.82659 4.6665 1.33325 6.15984 1.33325 7.99984C1.33325 9.83984 2.82659 11.3332 4.66659 11.3332H7.33325V9.99984ZM5.33325 7.33317L10.6666 7.33317V8.6665L5.33325 8.6665L5.33325 7.33317Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const LinkWhiteIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3334 4.6665H8.66671V5.99984H11.3334C12.4334 5.99984 13.3334 6.89984 13.3334 7.99984C13.3334 9.09984 12.4334 9.99984 11.3334 9.99984H8.66671V11.3332H11.3334C13.1734 11.3332 14.6667 9.83984 14.6667 7.99984C14.6667 6.15984 13.1734 4.6665 11.3334 4.6665ZM7.33337 9.99984H4.66671C3.56671 9.99984 2.66671 9.09984 2.66671 7.99984C2.66671 6.89984 3.56671 5.99984 4.66671 5.99984H7.33337V4.6665H4.66671C2.82671 4.6665 1.33337 6.15984 1.33337 7.99984C1.33337 9.83984 2.82671 11.3332 4.66671 11.3332H7.33337V9.99984ZM5.33337 7.33317H10.6667V8.6665H5.33337V7.33317Z"
        fill="white"
      />
    </svg>
  );
};
export const POGreyIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 6H6.5V9H16.5V6H18.5V12H20.5V6C20.5 4.9 19.6 4 18.5 4H14.32C13.9 2.84 12.8 2 11.5 2C10.2 2 9.1 2.84 8.68 4H4.5C3.4 4 2.5 4.9 2.5 6V20C2.5 21.1 3.4 22 4.5 22H9.5V20H4.5V6ZM11.5 4C12.05 4 12.5 4.45 12.5 5C12.5 5.55 12.05 6 11.5 6C10.95 6 10.5 5.55 10.5 5C10.5 4.45 10.95 4 11.5 4Z"
          fill="#44546F"
        />
        <path
          d="M17.51 14L16.09 15.41L17.67 16.99H11.5V18.99H17.67L16.09 20.58L17.51 21.99L21.5 17.99L17.51 14Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};
export const OrderIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="23"
        height="24"
        viewBox="0 0 23 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 17C7.60444 17 7.21776 17.1173 6.88886 17.3371C6.55996 17.5568 6.30361 17.8692 6.15224 18.2346C6.00086 18.6001 5.96126 19.0022 6.03843 19.3902C6.1156 19.7781 6.30608 20.1345 6.58579 20.4142C6.86549 20.6939 7.22186 20.8844 7.60982 20.9616C7.99778 21.0387 8.39991 20.9991 8.76537 20.8478C9.13082 20.6964 9.44318 20.44 9.66294 20.1111C9.8827 19.7822 10 19.3956 10 19C10 18.4696 9.78928 17.9609 9.41421 17.5858C9.03914 17.2107 8.53043 17 8 17ZM8 7C8.39556 7 8.78224 6.8827 9.11114 6.66294C9.44004 6.44318 9.69638 6.13082 9.84776 5.76537C9.99913 5.39991 10.0387 4.99778 9.96157 4.60982C9.8844 4.22186 9.69392 3.86549 9.41421 3.58579C9.13451 3.30608 8.77814 3.1156 8.39018 3.03843C8.00222 2.96126 7.60008 3.00087 7.23463 3.15224C6.86918 3.30362 6.55682 3.55996 6.33706 3.88886C6.1173 4.21776 6 4.60444 6 5C6 5.53043 6.21071 6.03914 6.58579 6.41421C6.96086 6.78928 7.46957 7 8 7ZM8 14C8.39556 14 8.78224 13.8827 9.11114 13.6629C9.44004 13.4432 9.69638 13.1308 9.84776 12.7654C9.99913 12.3999 10.0387 11.9978 9.96157 11.6098C9.8844 11.2219 9.69392 10.8655 9.41421 10.5858C9.13451 10.3061 8.77814 10.1156 8.39018 10.0384C8.00222 9.96126 7.60008 10.0009 7.23463 10.1522C6.86918 10.3036 6.55682 10.56 6.33706 10.8889C6.1173 11.2178 6 11.6044 6 12C6 12.5304 6.21071 13.0391 6.58579 13.4142C6.96086 13.7893 7.46957 14 8 14Z"
          fill="#788CA5"
        />
        <path
          d="M15 17C14.6044 17 14.2178 17.1173 13.8889 17.3371C13.56 17.5568 13.3036 17.8692 13.1522 18.2346C13.0009 18.6001 12.9613 19.0022 13.0384 19.3902C13.1156 19.7781 13.3061 20.1345 13.5858 20.4142C13.8655 20.6939 14.2219 20.8844 14.6098 20.9616C14.9978 21.0387 15.3999 20.9991 15.7654 20.8478C16.1308 20.6964 16.4432 20.44 16.6629 20.1111C16.8827 19.7822 17 19.3956 17 19C17 18.4696 16.7893 17.9609 16.4142 17.5858C16.0391 17.2107 15.5304 17 15 17ZM15 7C15.3956 7 15.7822 6.8827 16.1111 6.66294C16.44 6.44318 16.6964 6.13082 16.8478 5.76537C16.9991 5.39991 17.0387 4.99778 16.9616 4.60982C16.8844 4.22186 16.6939 3.86549 16.4142 3.58579C16.1345 3.30608 15.7781 3.1156 15.3902 3.03843C15.0022 2.96126 14.6001 3.00087 14.2346 3.15224C13.8692 3.30362 13.5568 3.55996 13.3371 3.88886C13.1173 4.21776 13 4.60444 13 5C13 5.53043 13.2107 6.03914 13.5858 6.41421C13.9609 6.78928 14.4696 7 15 7ZM15 14C15.3956 14 15.7822 13.8827 16.1111 13.6629C16.44 13.4432 16.6964 13.1308 16.8478 12.7654C16.9991 12.3999 17.0387 11.9978 16.9616 11.6098C16.8844 11.2219 16.6939 10.8655 16.4142 10.5858C16.1345 10.3061 15.7781 10.1156 15.3902 10.0384C15.0022 9.96126 14.6001 10.0009 14.2346 10.1522C13.8692 10.3036 13.5568 10.56 13.3371 10.8889C13.1173 11.2178 13 11.6044 13 12C13 12.5304 13.2107 13.0391 13.5858 13.4142C13.9609 13.7893 14.4696 14 15 14Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const OptionIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 17C7.60444 17 7.21776 17.1173 6.88886 17.3371C6.55996 17.5568 6.30361 17.8692 6.15224 18.2346C6.00086 18.6001 5.96126 19.0022 6.03843 19.3902C6.1156 19.7781 6.30608 20.1345 6.58579 20.4142C6.86549 20.6939 7.22186 20.8844 7.60982 20.9616C7.99778 21.0387 8.39991 20.9991 8.76537 20.8478C9.13082 20.6964 9.44318 20.44 9.66294 20.1111C9.8827 19.7822 10 19.3956 10 19C10 18.4696 9.78928 17.9609 9.41421 17.5858C9.03914 17.2107 8.53043 17 8 17ZM8 7C8.39556 7 8.78224 6.8827 9.11114 6.66294C9.44004 6.44318 9.69638 6.13082 9.84776 5.76537C9.99913 5.39991 10.0387 4.99778 9.96157 4.60982C9.8844 4.22186 9.69392 3.86549 9.41421 3.58579C9.13451 3.30608 8.77814 3.1156 8.39018 3.03843C8.00222 2.96126 7.60008 3.00087 7.23463 3.15224C6.86918 3.30362 6.55682 3.55996 6.33706 3.88886C6.1173 4.21776 6 4.60444 6 5C6 5.53043 6.21071 6.03914 6.58579 6.41421C6.96086 6.78928 7.46957 7 8 7ZM8 14C8.39556 14 8.78224 13.8827 9.11114 13.6629C9.44004 13.4432 9.69638 13.1308 9.84776 12.7654C9.99913 12.3999 10.0387 11.9978 9.96157 11.6098C9.8844 11.2219 9.69392 10.8655 9.41421 10.5858C9.13451 10.3061 8.77814 10.1156 8.39018 10.0384C8.00222 9.96126 7.60008 10.0009 7.23463 10.1522C6.86918 10.3036 6.55682 10.56 6.33706 10.8889C6.1173 11.2178 6 11.6044 6 12C6 12.5304 6.21071 13.0391 6.58579 13.4142C6.96086 13.7893 7.46957 14 8 14Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const PictureIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const RestockIcon = ({ width = "20", height = "18" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13.17L18 8.83V20ZM8.45 10.57L7.28 9.4V13H10.88L9.44 11.56C9.96 10.55 11.02 9.85 12.23 9.85C13.97 9.85 15.38 11.26 15.38 13C15.38 14.74 13.97 16.15 12.23 16.15C11.16 16.15 10.21 15.61 9.65 14.8H8.1C8.79 16.38 10.38 17.5 12.22 17.5C14.7 17.5 16.72 15.48 16.72 13C16.72 10.52 14.7 8.5 12.22 8.5C10.63 8.5 9.25 9.33 8.45 10.57Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const DashboardWOStatusIcon = ({ width = "20", height = "18" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16675 4.83335H9.83342V6.50002H8.16675V4.83335ZM8.16675 8.16669H9.83342V13.1667H8.16675V8.16669ZM9.00008 0.666687C4.40008 0.666687 0.666748 4.40002 0.666748 9.00002C0.666748 13.6 4.40008 17.3334 9.00008 17.3334C13.6001 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6001 0.666687 9.00008 0.666687ZM9.00008 15.6667C5.32508 15.6667 2.33341 12.675 2.33341 9.00002C2.33341 5.32502 5.32508 2.33335 9.00008 2.33335C12.6751 2.33335 15.6667 5.32502 15.6667 9.00002C15.6667 12.675 12.6751 15.6667 9.00008 15.6667Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const ProcedureIconBlue = () => {
  return (
    <>
      <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8">
          <path
            opacity="0.3"
            d="M13.8333 63.3334H67.1667V16.6667H13.8333V63.3334ZM45.2 35.8334L49.9 40.5667L60.4667 30.0001L65.2 34.7334L49.9 50.0001L40.5 40.5334L45.2 35.8334ZM17.1667 23.3334H33.8333V30.0001H17.1667V23.3334ZM17.1667 36.6667H33.8333V43.3334H17.1667V36.6667ZM17.1667 50.0001H33.8333V56.6667H17.1667V50.0001Z"
            fill="#0C66E4"
          />
          <path
            d="M67.1667 10H13.8333C10.1667 10 7.16666 13 7.16666 16.6667V63.3333C7.16666 67 10.1667 70 13.8333 70H67.1667C70.8333 70 73.8333 67 73.8333 63.3333V16.6667C73.8333 13 70.8333 10 67.1667 10ZM67.1667 63.3333H13.8333V16.6667H67.1667V63.3333Z"
            fill="#0C66E4"
          />
          <path
            d="M65.2 34.7333L60.4667 30L49.9 40.5667L45.2 35.8333L40.5 40.5333L49.9 50L65.2 34.7333Z"
            fill="#0C66E4"
          />
          <path
            d="M33.8333 23.3333H17.1667V29.9999H33.8333V23.3333Z"
            fill="#0C66E4"
          />
          <path
            d="M33.8333 36.6667H17.1667V43.3334H33.8333V36.6667Z"
            fill="#0C66E4"
          />
          <path d="M33.8333 50H17.1667V56.6667H33.8333V50Z" fill="#0C66E4" />
        </g>
      </svg>
    </>
  );
};

export const AmountLightIcon = () => {
  return (
    <>
      <svg
        width="42"
        height="34"
        viewBox="0 0 42 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="41"
          height="33"
          rx="1.5"
          fill="#E9F2FF"
          stroke="#0C66E4"
        />
        <path
          d="M28 19V11C28 9.9 27.1 9 26 9H12C10.9 9 10 9.9 10 11V19C10 20.1 10.9 21 12 21H26C27.1 21 28 20.1 28 19ZM26 19H12V11H26V19ZM19 12C17.34 12 16 13.34 16 15C16 16.66 17.34 18 19 18C20.66 18 22 16.66 22 15C22 13.34 20.66 12 19 12ZM32 12V23C32 24.1 31.1 25 30 25H13V23H30V12H32Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const AmountBlueIcon = () => {
  return (
    <>
      <svg
        width="42"
        height="34"
        viewBox="0 0 42 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="41"
          height="33"
          rx="1.5"
          fill="#0C66E4"
          stroke="#0C66E4"
        />
        <path
          d="M28 19V11C28 9.9 27.1 9 26 9H12C10.9 9 10 9.9 10 11V19C10 20.1 10.9 21 12 21H26C27.1 21 28 20.1 28 19ZM26 19H12V11H26V19ZM19 12C17.34 12 16 13.34 16 15C16 16.66 17.34 18 19 18C20.66 18 22 16.66 22 15C22 13.34 20.66 12 19 12ZM32 12V23C32 24.1 31.1 25 30 25H13V23H30V12H32Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const PercentageLightIcon = () => {
  return (
    <>
      <svg
        width="42"
        height="34"
        viewBox="0 0 42 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="41"
          height="33"
          rx="1.5"
          fill="#E9F2FF"
          stroke="#0C66E4"
        />
        <path
          d="M16.5 9C14.57 9 13 10.57 13 12.5C13 14.43 14.57 16 16.5 16C18.43 16 20 14.43 20 12.5C20 10.57 18.43 9 16.5 9ZM16.5 14C15.67 14 15 13.33 15 12.5C15 11.67 15.67 11 16.5 11C17.33 11 18 11.67 18 12.5C18 13.33 17.33 14 16.5 14ZM25.5 18C23.57 18 22 19.57 22 21.5C22 23.43 23.57 25 25.5 25C27.43 25 29 23.43 29 21.5C29 19.57 27.43 18 25.5 18ZM25.5 23C24.67 23 24 22.33 24 21.5C24 20.67 24.67 20 25.5 20C26.33 20 27 20.67 27 21.5C27 22.33 26.33 23 25.5 23ZM14.41 25L13 23.59L27.59 9L29 10.41L14.41 25Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const PercentageBlueIcon = () => {
  return (
    <>
      <svg
        width="42"
        height="34"
        viewBox="0 0 42 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="41"
          height="33"
          rx="1.5"
          fill="#0C66E4"
          stroke="#0C66E4"
        />
        <path
          d="M16.5 9C14.57 9 13 10.57 13 12.5C13 14.43 14.57 16 16.5 16C18.43 16 20 14.43 20 12.5C20 10.57 18.43 9 16.5 9ZM16.5 14C15.67 14 15 13.33 15 12.5C15 11.67 15.67 11 16.5 11C17.33 11 18 11.67 18 12.5C18 13.33 17.33 14 16.5 14ZM25.5 18C23.57 18 22 19.57 22 21.5C22 23.43 23.57 25 25.5 25C27.43 25 29 23.43 29 21.5C29 19.57 27.43 18 25.5 18ZM25.5 23C24.67 23 24 22.33 24 21.5C24 20.67 24.67 20 25.5 20C26.33 20 27 20.67 27 21.5C27 22.33 26.33 23 25.5 23ZM14.41 25L13 23.59L27.59 9L29 10.41L14.41 25Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const PercentageDashBoardBlueIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill="#0C66E4" />
        <rect
          width="24"
          height="24"
          transform="translate(2 2)"
          fill="#0C66E4"
        />
        <path
          d="M9.5 6C7.57 6 6 7.57 6 9.5C6 11.43 7.57 13 9.5 13C11.43 13 13 11.43 13 9.5C13 7.57 11.43 6 9.5 6ZM9.5 11C8.67 11 8 10.33 8 9.5C8 8.67 8.67 8 9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11ZM18.5 15C16.57 15 15 16.57 15 18.5C15 20.43 16.57 22 18.5 22C20.43 22 22 20.43 22 18.5C22 16.57 20.43 15 18.5 15ZM18.5 20C17.67 20 17 19.33 17 18.5C17 17.67 17.67 17 18.5 17C19.33 17 20 17.67 20 18.5C20 19.33 19.33 20 18.5 20ZM7.41 22L6 20.59L20.59 6L22 7.41L7.41 22Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const ClockdBlueIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill="#0C66E4" />
        <rect
          width="24"
          height="24"
          transform="translate(2 2)"
          fill="#0C66E4"
        />
        <path
          d="M13.99 4C8.47 4 4 8.48 4 14C4 19.52 8.47 24 13.99 24C19.52 24 24 19.52 24 14C24 8.48 19.52 4 13.99 4ZM14 22C9.58 22 6 18.42 6 14C6 9.58 9.58 6 14 6C18.42 6 22 9.58 22 14C22 18.42 18.42 22 14 22Z"
          fill="white"
        />
        <path
          d="M14.5 9H13V15L18.25 18.15L19 16.92L14.5 14.25V9Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const ClockdLightBlueIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill="#E9F2FF" />
        <rect
          width="24"
          height="24"
          transform="translate(2 2)"
          fill="#E9F2FF"
        />
        <path
          d="M13.99 4C8.47 4 4 8.48 4 14C4 19.52 8.47 24 13.99 24C19.52 24 24 19.52 24 14C24 8.48 19.52 4 13.99 4ZM14 22C9.58 22 6 18.42 6 14C6 9.58 9.58 6 14 6C18.42 6 22 9.58 22 14C22 18.42 18.42 22 14 22Z"
          fill="#0C66E4"
        />
        <path
          d="M14.5 9H13V15L18.25 18.15L19 16.92L14.5 14.25V9Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const PercentageLightBlueIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill="#E9F2FF" />
        <rect
          width="24"
          height="24"
          transform="translate(2 2)"
          fill="#E9F2FF"
        />
        <path
          d="M9.5 6C7.57 6 6 7.57 6 9.5C6 11.43 7.57 13 9.5 13C11.43 13 13 11.43 13 9.5C13 7.57 11.43 6 9.5 6ZM9.5 11C8.67 11 8 10.33 8 9.5C8 8.67 8.67 8 9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11ZM18.5 15C16.57 15 15 16.57 15 18.5C15 20.43 16.57 22 18.5 22C20.43 22 22 20.43 22 18.5C22 16.57 20.43 15 18.5 15ZM18.5 20C17.67 20 17 19.33 17 18.5C17 17.67 17.67 17 18.5 17C19.33 17 20 17.67 20 18.5C20 19.33 19.33 20 18.5 20ZM7.41 22L6 20.59L20.59 6L22 7.41L7.41 22Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const HashBlueIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="2" fill="#0C66E4" />
        <path
          d="M22.5 12L23 10H19L20 6H18L17 10H13L14 6H12L11 10H7L6.5 12H10.5L9.5 16H5.5L5 18H9L8 22H10L11 18H15L14 22H16L17 18H21L21.5 16H17.5L18.5 12H22.5ZM15.5 16H11.5L12.5 12H16.5L15.5 16Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const HomeIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1765 5.00647L17.7647 10.0359V18.7647H15.5294V12.0588H8.82353V18.7647H6.58824V10.0359L12.1765 5.00647ZM12.1765 2L1 12.0588H4.35294V21H11.0588V14.2941H13.2941V21H20V12.0588H23.3529L12.1765 2Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const BillingInfoIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM15 20H6C5.45 20 5 19.55 5 19V18H15V20ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z"
          fill="#44546F"
        />
        <path d="M15 7H9V9H15V7Z" fill="#44546F" />
        <path d="M18 7H16V9H18V7Z" fill="#44546F" />
        <path d="M15 10H9V12H15V10Z" fill="#44546F" />
        <path d="M18 10H16V12H18V10Z" fill="#44546F" />
      </svg>
    </>
  );
};
export const ContactInfoIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.22 3.75 12.41 3.85 12.55 4C12.67 4.13 12.75 4.31 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.31 11.33 4.13 11.45 4C11.59 3.85 11.78 3.75 12 3.75ZM19 20H5V6H19V20ZM12 7C10.35 7 9 8.35 9 10C9 11.65 10.35 13 12 13C13.65 13 15 11.65 15 10C15 8.35 13.65 7 12 7ZM12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11ZM6 17.47V19H18V17.47C18 14.97 14.03 13.89 12 13.89C9.97 13.89 6 14.96 6 17.47ZM8.31 17C9 16.44 10.69 15.88 12 15.88C13.31 15.88 15.01 16.44 15.69 17H8.31Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const StoreInfoIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.8978 8.89L20.8478 4.52C20.6278 3.62 19.8478 3 18.9378 3H5.04781C4.14781 3 3.35781 3.63 3.14781 4.52L2.09781 8.89C1.85781 9.91 2.07781 10.95 2.71781 11.77C2.79781 11.88 2.90781 11.96 2.99781 12.06V19C2.99781 20.1 3.89781 21 4.99781 21H18.9978C20.0978 21 20.9978 20.1 20.9978 19V12.06C21.0878 11.97 21.1978 11.88 21.2778 11.78C21.9178 10.96 22.1478 9.91 21.8978 8.89ZM18.9078 4.99L19.9578 9.36C20.0578 9.78 19.9678 10.2 19.7078 10.53C19.5678 10.71 19.2678 11 18.7678 11C18.1578 11 17.6278 10.51 17.5578 9.86L16.9778 5L18.9078 4.99ZM12.9978 5H14.9578L15.4978 9.52C15.5478 9.91 15.4278 10.3 15.1678 10.59C14.9478 10.85 14.6278 11 14.2178 11C13.5478 11 12.9978 10.41 12.9978 9.69V5ZM8.48781 9.52L9.03781 5H10.9978V9.69C10.9978 10.41 10.4478 11 9.70781 11C9.36781 11 9.05781 10.85 8.81781 10.59C8.56781 10.3 8.44781 9.91 8.48781 9.52ZM4.03781 9.36L5.04781 5H7.01781L6.43781 9.86C6.35781 10.51 5.83781 11 5.22781 11C4.73781 11 4.42781 10.71 4.29781 10.53C4.02781 10.21 3.93781 9.78 4.03781 9.36ZM4.99781 19V12.97C5.07781 12.98 5.14781 13 5.22781 13C6.09781 13 6.88781 12.64 7.46781 12.05C8.06781 12.65 8.86781 13 9.77781 13C10.6478 13 11.4278 12.64 12.0078 12.07C12.5978 12.64 13.3978 13 14.2978 13C15.1378 13 15.9378 12.65 16.5378 12.05C17.1178 12.64 17.9078 13 18.7778 13C18.8578 13 18.9278 12.98 19.0078 12.97V19H4.99781Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};
export const InventoryIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 16H14V18H7V16ZM7 12H17V14H7V12ZM7 8H17V10H7V8ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const AddIconDashboard = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#788CA5" />
      </svg>
    </>
  );
};

export const EyeIcon = () => {
  return (
    <>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 3.97505C14.79 3.97505 18.17 6.10505 19.82 9.47505C19.23 10.695 18.4 11.745 17.41 12.595L18.82 14.005C20.21 12.775 21.31 11.235 22 9.47505C20.27 5.08505 16 1.97505 11 1.97505C9.73 1.97505 8.51 2.17505 7.36 2.54505L9.01 4.19505C9.66 4.06505 10.32 3.97505 11 3.97505ZM9.93 5.11505L12 7.18505C12.57 7.43505 13.03 7.89505 13.28 8.46505L15.35 10.535C15.43 10.195 15.49 9.83505 15.49 9.46505C15.5 6.98505 13.48 4.97505 11 4.97505C10.63 4.97505 10.28 5.02505 9.93 5.11505ZM1.01 1.84505L3.69 4.52505C2.06 5.80505 0.77 7.50505 0 9.47505C1.73 13.865 6 16.975 11 16.975C12.52 16.975 13.98 16.685 15.32 16.155L18.74 19.575L20.15 18.165L2.42 0.425049L1.01 1.84505ZM8.51 9.34505L11.12 11.955C11.08 11.965 11.04 11.975 11 11.975C9.62 11.975 8.5 10.855 8.5 9.47505C8.5 9.42505 8.51 9.39505 8.51 9.34505ZM5.11 5.94505L6.86 7.69505C6.63 8.24505 6.5 8.84505 6.5 9.47505C6.5 11.955 8.52 13.975 11 13.975C11.63 13.975 12.23 13.845 12.77 13.615L13.75 14.595C12.87 14.835 11.95 14.975 11 14.975C7.21 14.975 3.83 12.845 2.18 9.47505C2.88 8.04505 3.9 6.86505 5.11 5.94505Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};
export const ErrorIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="16" height="16" fill="white" fill-opacity="0.01" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.51115 2.65513C8.67312 2.72225 8.82029 2.82062 8.94423 2.94463L13.0562 7.05596C13.1803 7.17992 13.2788 7.32713 13.346 7.48916C13.4132 7.6512 13.4477 7.82489 13.4477 8.0003C13.4477 8.17571 13.4132 8.34939 13.346 8.51143C13.2788 8.67347 13.1803 8.82067 13.0562 8.94463L8.94423 13.056C8.82029 13.18 8.67312 13.2783 8.51115 13.3455C8.34917 13.4126 8.17556 13.4471 8.00023 13.4471C7.8249 13.4471 7.65129 13.4126 7.48931 13.3455C7.32734 13.2783 7.18017 13.18 7.05623 13.056L2.94423 8.94463C2.82012 8.82067 2.72166 8.67347 2.65449 8.51143C2.58731 8.34939 2.55273 8.17571 2.55273 8.0003C2.55273 7.82489 2.58731 7.6512 2.65449 7.48916C2.72166 7.32713 2.82012 7.17992 2.94423 7.05596L7.05623 2.94463C7.18017 2.82062 7.32734 2.72225 7.48931 2.65513C7.65129 2.58801 7.8249 2.55347 8.00023 2.55347C8.17556 2.55347 8.34917 2.58801 8.51115 2.65513ZM7.52882 9.13803C7.65385 9.26305 7.82342 9.33329 8.00023 9.33329C8.17704 9.33329 8.34661 9.26305 8.47163 9.13803C8.59666 9.01301 8.6669 8.84344 8.6669 8.66663V5.33329C8.6669 5.15648 8.59666 4.98691 8.47163 4.86189C8.34661 4.73686 8.17704 4.66663 8.00023 4.66663C7.82342 4.66663 7.65385 4.73686 7.52882 4.86189C7.4038 4.98691 7.33356 5.15648 7.33356 5.33329V8.66663C7.33356 8.84344 7.4038 9.01301 7.52882 9.13803ZM7.52882 11.138C7.65385 11.2631 7.82342 11.3333 8.00023 11.3333C8.17704 11.3333 8.34661 11.2631 8.47163 11.138C8.59666 11.013 8.6669 10.8434 8.6669 10.6666C8.6669 10.4898 8.59666 10.3202 8.47163 10.1952C8.34661 10.0702 8.17704 9.99996 8.00023 9.99996C7.82342 9.99996 7.65385 10.0702 7.52882 10.1952C7.4038 10.3202 7.33356 10.4898 7.33356 10.6666C7.33356 10.8434 7.4038 11.013 7.52882 11.138Z"
          fill="#D14040"
        />
      </svg>
    </>
  );
};

export const ProcedurePlusIcon = () => {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
      </svg>
    </>
  );
};

export const PeopleIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          opacity="0.3"
          d="M9 10C9.82843 10 10.5 9.32843 10.5 8.5C10.5 7.67157 9.82843 7 9 7C8.17157 7 7.5 7.67157 7.5 8.5C7.5 9.32843 8.17157 10 9 10Z"
          fill="#172B4D"
        />
        <path
          opacity="0.3"
          d="M4.34003 17H13.66C12.82 16.42 10.79 15.75 9.00003 15.75C7.21003 15.75 5.18003 16.42 4.34003 17Z"
          fill="#172B4D"
        />
        <path
          d="M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
          fill="#172B4D"
        />
      </svg>
    </>
  );
};
export const PartIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 11.5L22.5 13L15.51 20L11 15.5L12.5 14L15.51 17L21 11.5Z"
          fill="#172B4D"
        />
        <path
          opacity="0.3"
          d="M17 5V8H7V5H5V19H11.68L8.17 15.5L12.5 11.17L15.51 14.17L19 10.67V5H17Z"
          fill="#172B4D"
        />
        <path
          d="M5 19V5H7V8H17V5H19V10.67L21 8.67V5C21 3.9 20.1 3 19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H13.68L11.68 19H5ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3Z"
          fill="#172B4D"
        />
      </svg>
    </>
  );
};
export const CustomerIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M17 11H19V13H17V15H19V17H17V19H21V5H12V6.4L17 9.97V11ZM17 7H19V9H17V7Z"
          fill="#172B4D"
        />
        <path
          d="M10 3V4.97L10.96 5.66L12 6.4V5H21V19H17V21H23V3H10Z"
          fill="#172B4D"
        />
        <path
          opacity="0.3"
          d="M3 12V19H5V14H11V19H13V12L8 8.5L3 12Z"
          fill="#172B4D"
        />
        <path d="M19 7H17V9H19V7Z" fill="#172B4D" />
        <path d="M19 11H17V13H19V11Z" fill="#172B4D" />
        <path d="M19 15H17V17H19V15Z" fill="#172B4D" />
        <path
          d="M1 11V21H7V16H9V21H15V11L8 6L1 11ZM13 19H11V14H5V19H3V12L8 8.5L13 12V19Z"
          fill="#172B4D"
        />
      </svg>
    </>
  );
};

export const SearchIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6965 12.5708L16.9798 15.9125C17.1269 16.0715 17.2063 16.2815 17.2012 16.498C17.1961 16.7145 17.1069 16.9206 16.9525 17.0725C16.7982 17.2244 16.5907 17.3102 16.3741 17.3117C16.1575 17.3133 15.9489 17.2305 15.7923 17.0808L12.5106 13.7425C11.2444 14.6964 9.66304 15.1334 8.08669 14.9652C6.51035 14.7969 5.05684 14.036 4.02048 12.8363C2.98411 11.6367 2.44234 10.0881 2.50487 8.50399C2.56739 6.91993 3.22953 5.41881 4.35722 4.3046C5.48491 3.19038 6.99388 2.54632 8.57858 2.50284C10.1633 2.45936 11.7053 3.0197 12.8924 4.07041C14.0795 5.12111 14.8229 6.58366 14.9722 8.16192C15.1215 9.74017 14.6655 11.3162 13.6965 12.5708ZM8.7498 13.3333C9.96537 13.3333 11.1312 12.8505 11.9907 11.9909C12.8502 11.1314 13.3331 9.96558 13.3331 8.75C13.3331 7.53443 12.8502 6.36864 11.9907 5.5091C11.1312 4.64956 9.96537 4.16667 8.7498 4.16667C7.53422 4.16667 6.36843 4.64956 5.50889 5.5091C4.64935 6.36864 4.16646 7.53443 4.16646 8.75C4.16646 9.96558 4.64935 11.1314 5.50889 11.9909C6.36843 12.8505 7.53422 13.3333 8.7498 13.3333Z"
          fill="#626F86"
        />
      </svg>
    </>
  );
};

export const DownChevron = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.52742 10.293C8.34061 10.4819 8.23584 10.7368 8.23584 11.0025C8.23584 11.2682 8.34061 11.5231 8.52742 11.712L11.4664 14.677C11.6844 14.892 11.9664 14.999 12.2454 14.999C12.5244 14.999 12.8014 14.892 13.0144 14.677L15.9444 11.722C16.131 11.533 16.2356 11.2781 16.2356 11.0125C16.2356 10.7469 16.131 10.492 15.9444 10.303C15.8526 10.2098 15.7431 10.1358 15.6225 10.0853C15.5018 10.0348 15.3722 10.0088 15.2414 10.0088C15.1106 10.0088 14.9811 10.0348 14.8604 10.0853C14.7397 10.1358 14.6303 10.2098 14.5384 10.303L12.2404 12.62L9.93342 10.293C9.84138 10.2002 9.73188 10.1265 9.61122 10.0762C9.49056 10.0259 9.36114 10.0001 9.23042 10.0001C9.0997 10.0001 8.97028 10.0259 8.84962 10.0762C8.72896 10.1265 8.61946 10.2002 8.52742 10.293Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const WhiteDownChevron = ({
  width = "25",
  height = "24",
  fill = "#ffffff",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.52742 10.293C8.34061 10.4819 8.23584 10.7368 8.23584 11.0025C8.23584 11.2682 8.34061 11.5231 8.52742 11.712L11.4664 14.677C11.6844 14.892 11.9664 14.999 12.2454 14.999C12.5244 14.999 12.8014 14.892 13.0144 14.677L15.9444 11.722C16.131 11.533 16.2356 11.2781 16.2356 11.0125C16.2356 10.7469 16.131 10.492 15.9444 10.303C15.8526 10.2098 15.7431 10.1358 15.6225 10.0853C15.5018 10.0348 15.3722 10.0088 15.2414 10.0088C15.1106 10.0088 14.9811 10.0348 14.8604 10.0853C14.7397 10.1358 14.6303 10.2098 14.5384 10.303L12.2404 12.62L9.93342 10.293C9.84138 10.2002 9.73188 10.1265 9.61122 10.0762C9.49056 10.0259 9.36114 10.0001 9.23042 10.0001C9.0997 10.0001 8.97028 10.0259 8.84962 10.0762C8.72896 10.1265 8.61946 10.2002 8.52742 10.293Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export const ActionBtnIcon = ({}) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 12C7 11.6044 6.8827 11.2178 6.66294 10.8889C6.44318 10.56 6.13082 10.3036 5.76537 10.1522C5.39992 10.0009 4.99778 9.96126 4.60982 10.0384C4.22186 10.1156 3.86549 10.3061 3.58579 10.5858C3.30608 10.8655 3.1156 11.2219 3.03843 11.6098C2.96126 11.9978 3.00087 12.3999 3.15224 12.7654C3.30362 13.1308 3.55996 13.4432 3.88886 13.6629C4.21776 13.8827 4.60444 14 5 14C5.53043 14 6.03914 13.7893 6.41421 13.4142C6.78929 13.0391 7 12.5304 7 12ZM17 12C17 12.3956 17.1173 12.7822 17.3371 13.1111C17.5568 13.44 17.8692 13.6964 18.2346 13.8478C18.6001 13.9991 19.0022 14.0387 19.3902 13.9616C19.7781 13.8844 20.1345 13.6939 20.4142 13.4142C20.6939 13.1345 20.8844 12.7781 20.9616 12.3902C21.0387 12.0022 20.9991 11.6001 20.8478 11.2346C20.6964 10.8692 20.44 10.5568 20.1111 10.3371C19.7822 10.1173 19.3956 10 19 10C18.4696 10 17.9609 10.2107 17.5858 10.5858C17.2107 10.9609 17 11.4696 17 12ZM10 12C10 12.3956 10.1173 12.7822 10.3371 13.1111C10.5568 13.44 10.8692 13.6964 11.2346 13.8478C11.6001 13.9991 12.0022 14.0387 12.3902 13.9616C12.7781 13.8844 13.1345 13.6939 13.4142 13.4142C13.6939 13.1345 13.8844 12.7781 13.9616 12.3902C14.0387 12.0022 13.9991 11.6001 13.8478 11.2346C13.6964 10.8692 13.44 10.5568 13.1111 10.3371C12.7822 10.1173 12.3956 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const DashboardFilterIcon = ({
  width = "25",
  height = "24",
  fill = "#ffffff",
}) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.005 6H17.005L11.995 12.3L7.005 6ZM4.255 5.61C6.275 8.2 10.005 13 10.005 13V19C10.005 19.55 10.455 20 11.005 20H13.005C13.555 20 14.005 19.55 14.005 19V13C14.005 13 17.725 8.2 19.745 5.61C20.255 4.95 19.785 4 18.955 4H5.045C4.215 4 3.745 4.95 4.255 5.61Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const CalenderIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.87781 5H19.8878C20.9898 5 21.8828 5.895 21.8828 6.994V19.006C21.8828 19.2679 21.8312 19.5273 21.7309 19.7693C21.6307 20.0113 21.4837 20.2312 21.2984 20.4163C21.1132 20.6015 20.8932 20.7484 20.6512 20.8485C20.4092 20.9487 20.1498 21.0001 19.8878 21H5.87781C5.34888 21 4.84159 20.7899 4.46749 20.416C4.09338 20.0421 3.88308 19.5349 3.88281 19.006V6.994C3.88281 5.893 4.77481 5 5.87781 5ZM5.88281 9V18C5.88281 18.2652 5.98817 18.5196 6.17571 18.7071C6.36324 18.8946 6.6176 19 6.88281 19H18.8828C19.148 19 19.4024 18.8946 19.5899 18.7071C19.7775 18.5196 19.8828 18.2652 19.8828 18V9H5.88281ZM6.88281 4C6.88281 3.73478 6.98817 3.48043 7.17571 3.29289C7.36324 3.10536 7.6176 3 7.88281 3C8.14803 3 8.40238 3.10536 8.58992 3.29289C8.77746 3.48043 8.88281 3.73478 8.88281 4V5H6.88281V4ZM16.8828 4C16.8828 3.73478 16.9882 3.48043 17.1757 3.29289C17.3632 3.10536 17.6176 3 17.8828 3C18.148 3 18.4024 3.10536 18.5899 3.29289C18.7775 3.48043 18.8828 3.73478 18.8828 4V5H16.8828V4ZM7.88281 13V10.999H9.88281V13H7.88281ZM15.8828 13V10.999H17.8828V13H15.8828ZM11.8828 13V10.999H13.8838V13H11.8828ZM7.88281 17V15H9.88281V17H7.88281ZM11.8828 17V15H13.8838V17H11.8828ZM15.8828 17V15H17.8828V17H15.8828Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const DownloadIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 0H6L0 6V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM14 2V18H2V6.83L6.83 2H14Z"
          fill="#44546F"
        />
        <path
          d="M12 11L8 15L4 11L5.41 9.59L7 11.17V7.02L9 7V11.17L10.59 9.58L12 11Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const PdfIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 0H6C4.9 0 4 0.9 4 2V14C4 15.1 4.9 16 6 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H6V2H18V14ZM2 4H0V18C0 19.1 0.9 20 2 20H16V18H2V4ZM14 10V7C14 6.45 13.55 6 13 6H11V11H13C13.55 11 14 10.55 14 10ZM12 7H13V10H12V7ZM16 9H17V8H16V7H17V6H15V11H16V9ZM8 9H9C9.55 9 10 8.55 10 8V7C10 6.45 9.55 6 9 6H7V11H8V9ZM8 7H9V8H8V7Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};

export const UploadIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM3 5L4.41 6.41L7 3.83V12H9V3.83L11.59 6.41L13 5L8 0L3 5Z"
          fill="#44546F"
        />
      </svg>
    </>
  );
};
export const UnreadIcon = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 5.985V12.75C16.5 13.575 15.825 14.25 15 14.25H4.5L1.5 17.25V3.75C1.5 2.925 2.175 2.25 3 2.25H10.575C10.53 2.49 10.5 2.745 10.5 3C10.5 3.255 10.53 3.51 10.575 3.75H3V12.75H15V6.675C15.555 6.5625 16.065 6.315 16.5 5.985ZM12 3C12 4.245 13.005 5.25 14.25 5.25C15.495 5.25 16.5 4.245 16.5 3C16.5 1.755 15.495 0.75 14.25 0.75C13.005 0.75 12 1.755 12 3Z"
          fill="#788CA5"
        />
      </svg>
    </>
  );
};

export const Refrigeration = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ac_unit">
        <path
          id="Vector"
          d="M18.3332 9.16666H14.8582L17.5582 6.46666L16.3832 5.28332L12.4998 9.16666H10.8332V7.49999L14.7165 3.61666L13.5332 2.44166L10.8332 5.14166V1.66666H9.1665V5.14166L6.4665 2.44166L5.28317 3.61666L9.1665 7.49999V9.16666H7.49984L3.6165 5.28332L2.4415 6.46666L5.1415 9.16666H1.6665V10.8333H5.1415L2.4415 13.5333L3.6165 14.7167L7.49984 10.8333H9.1665V12.5L5.28317 16.3833L6.4665 17.5583L9.1665 14.8583V18.3333H10.8332V14.8583L13.5332 17.5583L14.7165 16.3833L10.8332 12.5V10.8333H12.4998L16.3832 14.7167L17.5582 13.5333L14.8582 10.8333H18.3332V9.16666Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const Project = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="assignment">
        <path
          id="Vector"
          d="M5.83333 13.3333H11.6667V15H5.83333V13.3333ZM5.83333 9.99999H14.1667V11.6667H5.83333V9.99999ZM5.83333 6.66666H14.1667V8.33332H5.83333V6.66666ZM15.8333 3.33332H12.35C12 2.36666 11.0833 1.66666 10 1.66666C8.91667 1.66666 8 2.36666 7.65 3.33332H4.16667C4.05 3.33332 3.94167 3.34166 3.83333 3.36666C3.50833 3.43332 3.21667 3.59999 2.99167 3.82499C2.84167 3.97499 2.71667 4.15832 2.63333 4.35832C2.55 4.54999 2.5 4.76666 2.5 4.99999V16.6667C2.5 16.8917 2.55 17.1167 2.63333 17.3167C2.71667 17.5167 2.84167 17.6917 2.99167 17.85C3.21667 18.075 3.50833 18.2417 3.83333 18.3083C3.94167 18.325 4.05 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6667V4.99999C17.5 4.08332 16.75 3.33332 15.8333 3.33332ZM10 3.12499C10.3417 3.12499 10.625 3.40832 10.625 3.74999C10.625 4.09166 10.3417 4.37499 10 4.37499C9.65833 4.37499 9.375 4.09166 9.375 3.74999C9.375 3.40832 9.65833 3.12499 10 3.12499ZM15.8333 16.6667H4.16667V4.99999H15.8333V16.6667Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const Electrical = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="electric_bolt">
        <path
          id="Vector"
          d="M12.2419 1.84169L3.60853 9.57502C3.0752 10.0584 3.3752 10.95 4.09186 11.0167L10.8335 11.6667L6.79186 17.3C6.60853 17.5584 6.63353 17.9167 6.85853 18.1417C7.10853 18.3917 7.5002 18.4 7.75853 18.1584L16.3919 10.425C16.9252 9.94169 16.6252 9.05002 15.9085 8.98335L9.16686 8.33335L13.2085 2.70002C13.3919 2.44169 13.3669 2.08335 13.1419 1.85835C12.8919 1.60835 12.5002 1.60002 12.2419 1.84169Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const Damage = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="report_problem">
        <path
          id="Vector"
          d="M9.99967 5.40831L16.2747 16.25H3.72467L9.99967 5.40831ZM9.99967 2.08331L0.833008 17.9166H19.1663L9.99967 2.08331ZM10.833 13.75H9.16634V15.4166H10.833V13.75ZM10.833 8.74998H9.16634V12.0833H10.833V8.74998Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};
export const DamageComments = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.8675L14.6475 14.625H3.3525L9 4.8675ZM9 1.875L0.75 16.125H17.25L9 1.875ZM9.75 12.375H8.25V13.875H9.75V12.375ZM9.75 7.875H8.25V10.875H9.75V7.875Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const Inspections = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="note_alt">
        <g id="Vector">
          <path
            d="M15.8333 3.33335H12.35C12 2.36669 11.0833 1.66669 10 1.66669C8.91667 1.66669 8 2.36669 7.65 3.33335H4.16667C3.25 3.33335 2.5 4.08335 2.5 5.00002V16.6667C2.5 17.5834 3.25 18.3334 4.16667 18.3334H15.8333C16.75 18.3334 17.5 17.5834 17.5 16.6667V5.00002C17.5 4.08335 16.75 3.33335 15.8333 3.33335ZM10 3.12502C10.3417 3.12502 10.625 3.40835 10.625 3.75002C10.625 4.09169 10.3417 4.37502 10 4.37502C9.65833 4.37502 9.375 4.09169 9.375 3.75002C9.375 3.40835 9.65833 3.12502 10 3.12502ZM15.8333 16.6667H4.16667V5.00002H15.8333V16.6667Z"
            fill="#44546F"
          />
          <path
            d="M12.5667 10.025L10.8 8.25835L5.83333 13.2167V15H7.58333L12.5667 10.025Z"
            fill="#44546F"
          />
          <path
            d="M14.0417 8.55835C14.2083 8.39169 14.2083 8.13335 14.0417 7.96669L12.8667 6.79169C12.7 6.62502 12.4417 6.62502 12.275 6.79169L11.3917 7.67502L13.1583 9.44169L14.0417 8.55835Z"
            fill="#44546F"
          />
        </g>
      </g>
    </svg>
  );
};
export const InspectionsComments = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 3H11.115C10.8 2.13 9.975 1.5 9 1.5C8.025 1.5 7.2 2.13 6.885 3H3.75C2.925 3 2.25 3.675 2.25 4.5V15C2.25 15.825 2.925 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM9 2.8125C9.3075 2.8125 9.5625 3.0675 9.5625 3.375C9.5625 3.6825 9.3075 3.9375 9 3.9375C8.6925 3.9375 8.4375 3.6825 8.4375 3.375C8.4375 3.0675 8.6925 2.8125 9 2.8125ZM14.25 15H3.75V4.5H14.25V15Z"
        fill="#44546F"
      />
      <path
        d="M11.31 9.0225L9.72 7.4325L5.25 11.895V13.5H6.825L11.31 9.0225Z"
        fill="#44546F"
      />
      <path
        d="M12.6375 7.7025C12.7875 7.5525 12.7875 7.32 12.6375 7.17L11.58 6.1125C11.43 5.9625 11.1975 5.9625 11.0475 6.1125L10.2525 6.9075L11.8425 8.4975L12.6375 7.7025Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const Mechanical = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="settings">
        <path
          id="Vector"
          d="M16.194 10.8167C16.2273 10.55 16.2523 10.2834 16.2523 10C16.2523 9.71669 16.2273 9.45002 16.194 9.18335L17.9523 7.80835C18.1106 7.68335 18.1523 7.45835 18.0523 7.27502L16.3856 4.39169C16.3106 4.25835 16.169 4.18335 16.019 4.18335C15.969 4.18335 15.919 4.19169 15.8773 4.20835L13.8023 5.04169C13.369 4.70835 12.9023 4.43335 12.394 4.22502L12.0773 2.01669C12.0523 1.81669 11.8773 1.66669 11.669 1.66669H8.33564C8.12731 1.66669 7.95231 1.81669 7.92731 2.01669L7.61064 4.22502C7.10231 4.43335 6.63564 4.71669 6.20231 5.04169L4.12731 4.20835C4.07731 4.19169 4.02731 4.18335 3.97731 4.18335C3.83564 4.18335 3.69397 4.25835 3.61897 4.39169L1.95231 7.27502C1.84397 7.45835 1.89397 7.68335 2.05231 7.80835L3.81064 9.18335C3.77731 9.45002 3.75231 9.72502 3.75231 10C3.75231 10.275 3.77731 10.55 3.81064 10.8167L2.05231 12.1917C1.89397 12.3167 1.85231 12.5417 1.95231 12.725L3.61897 15.6084C3.69397 15.7417 3.83564 15.8167 3.98564 15.8167C4.03564 15.8167 4.08564 15.8084 4.12731 15.7917L6.20231 14.9584C6.63564 15.2917 7.10231 15.5667 7.61064 15.775L7.92731 17.9834C7.95231 18.1834 8.12731 18.3334 8.33564 18.3334H11.669C11.8773 18.3334 12.0523 18.1834 12.0773 17.9834L12.394 15.775C12.9023 15.5667 13.369 15.2834 13.8023 14.9584L15.8773 15.7917C15.9273 15.8084 15.9773 15.8167 16.0273 15.8167C16.169 15.8167 16.3106 15.7417 16.3856 15.6084L18.0523 12.725C18.1523 12.5417 18.1106 12.3167 17.9523 12.1917L16.194 10.8167ZM14.544 9.39169C14.5773 9.65002 14.5856 9.82502 14.5856 10C14.5856 10.175 14.569 10.3584 14.544 10.6084L14.4273 11.55L15.169 12.1334L16.069 12.8334L15.4856 13.8417L14.4273 13.4167L13.5606 13.0667L12.8106 13.6334C12.4523 13.9 12.1106 14.1 11.769 14.2417L10.8856 14.6L10.7523 15.5417L10.5856 16.6667H9.41897L9.12731 14.6L8.24397 14.2417C7.88564 14.0917 7.55231 13.9 7.21897 13.65L6.46064 13.0667L5.57731 13.425L4.51897 13.85L3.93564 12.8417L4.83564 12.1417L5.57731 11.5584L5.46064 10.6167C5.43564 10.3584 5.41897 10.1667 5.41897 10C5.41897 9.83335 5.43564 9.64169 5.46064 9.39169L5.57731 8.45002L4.83564 7.86669L3.93564 7.16669L4.51897 6.15835L5.57731 6.58335L6.44397 6.93335L7.19397 6.36669C7.55231 6.10002 7.89397 5.90002 8.23564 5.75835L9.11897 5.40002L9.25231 4.45835L9.41897 3.33335H10.5773L10.869 5.40002L11.7523 5.75835C12.1106 5.90835 12.444 6.10002 12.7773 6.35002L13.5356 6.93335L14.419 6.57502L15.4773 6.15002L16.0606 7.15835L15.169 7.86669L14.4273 8.45002L14.544 9.39169ZM10.0023 6.66669C8.16064 6.66669 6.66897 8.15835 6.66897 10C6.66897 11.8417 8.16064 13.3334 10.0023 13.3334C11.844 13.3334 13.3356 11.8417 13.3356 10C13.3356 8.15835 11.844 6.66669 10.0023 6.66669ZM10.0023 11.6667C9.08564 11.6667 8.33564 10.9167 8.33564 10C8.33564 9.08335 9.08564 8.33335 10.0023 8.33335C10.919 8.33335 11.669 9.08335 11.669 10C11.669 10.9167 10.919 11.6667 10.0023 11.6667Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const Preventive = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="beenhere">
        <path
          id="Vector"
          d="M15.8333 0.833344H4.16667C3.25 0.833344 2.50833 1.58334 2.50833 2.50001L2.5 13.275C2.5 13.85 2.79167 14.3583 3.23333 14.6583L10 19.1667L16.7583 14.6583C17.2 14.3583 17.4917 13.85 17.4917 13.275L17.5 2.50001C17.5 1.58334 16.75 0.833344 15.8333 0.833344ZM10 17.1667L4.16667 13.2833V2.50001H15.8333V13.275L10 17.1667ZM8.325 10.9833L6.175 8.82501L5 10L8.33333 13.3333L15 6.66668L13.8167 5.48334L8.325 10.9833Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const Safety = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="shield">
        <path
          id="Vector"
          d="M9 1.5L3 3.75V8.3175C3 12.105 5.5575 15.6375 9 16.5C12.4425 15.6375 15 12.105 15 8.3175V3.75L9 1.5ZM13.5 8.3175C13.5 11.3175 11.5875 14.0925 9 14.94C6.4125 14.0925 4.5 11.325 4.5 8.3175V4.7925L9 3.105L13.5 4.7925V8.3175Z"
          fill="#44546F"
        />
      </g>
    </svg>
  );
};

export const OperationProcedure = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="inventory">
        <g id="Vector">
          <path
            d="M3.1875 4.5H4.6875V6.75H12.1875V4.5H13.6875V8.25H15.1875V4.5C15.1875 3.675 14.5125 3 13.6875 3H10.5525C10.2375 2.13 9.4125 1.5 8.4375 1.5C7.4625 1.5 6.6375 2.13 6.3225 3H3.1875C2.3625 3 1.6875 3.675 1.6875 4.5V15C1.6875 15.825 2.3625 16.5 3.1875 16.5H7.6875V15H3.1875V4.5ZM8.4375 3C8.85 3 9.1875 3.3375 9.1875 3.75C9.1875 4.1625 8.85 4.5 8.4375 4.5C8.025 4.5 7.6875 4.1625 7.6875 3.75C7.6875 3.3375 8.025 3 8.4375 3Z"
            fill="#44546F"
          />
          <path
            d="M15.1875 9.375L11.07 13.5L8.8125 11.25L7.6875 12.375L11.07 15.75L16.3125 10.5L15.1875 9.375Z"
            fill="#44546F"
          />
        </g>
      </g>
    </svg>
  );
};
export const ChecklistIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.5 5.65125H9.75V7.15125H16.5V5.65125ZM16.5 11.6513H9.75V13.1513H16.5V11.6513ZM4.155 8.65125L1.5 5.99625L2.5575 4.93876L4.1475 6.52875L7.3275 3.34875L8.385 4.40626L4.155 8.65125ZM4.155 14.6513L1.5 11.9963L2.5575 10.9388L4.1475 12.5288L7.3275 9.34875L8.385 10.4063L4.155 14.6513Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryDamage = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.8675L14.6475 13.625H3.3525L9 3.8675ZM9 0.875L0.75 15.125H17.25L9 0.875ZM9.75 11.375H8.25V12.875H9.75V11.375ZM9.75 6.875H8.25V9.875H9.75V6.875Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryInspection = ({ width = "14px", height = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 2H9.115C8.8 1.13 7.975 0.5 7 0.5C6.025 0.5 5.2 1.13 4.885 2H1.75C0.925 2 0.25 2.675 0.25 3.5V14C0.25 14.825 0.925 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM7 1.8125C7.3075 1.8125 7.5625 2.0675 7.5625 2.375C7.5625 2.6825 7.3075 2.9375 7 2.9375C6.6925 2.9375 6.4375 2.6825 6.4375 2.375C6.4375 2.0675 6.6925 1.8125 7 1.8125ZM12.25 14H1.75V3.5H12.25V14Z"
        fill="#44546F"
      />
      <path
        d="M9.31 8.0225L7.72 6.4325L3.25 10.895V12.5H4.825L9.31 8.0225Z"
        fill="#44546F"
      />
      <path
        d="M10.6375 6.7025C10.7875 6.5525 10.7875 6.32 10.6375 6.17L9.58 5.1125C9.43 4.9625 9.1975 4.9625 9.0475 5.1125L8.2525 5.9075L9.8425 7.4975L10.6375 6.7025Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryMechanical = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5741 8.735C13.6041 8.495 13.6266 8.255 13.6266 8C13.6266 7.745 13.6041 7.505 13.5741 7.265L15.1566 6.0275C15.2991 5.915 15.3366 5.7125 15.2466 5.5475L13.7466 2.9525C13.6791 2.8325 13.5516 2.765 13.4166 2.765C13.3716 2.765 13.3266 2.7725 13.2891 2.7875L11.4216 3.5375C11.0316 3.2375 10.6116 2.99 10.1541 2.8025L9.86909 0.815C9.84659 0.635 9.68909 0.5 9.50159 0.5H6.50159C6.31409 0.5 6.15659 0.635 6.13409 0.815L5.84909 2.8025C5.39159 2.99 4.97159 3.245 4.58159 3.5375L2.71409 2.7875C2.66909 2.7725 2.62409 2.765 2.57909 2.765C2.45159 2.765 2.32409 2.8325 2.25659 2.9525L0.756589 5.5475C0.659089 5.7125 0.704089 5.915 0.846589 6.0275L2.42909 7.265C2.39909 7.505 2.37659 7.7525 2.37659 8C2.37659 8.2475 2.39909 8.495 2.42909 8.735L0.846589 9.9725C0.704089 10.085 0.666589 10.2875 0.756589 10.4525L2.25659 13.0475C2.32409 13.1675 2.45159 13.235 2.58659 13.235C2.63159 13.235 2.67659 13.2275 2.71409 13.2125L4.58159 12.4625C4.97159 12.7625 5.39159 13.01 5.84909 13.1975L6.13409 15.185C6.15659 15.365 6.31409 15.5 6.50159 15.5H9.50159C9.68909 15.5 9.84659 15.365 9.86909 15.185L10.1541 13.1975C10.6116 13.01 11.0316 12.755 11.4216 12.4625L13.2891 13.2125C13.3341 13.2275 13.3791 13.235 13.4241 13.235C13.5516 13.235 13.6791 13.1675 13.7466 13.0475L15.2466 10.4525C15.3366 10.2875 15.2991 10.085 15.1566 9.9725L13.5741 8.735ZM12.0891 7.4525C12.1191 7.685 12.1266 7.8425 12.1266 8C12.1266 8.1575 12.1116 8.3225 12.0891 8.5475L11.9841 9.395L12.6516 9.92L13.4616 10.55L12.9366 11.4575L11.9841 11.075L11.2041 10.76L10.5291 11.27C10.2066 11.51 9.89909 11.69 9.59159 11.8175L8.79659 12.14L8.67659 12.9875L8.52659 14H7.47659L7.21409 12.14L6.41909 11.8175C6.09659 11.6825 5.79659 11.51 5.49659 11.285L4.81409 10.76L4.01909 11.0825L3.06659 11.465L2.54159 10.5575L3.35159 9.9275L4.01909 9.4025L3.91409 8.555C3.89159 8.3225 3.87659 8.15 3.87659 8C3.87659 7.85 3.89159 7.6775 3.91409 7.4525L4.01909 6.605L3.35159 6.08L2.54159 5.45L3.06659 4.5425L4.01909 4.925L4.79909 5.24L5.47409 4.73C5.79659 4.49 6.10409 4.31 6.41159 4.1825L7.20659 3.86L7.32659 3.0125L7.47659 2H8.51909L8.78159 3.86L9.57659 4.1825C9.89909 4.3175 10.1991 4.49 10.4991 4.715L11.1816 5.24L11.9766 4.9175L12.9291 4.535L13.4541 5.4425L12.6516 6.08L11.9841 6.605L12.0891 7.4525ZM8.00159 5C6.34409 5 5.00159 6.3425 5.00159 8C5.00159 9.6575 6.34409 11 8.00159 11C9.65909 11 11.0016 9.6575 11.0016 8C11.0016 6.3425 9.65909 5 8.00159 5ZM8.00159 9.5C7.17659 9.5 6.50159 8.825 6.50159 8C6.50159 7.175 7.17659 6.5 8.00159 6.5C8.82659 6.5 9.50159 7.175 9.50159 8C9.50159 8.825 8.82659 9.5 8.00159 9.5Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CatgoryPreventive = ({ width = "14px", height = "18px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 0.75H1.75C0.925 0.75 0.2575 1.425 0.2575 2.25L0.25 11.9475C0.25 12.465 0.5125 12.9225 0.91 13.1925L7 17.25L13.0825 13.1925C13.48 12.9225 13.7425 12.465 13.7425 11.9475L13.75 2.25C13.75 1.425 13.075 0.75 12.25 0.75ZM7 15.45L1.75 11.955V2.25H12.25V11.9475L7 15.45ZM5.4925 9.885L3.5575 7.9425L2.5 9L5.5 12L11.5 6L10.435 4.935L5.4925 9.885Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryProject = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 11H8.5V12.5H3.25V11ZM3.25 8H10.75V9.5H3.25V8ZM3.25 5H10.75V6.5H3.25V5ZM12.25 2H9.115C8.8 1.13 7.975 0.5 7 0.5C6.025 0.5 5.2 1.13 4.885 2H1.75C1.645 2 1.5475 2.0075 1.45 2.03C1.1575 2.09 0.895 2.24 0.6925 2.4425C0.5575 2.5775 0.445 2.7425 0.37 2.9225C0.295 3.095 0.25 3.29 0.25 3.5V14C0.25 14.2025 0.295 14.405 0.37 14.585C0.445 14.765 0.5575 14.9225 0.6925 15.065C0.895 15.2675 1.1575 15.4175 1.45 15.4775C1.5475 15.4925 1.645 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM7 1.8125C7.3075 1.8125 7.5625 2.0675 7.5625 2.375C7.5625 2.6825 7.3075 2.9375 7 2.9375C6.6925 2.9375 6.4375 2.6825 6.4375 2.375C6.4375 2.0675 6.6925 1.8125 7 1.8125ZM12.25 14H1.75V3.5H12.25V14Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryRefrigeration = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 7.25H12.3725L14.8025 4.82L13.745 3.755L10.25 7.25H8.75V5.75L12.245 2.255L11.18 1.1975L8.75 3.6275V0.5H7.25V3.6275L4.82 1.1975L3.755 2.255L7.25 5.75V7.25H5.75L2.255 3.755L1.1975 4.82L3.6275 7.25H0.5V8.75H3.6275L1.1975 11.18L2.255 12.245L5.75 8.75H7.25V10.25L3.755 13.745L4.82 14.8025L7.25 12.3725V15.5H8.75V12.3725L11.18 14.8025L12.245 13.745L8.75 10.25V8.75H10.25L13.745 12.245L14.8025 11.18L12.3725 8.75H15.5V7.25Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const RedFlag = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90667 3.66683L8.17333 5.00016H11.6667V9.00016H9.42667L9.16 7.66683H4.33333V3.66683H7.90667ZM9 2.3335H3V13.6668H4.33333V9.00016H8.06667L8.33333 10.3335H13V3.66683H9.26667L9 2.3335Z"
        fill="#D14040"
      />
    </svg>
  );
};

export const YellowFlag = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90667 3.66683L8.17333 5.00016H11.6667V9.00016H9.42667L9.16 7.66683H4.33333V3.66683H7.90667ZM9 2.3335H3V13.6668H4.33333V9.00016H8.06667L8.33333 10.3335H13V3.66683H9.26667L9 2.3335Z"
        fill="#E2B203"
      />
    </svg>
  );
};
export const GreenFlag = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90667 3.66683L8.17333 5.00016H11.6667V9.00016H9.42667L9.16 7.66683H4.33333V3.66683H7.90667ZM9 2.3335H3V13.6668H4.33333V9.00016H8.06667L8.33333 10.3335H13V3.66683H9.26667L9 2.3335Z"
        fill="#4FAB68"
      />
    </svg>
  );
};
export const CostIconEstimate = ({ width = "6px", height = "6px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 3H6" stroke="#0C66E4" stroke-width="5" />
    </svg>
  );
};
export const POPriceIcon = ({
  width = "6px",
  height = "6px",
  color = "#0C66E4",
}) => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4H9" stroke={color} stroke-width="7" />
    </svg>
  );
};

export const GreenLine = ({ width = "6px", height = "6px" }) => {
  return (
    <svg
      width="19"
      height="4"
      viewBox="0 0 19 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 2H19" stroke="#4FAB68" stroke-width="3" />
    </svg>
  );
};

export const RedIcon = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H4.5"
        stroke="#D14040"
        stroke-width="7"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const OrangeIcon = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 4H4"
        stroke="#F17F16"
        stroke-width="7"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const GreenIcon = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H4.5"
        stroke="#4FAB68"
        stroke-width="7"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const TimeIconEstimate = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 3H6" stroke="#063270" stroke-width="5" />
    </svg>
  );
};

export const MaintenanceCostIcon = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4H9" stroke="#9CC2F7" stroke-width="7" />
    </svg>
  );
};

export const DisposeCostIcon = ({ width = "16px", height = "16px" }) => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4H9" stroke="#5494EE" stroke-width="7" />
    </svg>
  );
};

export const CategorySafety = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.5L0 2.75V7.3175C0 11.105 2.5575 14.6375 6 15.5C9.4425 14.6375 12 11.105 12 7.3175V2.75L6 0.5ZM10.5 7.3175C10.5 10.3175 8.5875 13.0925 6 13.94C3.4125 13.0925 1.5 10.325 1.5 7.3175V3.7925L6 2.105L10.5 3.7925V7.3175Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const CategorySafety1 = ({ width = "10px", height = "10px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99996 0.833496L1.66663 2.0835V4.621C1.66663 6.72516 3.08746 8.68766 4.99996 9.16683C6.91246 8.68766 8.33329 6.72516 8.33329 4.621V2.0835L4.99996 0.833496ZM7.49996 4.621C7.49996 6.28766 6.43746 7.82933 4.99996 8.30016C3.56246 7.82933 2.49996 6.29183 2.49996 4.621V2.66266L4.99996 1.72516L7.49996 2.66266V4.621Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CategoryOperation = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1875 3.5H3.6875V5.75H11.1875V3.5H12.6875V7.25H14.1875V3.5C14.1875 2.675 13.5125 2 12.6875 2H9.5525C9.2375 1.13 8.4125 0.5 7.4375 0.5C6.4625 0.5 5.6375 1.13 5.3225 2H2.1875C1.3625 2 0.6875 2.675 0.6875 3.5V14C0.6875 14.825 1.3625 15.5 2.1875 15.5H6.6875V14H2.1875V3.5ZM7.4375 2C7.85 2 8.1875 2.3375 8.1875 2.75C8.1875 3.1625 7.85 3.5 7.4375 3.5C7.025 3.5 6.6875 3.1625 6.6875 2.75C6.6875 2.3375 7.025 2 7.4375 2Z"
        fill="#44546F"
      />
      <path
        d="M14.1875 8.375L10.07 12.5L7.8125 10.25L6.6875 11.375L10.07 14.75L15.3125 9.5L14.1875 8.375Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const CheckboxIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 2.25H3C2.175 2.25 1.5 2.925 1.5 3.75V14.25C1.5 15.075 2.175 15.75 3 15.75H15C15.825 15.75 16.5 15.075 16.5 14.25V3.75C16.5 2.925 15.825 2.25 15 2.25ZM15 14.25H3V3.75H15V14.25Z"
        fill="#44546F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5575 7.815L13.4925 6.75L11.115 9.1275L10.0575 8.0625L9 9.12L11.115 11.25L14.5575 7.815Z"
        fill={fill}
      />
      <path d="M7.5 5.25H3.75V6.75H7.5V5.25Z" fill="#44546F" />
      <path d="M7.5 8.25H3.75V9.75H7.5V8.25Z" fill="#44546F" />
      <path d="M7.5 11.25H3.75V12.75H7.5V11.25Z" fill="#44546F" />
    </svg>
  );
};
export const TextIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.25 13.5H6.75V12H2.25V13.5ZM2.25 4.5V6H15.75V4.5H2.25ZM2.25 9.75H11.25V8.25H2.25V9.75Z"
        fill={fill}
      />
    </svg>
  );
};

export const NumberIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.375 7.5L15.75 6H12.75L13.5 3H12L11.25 6H8.25L9 3H7.5L6.75 6H3.75L3.375 7.5H6.375L5.625 10.5H2.625L2.25 12H5.25L4.5 15H6L6.75 12H9.75L9 15H10.5L11.25 12H14.25L14.625 10.5H11.625L12.375 7.5H15.375ZM10.125 10.5H7.125L7.875 7.5H10.875L10.125 10.5Z"
        fill={fill}
      />
    </svg>
  );
};
export const AmountIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.25 10.5V4.5C14.25 3.675 13.575 3 12.75 3H2.25C1.425 3 0.75 3.675 0.75 4.5V10.5C0.75 11.325 1.425 12 2.25 12H12.75C13.575 12 14.25 11.325 14.25 10.5ZM12.75 10.5H2.25V4.5H12.75V10.5ZM7.5 5.25C6.255 5.25 5.25 6.255 5.25 7.5C5.25 8.745 6.255 9.75 7.5 9.75C8.745 9.75 9.75 8.745 9.75 7.5C9.75 6.255 8.745 5.25 7.5 5.25ZM17.25 5.25V13.5C17.25 14.325 16.575 15 15.75 15H3V13.5H15.75V5.25H17.25Z"
        fill={fill}
      />
    </svg>
  );
};
export const MultipleChoiceIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.25 5.25H12.75V6.75H8.25V5.25ZM8.25 8.25H12.75V9.75H8.25V8.25ZM8.25 11.25H12.75V12.75H8.25V11.25ZM5.25 5.25H6.75V6.75H5.25V5.25ZM5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM15.075 2.25H2.925C2.55 2.25 2.25 2.55 2.25 2.925V15.075C2.25 15.375 2.55 15.75 2.925 15.75H15.075C15.375 15.75 15.75 15.375 15.75 15.075V2.925C15.75 2.55 15.375 2.25 15.075 2.25ZM14.25 14.25H3.75V3.75H14.25V14.25Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const InspectionIcon = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3.1875 4.5H4.6875V6.75H12.1875V4.5H13.6875V8.25H15.1875V4.5C15.1875 3.675 14.5125 3 13.6875 3H10.5525C10.2375 2.13 9.4125 1.5 8.4375 1.5C7.4625 1.5 6.6375 2.13 6.3225 3H3.1875C2.3625 3 1.6875 3.675 1.6875 4.5V15C1.6875 15.825 2.3625 16.5 3.1875 16.5H7.6875V15H3.1875V4.5ZM8.4375 3C8.85 3 9.1875 3.3375 9.1875 3.75C9.1875 4.1625 8.85 4.5 8.4375 4.5C8.025 4.5 7.6875 4.1625 7.6875 3.75C7.6875 3.3375 8.025 3 8.4375 3Z"
        fill="#44546F"
      />
      <path
        d="M15.1875 9.375L11.07 13.5L8.8125 11.25L7.6875 12.375L11.07 15.75L16.3125 10.5L15.1875 9.375Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const SignatureIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.3268 7.7925L15.1218 6.9975C15.7068 6.4125 15.7068 5.46 15.1218 4.875L14.0643 3.8175C13.4793 3.2325 12.5268 3.2325 11.9418 3.8175L11.1468 4.6125L14.3268 7.7925ZM11.1468 8.8575L5.74683 14.25H4.68933V13.1925L10.0818 7.8L11.1468 8.8575ZM10.0818 5.67L3.18933 12.57V15.75H6.36933L13.2618 8.8575L10.0818 5.67ZM14.4393 13.125C14.4393 14.7675 12.5343 15.75 10.6893 15.75C10.2768 15.75 9.93933 15.4125 9.93933 15C9.93933 14.5875 10.2768 14.25 10.6893 14.25C11.8443 14.25 12.9393 13.7025 12.9393 13.125C12.9393 12.7725 12.5793 12.4725 12.0168 12.225L13.1268 11.115C13.9293 11.5875 14.4393 12.2175 14.4393 13.125ZM3.62433 10.0125C2.89683 9.5925 2.43933 9.045 2.43933 8.25C2.43933 6.9 3.85683 6.2775 5.10933 5.73C5.88183 5.385 6.93933 4.92 6.93933 4.5C6.93933 4.1925 6.35433 3.75 5.43933 3.75C4.49433 3.75 4.08933 4.2075 4.06683 4.23C3.80433 4.5375 3.33183 4.575 3.01683 4.32C2.70933 4.065 2.64933 3.6075 2.90433 3.285C2.98683 3.18 3.75933 2.25 5.43933 2.25C7.11933 2.25 8.43933 3.24 8.43933 4.5C8.43933 5.9025 6.99183 6.54 5.70933 7.1025C5.00433 7.41 3.93933 7.875 3.93933 8.25C3.93933 8.4825 4.26183 8.7 4.74183 8.895L3.62433 10.0125Z"
        fill={fill}
      />
    </svg>
  );
};

export const DateIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.25 3H13.5V1.5H12V3H6V1.5H4.5V3H3.75C2.9175 3 2.2575 3.675 2.2575 4.5L2.25 15C2.25 15.825 2.9175 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM14.25 15H3.75V7.5H14.25V15ZM14.25 6H3.75V4.5H14.25V6ZM6.75 10.5H5.25V9H6.75V10.5ZM9.75 10.5H8.25V9H9.75V10.5ZM12.75 10.5H11.25V9H12.75V10.5ZM6.75 13.5H5.25V12H6.75V13.5ZM9.75 13.5H8.25V12H9.75V13.5ZM12.75 13.5H11.25V12H12.75V13.5Z"
        fill={fill}
      />
    </svg>
  );
};
export const FileIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12 4.5V13.125C12 14.7825 10.6575 16.125 9 16.125C7.3425 16.125 6 14.7825 6 13.125V3.75C6 2.715 6.84 1.875 7.875 1.875C8.91 1.875 9.75 2.715 9.75 3.75V11.625C9.75 12.0375 9.4125 12.375 9 12.375C8.5875 12.375 8.25 12.0375 8.25 11.625V4.5H7.125V11.625C7.125 12.66 7.965 13.5 9 13.5C10.035 13.5 10.875 12.66 10.875 11.625V3.75C10.875 2.0925 9.5325 0.75 7.875 0.75C6.2175 0.75 4.875 2.0925 4.875 3.75V13.125C4.875 15.405 6.72 17.25 9 17.25C11.28 17.25 13.125 15.405 13.125 13.125V4.5H12Z"
        fill={fill}
      />
    </svg>
  );
};
export const PhotoIcon = ({
  width = "18px",
  height = "18px",
  fill = "#44546F",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.25 3.75V14.25H3.75V3.75H14.25ZM14.25 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.075 2.25 14.25 2.25ZM10.605 8.895L8.355 11.7975L6.75 9.855L4.5 12.75H13.5L10.605 8.895Z"
        fill={fill}
      />
    </svg>
  );
};

export const HeadingIcon = ({
  width = "18px",
  height = "18px",
  fill = '"#44546F"',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.08337 3.75V6.25H6.25004V16.25H8.75004V6.25H12.9167V3.75H2.08337ZM17.9167 7.91667H10.4167V10.4167H12.9167V16.25H15.4167V10.4167H17.9167V7.91667Z"
        fill={fill}
      />
    </svg>
  );
};

export const CloseIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const FilesIcon = ({ width = "40", height = "40" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7399 2.95215H8.88851C7.25894 2.95215 5.92566 4.2806 5.92566 5.90426V29.5211C5.92566 31.1448 7.25894 32.4732 8.88851 32.4732H26.6656C28.2952 32.4732 29.6285 31.1448 29.6285 29.5211V11.8085L20.7399 2.95215ZM26.6656 29.5211H8.88851V5.90426H20.7399V11.8085H26.6656V29.5211ZM17.7771 25.093C16.1475 25.093 14.8142 23.7645 14.8142 22.1408V14.0225C14.8142 13.6093 15.1401 13.2845 15.5549 13.2845C15.9697 13.2845 16.2956 13.6093 16.2956 14.0225V22.1408H19.2585V14.0225C19.2585 11.9856 17.5993 10.3324 15.5549 10.3324C13.5106 10.3324 11.8514 11.9856 11.8514 14.0225V22.1408C11.8514 25.4029 14.5031 28.0451 17.7771 28.0451C21.051 28.0451 23.7028 25.4029 23.7028 22.1408V16.2366H20.7399V22.1408C20.7399 23.7645 19.4066 25.093 17.7771 25.093Z"
        fill="#788CA5"
      />
      <path
        d="M29.4122 20.6587C24.5418 20.6587 20.589 24.5971 20.589 29.4499C20.589 34.3026 24.5418 38.2411 29.4122 38.2411C34.2826 38.2411 38.2354 34.3026 38.2354 29.4499C38.2354 24.5971 34.2826 20.6587 29.4122 20.6587ZM33.8238 30.329H30.2945V33.8455H28.5299V30.329H25.0006V28.5708H28.5299V25.0543H30.2945V28.5708H33.8238V30.329Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const DownloadPdfIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19ZM13 12.67L15.59 10.09L17 11.5L12 16.5L7 11.5L8.41 10.09L11 12.67V3H13V12.67Z"
        fill="#E9F2FF"
      />
    </svg>
  );
};
export const SendVendorIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.51 6.03L11.02 9.25L3.5 8.25L3.51 6.03ZM11.01 14.75L3.5 17.97V15.75L11.01 14.75ZM1.51 3L1.5 10L16.5 12L1.5 14L1.51 21L22.5 12L1.51 3Z"
        fill="#E9F2FF"
      />
    </svg>
  );
};

export const DeleteIcon = ({
  width = "24px",
  height = "24px",
  fill = "#788CA5",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill={fill}
      />
    </svg>
  );
};
export const AddedFileIcon = ({
  width = "24px",
  height = "24px",
  fill = "#788CA5",
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3333 6.66667V25.3333H6.66667V6.66667H25.3333ZM25.3333 4H6.66667C5.2 4 4 5.2 4 6.66667V25.3333C4 26.8 5.2 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V6.66667C28 5.2 26.8 4 25.3333 4ZM18.8533 15.8133L14.8533 20.9733L12 17.52L8 22.6667H24L18.8533 15.8133Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const EditTextIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.93384 8.5H13.9338V10.5H2.93384V8.5ZM2.93384 6.5H13.9338V4.5H2.93384V6.5ZM2.93384 14.5H9.93384V12.5H2.93384V14.5ZM17.9438 11.37L18.6538 10.66C19.0438 10.27 19.6738 10.27 20.0638 10.66L20.7738 11.37C21.1638 11.76 21.1638 12.39 20.7738 12.78L20.0638 13.49L17.9438 11.37ZM17.2338 12.08L11.9338 17.38V19.5H14.0538L19.3538 14.2L17.2338 12.08Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const ShareIcon = ({
  width = "24px",
  height = "24px",
  fill = "#44546F",
}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M18 16.12C17.24 16.12 16.56 16.42 16.04 16.89L8.91 12.74C8.96 12.51 9 12.28 9 12.04C9 11.8 8.96 11.57 8.91 11.34L15.96 7.23004C16.5 7.73004 17.21 8.04004 18 8.04004C19.66 8.04004 21 6.70004 21 5.04004C21 3.38004 19.66 2.04004 18 2.04004C16.34 2.04004 15 3.38004 15 5.04004C15 5.28004 15.04 5.51004 15.09 5.74004L8.04 9.85004C7.5 9.35004 6.79 9.04004 6 9.04004C4.34 9.04004 3 10.38 3 12.04C3 13.7 4.34 15.04 6 15.04C6.79 15.04 7.5 14.73 8.04 14.23L15.16 18.39C15.11 18.6 15.08 18.82 15.08 19.04C15.08 20.65 16.39 21.96 18 21.96C19.61 21.96 20.92 20.65 20.92 19.04C20.92 17.43 19.61 16.12 18 16.12ZM18 4.04004C18.55 4.04004 19 4.49004 19 5.04004C19 5.59004 18.55 6.04004 18 6.04004C17.45 6.04004 17 5.59004 17 5.04004C17 4.49004 17.45 4.04004 18 4.04004ZM6 13.04C5.45 13.04 5 12.59 5 12.04C5 11.49 5.45 11.04 6 11.04C6.55 11.04 7 11.49 7 12.04C7 12.59 6.55 13.04 6 13.04ZM18 20.06C17.45 20.06 17 19.61 17 19.06C17 18.51 17.45 18.06 18 18.06C18.55 18.06 19 18.51 19 19.06C19 19.61 18.55 20.06 18 20.06Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export const FileDownloadIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V20H6V8.83L10.83 4H18Z"
        fill="#788CA5"
      />
      <path
        d="M16 13L12 17L8 13L9.41 11.59L11 13.17V9.02L13 9V13.17L14.59 11.58L16 13Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const DownloadIconBucket = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19ZM13 12.67L15.59 10.09L17 11.5L12 16.5L7 11.5L8.41 10.09L11 12.67V3H13V12.67Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const CategoryElectrical = ({ width = "12px", height = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.01738 0.657507L0.247384 7.61751C-0.232616 8.05251 0.0373838 8.85501 0.682384 8.91501L6.74988 9.50001L3.11238 14.57C2.94738 14.8025 2.96988 15.125 3.17238 15.3275C3.39738 15.5525 3.74988 15.56 3.98238 15.3425L11.7524 8.38251C12.2324 7.94751 11.9624 7.14501 11.3174 7.08501L5.24988 6.50001L8.88738 1.43001C9.05238 1.19751 9.02988 0.875007 8.82738 0.672507C8.60238 0.447507 8.24988 0.440007 8.01738 0.657507Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const Attachment = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6666 1.66667H4.99992C4.08325 1.66667 3.33325 2.41667 3.33325 3.33334V16.6667C3.33325 17.5833 4.08325 18.3333 4.99992 18.3333H14.9999C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V6.66667L11.6666 1.66667ZM14.9999 16.6667H4.99992V3.33334H11.6666V6.66667H14.9999V16.6667ZM9.99992 14.1667C9.08325 14.1667 8.33325 13.4167 8.33325 12.5V7.91667C8.33325 7.68334 8.51659 7.50001 8.74992 7.50001C8.98325 7.50001 9.16658 7.68334 9.16658 7.91667V12.5H10.8333V7.91667C10.8333 6.76667 9.89992 5.83334 8.74992 5.83334C7.59992 5.83334 6.66659 6.76667 6.66659 7.91667V12.5C6.66659 14.3417 8.15825 15.8333 9.99992 15.8333C11.8416 15.8333 13.3333 14.3417 13.3333 12.5V9.16667H11.6666V12.5C11.6666 13.4167 10.9166 14.1667 9.99992 14.1667Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const Success = ({ width = "65px", height = "64px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M32.0013 10.6667C20.2413 10.6667 10.668 20.2401 10.668 32.0001C10.668 43.7601 20.2413 53.3334 32.0013 53.3334C43.7613 53.3334 53.3346 43.7601 53.3346 32.0001C53.3346 20.2401 43.7613 10.6667 32.0013 10.6667ZM26.668 45.3334L16.0013 34.6667L19.7613 30.9067L26.668 37.7867L44.2413 20.2134L48.0013 24.0001L26.668 45.3334Z"
        fill="#4FAB68"
      />
      <path
        d="M31.9987 5.33325C17.2787 5.33325 5.33203 17.2799 5.33203 31.9999C5.33203 46.7199 17.2787 58.6666 31.9987 58.6666C46.7187 58.6666 58.6654 46.7199 58.6654 31.9999C58.6654 17.2799 46.7187 5.33325 31.9987 5.33325ZM31.9987 53.3333C20.2387 53.3333 10.6654 43.7599 10.6654 31.9999C10.6654 20.2399 20.2387 10.6666 31.9987 10.6666C43.7587 10.6666 53.332 20.2399 53.332 31.9999C53.332 43.7599 43.7587 53.3333 31.9987 53.3333ZM44.2387 20.2133L26.6654 37.7866L19.7587 30.9066L15.9987 34.6666L26.6654 45.3333L47.9987 23.9999L44.2387 20.2133Z"
        fill="#4FAB68"
      />
    </svg>
  );
};
export const SuccessToastIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
        fill="#4FAB68"
      />
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
        fill="#4FAB68"
      />
    </svg>
  );
};

export const GreenLocationIcon = ({ width = "65px", height = "64px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 65 64"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M32.5003 10.6667C25.1403 10.6667 19.167 16.64 19.167 24C19.167 31.6 26.9537 43.2267 32.5003 50.3467C38.127 43.1733 45.8337 31.68 45.8337 24C45.8337 16.64 39.8603 10.6667 32.5003 10.6667ZM32.5003 30.6667C28.8203 30.6667 25.8337 27.68 25.8337 24C25.8337 20.32 28.8203 17.3334 32.5003 17.3334C36.1803 17.3334 39.167 20.32 39.167 24C39.167 27.68 36.1803 30.6667 32.5003 30.6667Z"
        fill="#4FAB68"
      />
      <path
        d="M32.4997 5.33331C22.1797 5.33331 13.833 13.68 13.833 24C13.833 38 32.4997 58.6666 32.4997 58.6666C32.4997 58.6666 51.1663 38 51.1663 24C51.1663 13.68 42.8197 5.33331 32.4997 5.33331ZM19.1663 24C19.1663 16.64 25.1397 10.6666 32.4997 10.6666C39.8597 10.6666 45.833 16.64 45.833 24C45.833 31.68 38.153 43.1733 32.4997 50.3466C26.953 43.2266 19.1663 31.6 19.1663 24Z"
        fill="#4FAB68"
      />
      <path
        d="M32.4997 30.6666C36.1816 30.6666 39.1663 27.6819 39.1663 24C39.1663 20.3181 36.1816 17.3333 32.4997 17.3333C28.8178 17.3333 25.833 20.3181 25.833 24C25.833 27.6819 28.8178 30.6666 32.4997 30.6666Z"
        fill="#4FAB68"
      />
    </svg>
  );
};

export const Close = ({ width = "65px", height = "64px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 65 64"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M32.4993 10.6667C20.7393 10.6667 11.166 20.2401 11.166 32.0001C11.166 43.7601 20.7393 53.3334 32.4993 53.3334C44.2593 53.3334 53.8327 43.7601 53.8327 32.0001C53.8327 20.2401 44.2593 10.6667 32.4993 10.6667ZM43.166 38.9067L39.406 42.6667L32.4993 35.7601L25.5927 42.6667L21.8327 38.9067L28.7393 32.0001L21.8327 25.0934L25.5927 21.3334L32.4993 28.2401L39.406 21.3334L43.166 25.0934L36.2593 32.0001L43.166 38.9067Z"
        fill="#D14040"
      />
      <path
        d="M39.4073 21.3333L32.5007 28.2399L25.594 21.3333L21.834 25.0933L28.7407 31.9999L21.834 38.9066L25.594 42.6666L32.5007 35.7599L39.4073 42.6666L43.1673 38.9066L36.2607 31.9999L43.1673 25.0933L39.4073 21.3333ZM32.5007 5.33325C17.754 5.33325 5.83398 17.2533 5.83398 31.9999C5.83398 46.7466 17.754 58.6666 32.5007 58.6666C47.2473 58.6666 59.1673 46.7466 59.1673 31.9999C59.1673 17.2533 47.2473 5.33325 32.5007 5.33325ZM32.5007 53.3333C20.7407 53.3333 11.1673 43.7599 11.1673 31.9999C11.1673 20.2399 20.7407 10.6666 32.5007 10.6666C44.2607 10.6666 53.834 20.2399 53.834 31.9999C53.834 43.7599 44.2607 53.3333 32.5007 53.3333Z"
        fill="#D14040"
      />
    </svg>
  );
};

export const ArrowLeft = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.0047 10.995L13.5977 6.40199C13.6893 6.30854 13.7985 6.23416 13.919 6.18318C14.0395 6.13219 14.1689 6.10559 14.2998 6.10493C14.4306 6.10427 14.5603 6.12956 14.6813 6.17932C14.8023 6.22909 14.9123 6.30236 15.0048 6.39488C15.0973 6.48741 15.1706 6.59736 15.2204 6.71837C15.2701 6.83939 15.2954 6.96907 15.2948 7.09992C15.2941 7.23077 15.2675 7.36019 15.2165 7.48069C15.1655 7.6012 15.0912 7.7104 14.9977 7.80199L11.0977 11.702L14.9977 15.602C15.1803 15.7883 15.2819 16.0391 15.2806 16.2999C15.2793 16.5607 15.1751 16.8105 14.9907 16.995C14.8062 17.1794 14.5565 17.2836 14.2956 17.2849C14.0348 17.2862 13.784 17.1846 13.5977 17.002L9.0047 12.41C8.81723 12.2225 8.71191 11.9682 8.71191 11.703C8.71191 11.4378 8.81723 11.1835 9.0047 10.996V10.995Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const MemberIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.5 11.4582C5.55 11.4582 1.66667 12.4332 1.66667 14.3748V15.8332H13.3333V14.3748C13.3333 12.4332 9.45 11.4582 7.5 11.4582ZM3.61667 14.1665C4.31667 13.6832 6.00833 13.1248 7.5 13.1248C8.99167 13.1248 10.6833 13.6832 11.3833 14.1665H3.61667ZM7.5 9.99984C9.10834 9.99984 10.4167 8.6915 10.4167 7.08317C10.4167 5.47484 9.10834 4.1665 7.5 4.1665C5.89167 4.1665 4.58333 5.47484 4.58333 7.08317C4.58333 8.6915 5.89167 9.99984 7.5 9.99984ZM7.5 5.83317C8.19167 5.83317 8.75 6.3915 8.75 7.08317C8.75 7.77484 8.19167 8.33317 7.5 8.33317C6.80833 8.33317 6.25 7.77484 6.25 7.08317C6.25 6.3915 6.80833 5.83317 7.5 5.83317ZM13.3667 11.5082C14.3333 12.2082 15 13.1415 15 14.3748V15.8332H18.3333V14.3748C18.3333 12.6915 15.4167 11.7332 13.3667 11.5082ZM12.5 9.99984C14.1083 9.99984 15.4167 8.6915 15.4167 7.08317C15.4167 5.47484 14.1083 4.1665 12.5 4.1665C12.05 4.1665 11.6333 4.27484 11.25 4.45817C11.775 5.19984 12.0833 6.10817 12.0833 7.08317C12.0833 8.05817 11.775 8.9665 11.25 9.70817C11.6333 9.8915 12.05 9.99984 12.5 9.99984Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const AdminIcon = ({ width = "38px", height = "38px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
      <path
        d="M19 9C13.48 9 9 13.48 9 19C9 24.52 13.48 29 19 29C24.52 29 29 24.52 29 19C29 13.48 24.52 9 19 9ZM14.35 25.5C15.66 24.56 17.26 24 19 24C20.74 24 22.34 24.56 23.65 25.5C22.34 26.44 20.74 27 19 27C17.26 27 15.66 26.44 14.35 25.5ZM25.14 24.12C23.45 22.8 21.32 22 19 22C16.68 22 14.55 22.8 12.86 24.12C11.7 22.73 11 20.95 11 19C11 14.58 14.58 11 19 11C23.42 11 27 14.58 27 19C27 20.95 26.3 22.73 25.14 24.12Z"
        fill="#44546F"
      />
      <path
        d="M19 13C17.07 13 15.5 14.57 15.5 16.5C15.5 18.43 17.07 20 19 20C20.93 20 22.5 18.43 22.5 16.5C22.5 14.57 20.93 13 19 13ZM19 18C18.17 18 17.5 17.33 17.5 16.5C17.5 15.67 18.17 15 19 15C19.83 15 20.5 15.67 20.5 16.5C20.5 17.33 19.83 18 19 18Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const LimitedAdminIcon = ({ width = "38px", height = "38px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
      <path
        d="M23 22.62C23.6186 22.62 24.12 22.1186 24.12 21.5C24.12 20.8814 23.6186 20.38 23 20.38C22.3814 20.38 21.88 20.8814 21.88 21.5C21.88 22.1186 22.3814 22.62 23 22.62Z"
        fill="#44546F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23 23.5C22.27 23.5 20.81 23.86 20.76 24.58C21.26 25.29 22.08 25.75 23 25.75C23.92 25.75 24.74 25.29 25.24 24.58C25.19 23.86 23.73 23.5 23 23.5Z"
        fill="#44546F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 17.09V12.27L16.5 9L9 12.27V17.18C9 21.72 12.2 25.97 16.5 27C17.05 26.87 17.58 26.68 18.1 26.45C19.18 27.99 20.97 29 23 29C26.31 29 29 26.31 29 23C29 20.03 26.84 17.57 24 17.09ZM17 23C17 23.56 17.08 24.11 17.23 24.62C16.99 24.73 16.75 24.84 16.5 24.92C13.33 23.92 11 20.68 11 17.18V13.58L16.5 11.18L22 13.58V17.09C19.16 17.57 17 20.03 17 23ZM23 27C20.79 27 19 25.21 19 23C19 20.79 20.79 19 23 19C25.21 19 27 20.79 27 23C27 25.21 25.21 27 23 27Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const TechnicianIcon = ({ width = "38px", height = "38px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 9C13.48 9 9 13.48 9 19C9 24.52 13.48 29 19 29C24.52 29 29 24.52 29 19C29 13.48 24.52 9 19 9ZM19 27C14.59 27 11 23.41 11 19C11 14.59 14.59 11 19 11C23.41 11 27 14.59 27 19C27 23.41 23.41 27 19 27Z"
        fill="#44546F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.49 18.38C20.92 17.16 20.66 15.74 19.68 14.76C18.57 13.65 16.89 13.46 15.58 14.17L17.93 16.52L16.52 17.93L14.17 15.58C13.46 16.9 13.65 18.57 14.76 19.68C15.74 20.66 17.16 20.92 18.38 20.49L21.79 23.9C21.99 24.1 22.3 24.1 22.5 23.9L23.9 22.5C24.1 22.3 24.1 21.99 23.9 21.79L20.49 18.38Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const ViewerIcon = ({ width = "38px", height = "38px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
      <path
        d="M26 10H12C10.89 10 10 10.9 10 12V26C10 27.1 10.89 28 12 28H26C27.1 28 28 27.1 28 26V12C28 10.9 27.11 10 26 10ZM26 26H12V14H26V26ZM19 17.5C20.84 17.5 22.48 18.46 23.34 20C22.48 21.54 20.84 22.5 19 22.5C17.16 22.5 15.52 21.54 14.66 20C15.52 18.46 17.16 17.5 19 17.5ZM19 16C16.27 16 13.94 17.66 13 20C13.94 22.34 16.27 24 19 24C21.73 24 24.06 22.34 25 20C24.06 17.66 21.73 16 19 16ZM19 21.5C18.17 21.5 17.5 20.83 17.5 20C17.5 19.17 18.17 18.5 19 18.5C19.83 18.5 20.5 19.17 20.5 20C20.5 20.83 19.83 21.5 19 21.5Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const RequesterIcon = ({ width = "38px", height = "38px" }) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="19" r="19" fill="#E4E6EA" />
      <path
        d="M19 9C13.48 9 9 13.48 9 19C9 24.52 13.48 29 19 29C24.52 29 29 24.52 29 19C29 13.48 24.52 9 19 9ZM14.35 25.5C15.66 24.56 17.26 24 19 24C20.74 24 22.34 24.56 23.65 25.5C22.34 26.44 20.74 27 19 27C17.26 27 15.66 26.44 14.35 25.5ZM25.14 24.12C23.45 22.8 21.32 22 19 22C16.68 22 14.55 22.8 12.86 24.12C11.7 22.73 11 20.95 11 19C11 14.58 14.58 11 19 11C23.42 11 27 14.58 27 19C27 20.95 26.3 22.73 25.14 24.12Z"
        fill="#44546F"
      />
      <path
        d="M19 13C17.07 13 15.5 14.57 15.5 16.5C15.5 18.43 17.07 20 19 20C20.93 20 22.5 18.43 22.5 16.5C22.5 14.57 20.93 13 19 13ZM19 18C18.17 18 17.5 17.33 17.5 16.5C17.5 15.67 18.17 15 19 15C19.83 15 20.5 15.67 20.5 16.5C20.5 17.33 19.83 18 19 18Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const ArrowRight = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.9947 10.995C15.1821 11.1825 15.2875 11.4368 15.2875 11.702C15.2875 11.9672 15.1821 12.2215 14.9947 12.409L10.4017 17.002C10.2154 17.1846 9.96458 17.2862 9.70375 17.2849C9.44292 17.2836 9.19315 17.1794 9.00871 16.995C8.82428 16.8105 8.72008 16.5608 8.71876 16.2999C8.71745 16.0391 8.81911 15.7883 9.00168 15.602L12.9017 11.702L9.00168 7.80201C8.81911 7.61572 8.71745 7.36491 8.71876 7.10408C8.72008 6.84325 8.82428 6.59348 9.00871 6.40904C9.19315 6.22461 9.44292 6.12041 9.70375 6.11909C9.96458 6.11777 10.2154 6.21944 10.4017 6.40201L14.9947 10.995Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const AddIcon = ({
  width = "24px",
  height = "24px",
  fill = "#0C66E4",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8333 10.8333H10.8333V15.8333H9.16667V10.8333H4.16667V9.16666H9.16667V4.16666H10.8333V9.16666H15.8333V10.8333Z"
        fill={fill}
      />
    </svg>
  );
};

export const CopyIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.75 0.833344H3.74998C2.83331 0.833344 2.08331 1.58334 2.08331 2.50001V14.1667H3.74998V2.50001H13.75V0.833344ZM16.25 4.16668H7.08331C6.16665 4.16668 5.41665 4.91668 5.41665 5.83334V17.5C5.41665 18.4167 6.16665 19.1667 7.08331 19.1667H16.25C17.1666 19.1667 17.9166 18.4167 17.9166 17.5V5.83334C17.9166 4.91668 17.1666 4.16668 16.25 4.16668ZM16.25 17.5H7.08331V5.83334H16.25V17.5Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const FlagIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.895 4.125L9.195 5.625H13.125V10.125H10.605L10.305 8.625H4.875V4.125H8.895ZM10.125 2.625H3.375V15.375H4.875V10.125H9.075L9.375 11.625H14.625V4.125H10.425L10.125 2.625Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const FlagWhiteIcon = ({ color = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.90667 3.66665L8.17333 4.99998H11.6667V8.99998H9.42667L9.16 7.66665H4.33333V3.66665H7.90667ZM9 2.33331H3V13.6666H4.33333V8.99998H8.06667L8.33333 10.3333H13V3.66665H9.26667L9 2.33331Z"
        fill={color}
      />
    </svg>
  );
};

export const FlagwithFilled = ({ color = "white" }) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.26667 1.66659L6 0.333252H0V11.6666H1.33333V6.99992H5.06667L5.33333 8.33325H10V1.66659H6.26667Z"
        fill={color}
      />
    </svg>
  );
};
export const AddIconWithCircle = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const DocImg = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7116 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM2.88501 13.0862V9.28178C3.21323 9.23 3.64117 9.20133 4.09247 9.20133C4.84296 9.20133 5.32961 9.33356 5.71064 9.61511C6.12113 9.914 6.37885 10.3909 6.37885 11.0749C6.37885 11.8162 6.10323 12.3278 5.7222 12.6438C5.30581 12.9829 4.67296 13.1438 3.89935 13.1438C3.43581 13.1436 3.1076 13.1151 2.88501 13.0862ZM6.78232 11.1956C6.78232 10.0347 7.53871 9.16667 8.70491 9.16667C9.91848 9.16667 10.5806 10.0576 10.5806 11.1264C10.5806 12.3967 9.79517 13.1667 8.64031 13.1667C7.46799 13.1667 6.78232 12.2989 6.78232 11.1956ZM13.1888 12.4367C13.4583 12.4367 13.7575 12.3793 13.9337 12.3102L14.0683 12.9942C13.904 13.0747 13.5347 13.1609 13.054 13.1609C11.6881 13.1609 10.9845 12.3276 10.9845 11.224C10.9845 9.90222 11.946 9.16644 13.1424 9.16644C13.605 9.16644 13.957 9.25844 14.1152 9.33889L13.9337 10.0344C13.7514 9.95978 13.4996 9.89067 13.1832 9.89067C12.4735 9.89067 11.9224 10.3102 11.9224 11.1722C11.9227 11.9484 12.3919 12.4367 13.1888 12.4367ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#0C66E4"
      />
      <path
        d="M9.63736 11.1554C9.63736 10.4601 9.29736 9.8623 8.68174 9.8623C8.0779 9.8623 7.72656 10.4256 7.72656 11.1783C7.72656 11.937 8.08991 12.4714 8.68786 12.4714C9.29124 12.4714 9.63736 11.9081 9.63736 11.1554Z"
        fill="#0C66E4"
      />
      <path
        d="M4.18562 9.87402C3.98638 9.87402 3.85741 9.89136 3.78125 9.90847V12.4429C3.85741 12.4602 3.98072 12.4602 4.09201 12.4602C4.90076 12.466 5.42844 12.0294 5.42844 11.1038C5.43456 10.2994 4.9538 9.87402 4.18562 9.87402Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const CsvImg = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7617 0.626889C11.2674 0.142222 10.9169 0 10.2181 0H1.35637C0.382613 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382613 20 1.35637 20H15.6436C16.6174 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8549 5.62 16.3606 5.13533L11.7617 0.626889ZM15.8136 18.4824C15.8136 18.7371 15.7114 18.8369 15.4519 18.8369H1.54813C1.28837 18.8369 1.18637 18.7369 1.18637 18.4824V14.1807H15.8136V18.4824ZM5.63017 12.4413C5.89991 12.4413 6.19933 12.3838 6.37568 12.3149L6.51055 12.9998C6.34644 13.0802 5.97629 13.1667 5.49508 13.1667C4.1276 13.1667 3.42267 12.3322 3.42267 11.2269C3.42267 9.90311 4.38577 9.16667 5.58325 9.16667C6.04701 9.16667 6.39925 9.25889 6.55769 9.33933L6.37568 10.0358C6.19367 9.96111 5.94116 9.892 5.62428 9.892C4.91391 9.892 4.36197 10.3122 4.36197 11.1756C4.36197 11.9522 4.83163 12.4413 5.63017 12.4413ZM8.08316 11.4802C7.42583 11.2558 6.9972 10.8989 6.9972 10.3349C6.9972 9.67311 7.56069 9.16667 8.49411 9.16667C8.94041 9.16667 9.26885 9.25889 9.50391 9.36244L9.30467 10.0702C9.146 9.99556 8.86425 9.886 8.47688 9.886C8.08951 9.886 7.9016 10.0587 7.9016 10.2602C7.9016 10.5076 8.12464 10.6169 8.63532 10.8069C9.33413 11.06 9.66257 11.4171 9.66257 11.9638C9.66257 12.6142 9.15212 13.1667 8.06593 13.1667C7.61396 13.1667 7.16743 13.0516 6.94461 12.9307L7.12663 12.2056C7.36712 12.3264 7.73681 12.4473 8.11852 12.4473C8.52947 12.4473 8.74661 12.2804 8.74661 12.0271C8.74639 11.7853 8.55871 11.6473 8.08316 11.4802ZM9.93185 9.23H10.9122L11.3936 10.8702C11.5285 11.3307 11.652 11.7738 11.7461 12.2573H11.7635C11.8633 11.7911 11.9864 11.3307 12.1217 10.8876L12.6265 9.23H13.5773L12.2445 13.1091H11.1996L9.93185 9.23ZM15.8136 8.15267H1.18637V1.51756C1.18637 1.26289 1.28837 1.16311 1.54813 1.16311H10.5799C10.7095 1.16311 10.7608 1.21311 10.7608 1.34022V4.78711C10.7608 5.74178 11.1434 6.11689 12.1169 6.11689H15.6327C15.7626 6.11689 15.8136 6.16711 15.8136 6.29422V8.15267Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const DocxImg = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.79492 11.0229V11.1538C7.79492 11.297 7.7819 11.4246 7.75586 11.5366C7.73112 11.6473 7.69401 11.741 7.64453 11.8179C7.59505 11.8947 7.53385 11.9526 7.46094 11.9917C7.38932 12.0308 7.30729 12.0503 7.21484 12.0503C7.11849 12.0503 7.03385 12.0308 6.96094 11.9917C6.88932 11.9526 6.82878 11.8947 6.7793 11.8179C6.72982 11.741 6.69206 11.6473 6.66602 11.5366C6.64128 11.4246 6.62891 11.297 6.62891 11.1538V11.0229C6.62891 10.8784 6.64128 10.7508 6.66602 10.6401C6.69206 10.5282 6.72917 10.4344 6.77734 10.3589C6.82682 10.2834 6.88737 10.2267 6.95898 10.189C7.0306 10.1499 7.11458 10.1304 7.21094 10.1304C7.30339 10.1304 7.38607 10.1499 7.45898 10.189C7.5319 10.2267 7.5931 10.2834 7.64258 10.3589C7.69206 10.4344 7.72982 10.5282 7.75586 10.6401C7.7819 10.7508 7.79492 10.8784 7.79492 11.0229Z"
        fill="#0C66E4"
      />
      <path
        d="M4.10938 12.019H4.37305C4.51497 12.019 4.63477 11.9865 4.73242 11.9214C4.83008 11.855 4.9043 11.7573 4.95508 11.6284C5.00586 11.4982 5.03125 11.34 5.03125 11.1538V11.0229C5.03125 10.8823 5.01693 10.7586 4.98828 10.6519C4.95964 10.5438 4.91732 10.4533 4.86133 10.3804C4.80534 10.3075 4.73568 10.2528 4.65234 10.2163C4.57031 10.1799 4.47591 10.1616 4.36914 10.1616H4.10938V12.019Z"
        fill="#0C66E4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2183 0C10.9171 0 11.2675 0.142226 11.7619 0.626893L16.3606 5.13534C16.8547 5.62 17 5.96333 17 6.64867V18.6702C17 19.6249 16.6176 20 15.6436 20H1.35639C0.382618 20 0 19.6249 0 18.6702V1.32978C0 0.375112 0.382618 0 1.35639 0H10.2183ZM15.4521 18.8369C15.7118 18.8369 15.8138 18.7371 15.8138 18.4824L15.8136 14.1807H1.18639V18.4824C1.18639 18.7369 1.28839 18.8369 1.54815 18.8369H15.4521ZM1.18639 8.15267H15.8138V6.29423C15.8138 6.16711 15.7628 6.11689 15.633 6.11689H12.1171C11.1435 6.11689 10.7609 5.74178 10.7609 4.78711V1.34022C10.7609 1.21311 10.7097 1.16311 10.58 1.16311H1.54815C1.28816 1.16311 1.18639 1.26289 1.18639 1.51756V8.15267ZM10.4629 11.5581H11.0957C11.0853 11.7534 11.0319 11.9259 10.9355 12.0757C10.8405 12.2241 10.7083 12.3407 10.5391 12.4253C10.3698 12.5086 10.1686 12.5503 9.93555 12.5503C9.74935 12.5503 9.58268 12.5184 9.43555 12.4546C9.28841 12.3908 9.16341 12.2996 9.06055 12.1812C8.95898 12.0614 8.88086 11.9175 8.82617 11.7495C8.77279 11.5802 8.74609 11.3895 8.74609 11.1772V11.0034C8.74609 10.7912 8.77409 10.6004 8.83008 10.4312C8.88607 10.2619 8.96615 10.1174 9.07031 9.99756C9.17448 9.87777 9.29948 9.78597 9.44531 9.72217C9.59115 9.65837 9.75391 9.62646 9.93359 9.62646C10.1758 9.62646 10.3802 9.67008 10.5469 9.75732C10.7135 9.84456 10.8424 9.96436 10.9336 10.1167C11.026 10.269 11.0814 10.4429 11.0996 10.6382H10.4648C10.4596 10.5275 10.4388 10.4344 10.4023 10.3589C10.3659 10.2821 10.3099 10.2241 10.2344 10.1851C10.1589 10.146 10.0586 10.1265 9.93359 10.1265C9.84245 10.1265 9.76237 10.1434 9.69336 10.1772C9.62565 10.2111 9.56901 10.2638 9.52344 10.3354C9.47917 10.4071 9.44596 10.4982 9.42383 10.6089C9.40169 10.7183 9.39062 10.8485 9.39062 10.9995V11.1772C9.39062 11.327 9.40039 11.4565 9.41992 11.5659C9.43945 11.6753 9.4707 11.7658 9.51367 11.8374C9.55794 11.909 9.61458 11.9624 9.68359 11.9976C9.7526 12.0327 9.83659 12.0503 9.93555 12.0503C10.0488 12.0503 10.1432 12.0327 10.2188 11.9976C10.2943 11.9611 10.3522 11.9064 10.3926 11.8335C10.4329 11.7606 10.4564 11.6688 10.4629 11.5581ZM8.4375 11.1538V11.0269C8.4375 10.8107 8.40755 10.6167 8.34766 10.4448C8.28776 10.2716 8.20312 10.1245 8.09375 10.0034C7.98568 9.88232 7.85677 9.78988 7.70703 9.72607C7.55729 9.66097 7.39193 9.62842 7.21094 9.62842C7.02995 9.62842 6.86458 9.66097 6.71484 9.72607C6.5651 9.78988 6.43555 9.88232 6.32617 10.0034C6.2181 10.1245 6.13411 10.2716 6.07422 10.4448C6.01432 10.6167 5.98438 10.8107 5.98438 11.0269V11.1538C5.98438 11.37 6.01432 11.564 6.07422 11.7358C6.13411 11.9077 6.21875 12.0542 6.32812 12.1753C6.4388 12.2964 6.56901 12.3895 6.71875 12.4546C6.86849 12.5184 7.03385 12.5503 7.21484 12.5503C7.39583 12.5503 7.56055 12.5184 7.70898 12.4546C7.85872 12.3895 7.98763 12.2964 8.0957 12.1753C8.20508 12.0542 8.28906 11.9077 8.34766 11.7358C8.40755 11.564 8.4375 11.37 8.4375 11.1538ZM4.37305 12.5112C4.56445 12.5112 4.73958 12.4787 4.89844 12.4136C5.05729 12.3485 5.19466 12.256 5.31055 12.1362C5.42773 12.0151 5.51823 11.8719 5.58203 11.7065C5.64583 11.5399 5.67773 11.3556 5.67773 11.1538V11.0269C5.67773 10.8237 5.64583 10.6395 5.58203 10.4741C5.51823 10.3088 5.42773 10.1655 5.31055 10.0444C5.19466 9.92334 5.05664 9.83024 4.89648 9.76514C4.73763 9.70003 4.56185 9.66748 4.36914 9.66748H3.47266V12.5112H4.37305ZM12.4883 10.6362L11.9883 9.66748H11.2617L12.0723 11.0776L11.2402 12.5112H11.9746L12.4883 11.5249L13.0039 12.5112H13.7363L12.9062 11.0776L13.7148 9.66748H12.9883L12.4883 10.6362Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const PngPhotos = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11.14 8.86L8.14 12.73L6 10.14L3 14H15L11.14 8.86Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const TxtFile = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7619 0.626889C11.2675 0.142222 10.9171 0 10.2183 0H1.35639C0.382618 0 0 0.375111 0 1.32978V18.6702C0 19.6249 0.382618 20 1.35639 20H15.6436C16.6176 20 17 19.6249 17 18.6702V6.64867C17 5.96333 16.8547 5.62 16.3606 5.13533L11.7619 0.626889ZM15.8138 18.4824C15.8138 18.7371 15.7118 18.8369 15.4521 18.8369H1.54815C1.28839 18.8369 1.18639 18.7369 1.18639 18.4824V14.1807H15.8136L15.8138 18.4824ZM3.34655 9.92622V9.16667H6.4823V9.92622H5.36822V13.1667H4.44227V9.92622H3.34655ZM6.82049 9.16667H7.87949L8.23672 9.89667C8.35777 10.14 8.44866 10.3358 8.54545 10.5613H8.55769C8.65448 10.306 8.7329 10.128 8.83604 9.89667L9.18103 9.16667H10.2341L9.08401 11.1193L10.2949 13.1667H9.22954L8.86029 12.4427C8.7091 12.1638 8.61209 11.9562 8.49694 11.7247H8.48493C8.39993 11.9562 8.29724 12.1638 8.17008 12.4427L7.83098 13.1667H6.77788L7.95815 11.1429L6.82049 9.16667ZM10.5179 9.92622V9.16667H13.6537V9.92622H12.5398V13.1667H11.6139V9.92622H10.5179ZM15.8138 8.15267H1.18639V1.51756C1.18639 1.26289 1.28816 1.16311 1.54815 1.16311H10.58C10.7097 1.16311 10.7609 1.21311 10.7609 1.34022V4.78711C10.7609 5.74178 11.1435 6.11689 12.1171 6.11689H15.633C15.7628 6.11689 15.8138 6.16711 15.8138 6.29422V8.15267Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const Mp4File = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 5V13L12 9L7 5ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};
export const XlsxFile = ({ width = "33px", height = "33px" }) => {
  return (
    <>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.2183 0C10.9171 0 11.2675 0.142226 11.7619 0.626893L16.3606 5.13534C16.8547 5.62 17 5.96333 17 6.64867V18.6702C17 19.6249 16.6176 20 15.6436 20H1.35639C0.382618 20 0 19.6249 0 18.6702V1.32978C0 0.375112 0.382618 0 1.35639 0H10.2183ZM15.4521 18.8369C15.7118 18.8369 15.8138 18.7371 15.8138 18.4824L15.8136 14.1807H1.18639V18.4824C1.18639 18.7369 1.28839 18.8369 1.54815 18.8369H15.4521ZM1.18639 8.15267H15.8138V6.29423C15.8138 6.16711 15.7628 6.11689 15.633 6.11689H12.1171C11.1435 6.11689 10.7609 5.74178 10.7609 4.78711V1.34022C10.7609 1.21311 10.7097 1.16311 10.58 1.16311H1.54815C1.28816 1.16311 1.18639 1.26289 1.18639 1.51756V8.15267ZM10.4395 11.5737C10.4395 11.5135 10.4305 11.4598 10.4126 11.4126C10.3947 11.3638 10.3621 11.319 10.3149 11.2783C10.2677 11.2376 10.201 11.1969 10.1147 11.1562C10.0285 11.1139 9.91536 11.0708 9.77539 11.0269C9.61589 10.9748 9.4637 10.9162 9.31885 10.8511C9.17562 10.7843 9.04785 10.707 8.93555 10.6191C8.82324 10.5312 8.73454 10.4287 8.66943 10.3115C8.60596 10.1943 8.57422 10.0576 8.57422 9.90137C8.57422 9.75 8.60758 9.61328 8.67432 9.49121C8.74105 9.36914 8.83464 9.26497 8.95508 9.17871C9.07552 9.09082 9.21712 9.02409 9.37988 8.97852C9.54264 8.93132 9.72168 8.90771 9.91699 8.90771C10.1774 8.90771 10.4061 8.9541 10.603 9.04688C10.8016 9.13802 10.9562 9.2666 11.0669 9.43262C11.1776 9.597 11.2329 9.78825 11.2329 10.0063H10.4419C10.4419 9.91032 10.4215 9.82568 10.3809 9.75244C10.3418 9.67757 10.2816 9.61898 10.2002 9.57666C10.1204 9.53434 10.0203 9.51318 9.8999 9.51318C9.78271 9.51318 9.68425 9.53109 9.60449 9.56689C9.52637 9.60107 9.46696 9.64827 9.42627 9.7085C9.38721 9.76872 9.36768 9.83464 9.36768 9.90625C9.36768 9.96322 9.38232 10.0153 9.41162 10.0625C9.44255 10.1081 9.48649 10.1512 9.54346 10.1919C9.60205 10.231 9.67367 10.2684 9.7583 10.3042C9.84294 10.34 9.93978 10.3742 10.0488 10.4067C10.2393 10.467 10.4077 10.5337 10.5542 10.6069C10.7023 10.6802 10.8268 10.7632 10.9277 10.856C11.0286 10.9487 11.1043 11.0537 11.1548 11.1709C11.2069 11.2881 11.2329 11.4207 11.2329 11.5688C11.2329 11.7267 11.202 11.8667 11.1401 11.9888C11.0799 12.1108 10.992 12.215 10.8765 12.3013C10.7625 12.3859 10.6258 12.4502 10.4663 12.4941C10.3068 12.5381 10.1286 12.5601 9.93164 12.5601C9.7526 12.5601 9.57601 12.5373 9.40186 12.4917C9.2277 12.4445 9.06982 12.3729 8.92822 12.2769C8.78825 12.1808 8.67594 12.0588 8.59131 11.9106C8.5083 11.7609 8.4668 11.5835 8.4668 11.3784H9.2627C9.2627 11.4858 9.27816 11.577 9.30908 11.6519C9.34001 11.7251 9.38395 11.7845 9.44092 11.8301C9.49951 11.8757 9.57031 11.9082 9.65332 11.9277C9.73633 11.9473 9.8291 11.957 9.93164 11.957C10.0505 11.957 10.1465 11.9408 10.2197 11.9082C10.2946 11.874 10.3499 11.8276 10.3857 11.769C10.4215 11.7104 10.4395 11.6453 10.4395 11.5737ZM4.00146 10.1675L3.37646 8.95654H2.46826L3.48145 10.7192L2.44141 12.5112H3.35938L4.00146 11.2783L4.646 12.5112H5.56152L4.52393 10.7192L5.53467 8.95654H4.62646L4.00146 10.1675ZM8.20557 12.5112V11.896H6.68213V8.95654H5.88623V12.5112H8.20557ZM13.0005 10.1675L12.3755 8.95654H11.4673L12.4805 10.7192L11.4404 12.5112H12.3584L13.0005 11.2783L13.645 12.5112H14.5605L13.5229 10.7192L14.5337 8.95654H13.6255L13.0005 10.1675Z"
          fill="#0C66E4"
        />
      </svg>
    </>
  );
};

export const BarcodeIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2143 10.5H18.5V13.5C18.5 13.7761 18.2122 14 17.8571 14H14V13H17.2143V10.5ZM1.78571 10.5H0.5V13.5C0.5 13.7761 0.787842 14 1.14286 14H5V13H1.78571V10.5ZM17.8571 0H14V1H17.2143V3.5H18.5V0.5C18.5 0.223877 18.2122 0 17.8571 0ZM0.5 0.5V3.5H1.78571V1H5V0H1.14286C0.787842 0 0.5 0.223877 0.5 0.5ZM14.6429 2.5V11.5H15.9286V2.5H14.6429ZM14 2.5H12.7143V11.5H14V2.5ZM10.1429 11.5H11.4286V2.5H10.1429V11.5ZM8.21429 11.5H9.5V2.5H8.21429V11.5ZM5.64286 11.5H6.92857V2.5H5.64286V11.5ZM3.07143 2.5V11.5H4.35714V2.5H3.07143Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const QRcodeIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 4.875V7.125H4.875V4.875H7.125ZM8.25 3.75H3.75V8.25H8.25V3.75ZM7.125 10.875V13.125H4.875V10.875H7.125ZM8.25 9.75H3.75V14.25H8.25V9.75ZM13.125 4.875V7.125H10.875V4.875H13.125ZM14.25 3.75H9.75V8.25H14.25V3.75ZM9.75 9.75H10.875V10.875H9.75V9.75ZM10.875 10.875H12V12H10.875V10.875ZM12 9.75H13.125V10.875H12V9.75ZM9.75 12H10.875V13.125H9.75V12ZM10.875 13.125H12V14.25H10.875V13.125ZM12 12H13.125V13.125H12V12ZM13.125 10.875H14.25V12H13.125V10.875ZM13.125 13.125H14.25V14.25H13.125V13.125ZM16.5 5.25H15V3H12.75V1.5H16.5V5.25ZM16.5 16.5V12.75H15V15H12.75V16.5H16.5ZM1.5 16.5H5.25V15H3V12.75H1.5V16.5ZM1.5 1.5V5.25H3V3H5.25V1.5H1.5Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const QRcodeIconInactive = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 4.875V7.125H4.875V4.875H7.125ZM8.25 3.75H3.75V8.25H8.25V3.75ZM7.125 10.875V13.125H4.875V10.875H7.125ZM8.25 9.75H3.75V14.25H8.25V9.75ZM13.125 4.875V7.125H10.875V4.875H13.125ZM14.25 3.75H9.75V8.25H14.25V3.75ZM9.75 9.75H10.875V10.875H9.75V9.75ZM10.875 10.875H12V12H10.875V10.875ZM12 9.75H13.125V10.875H12V9.75ZM9.75 12H10.875V13.125H9.75V12ZM10.875 13.125H12V14.25H10.875V13.125ZM12 12H13.125V13.125H12V12ZM13.125 10.875H14.25V12H13.125V10.875ZM13.125 13.125H14.25V14.25H13.125V13.125ZM16.5 5.25H15V3H12.75V1.5H16.5V5.25ZM16.5 16.5V12.75H15V15H12.75V16.5H16.5ZM1.5 16.5H5.25V15H3V12.75H1.5V16.5ZM1.5 1.5V5.25H3V3H5.25V1.5H1.5Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const InfoIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33337 4.66659H8.66671V5.99992H7.33337V4.66659ZM7.33337 7.33325H8.66671V11.3333H7.33337V7.33325ZM8.00004 1.33325C4.32004 1.33325 1.33337 4.31992 1.33337 7.99992C1.33337 11.6799 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.6799 14.6667 7.99992C14.6667 4.31992 11.68 1.33325 8.00004 1.33325ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.9399 2.66671 7.99992C2.66671 5.05992 5.06004 2.66659 8.00004 2.66659C10.94 2.66659 13.3334 5.05992 13.3334 7.99992C13.3334 10.9399 10.94 13.3333 8.00004 13.3333Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const InfoIconBlue = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33331 4.66659H8.66665V5.99992H7.33331V4.66659ZM7.33331 7.33325H8.66665V11.3333H7.33331V7.33325ZM7.99998 1.33325C4.31998 1.33325 1.33331 4.31992 1.33331 7.99992C1.33331 11.6799 4.31998 14.6666 7.99998 14.6666C11.68 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.68 1.33325 7.99998 1.33325ZM7.99998 13.3333C5.05998 13.3333 2.66665 10.9399 2.66665 7.99992C2.66665 5.05992 5.05998 2.66659 7.99998 2.66659C10.94 2.66659 13.3333 5.05992 13.3333 7.99992C13.3333 10.9399 10.94 13.3333 7.99998 13.3333Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const POIconBlue = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M13.3332 22.6665C13.3332 18.2532 16.9198 14.6665 21.3332 14.6665H25.3332V6.6665H22.6665V10.6665H9.33317V6.6665H6.6665V25.3332H13.3332V22.6665Z"
        fill="#0C66E4"
      />
      <path
        d="M13.3333 25.3333H6.66667V6.66658H9.33333V10.6666H22.6667V6.66658H25.3333V14.6666H28V6.66658C28 5.19992 26.8 3.99992 25.3333 3.99992H19.76C19.2 2.45325 17.7333 1.33325 16 1.33325C14.2667 1.33325 12.8 2.45325 12.24 3.99992H6.66667C5.2 3.99992 4 5.19992 4 6.66658V25.3333C4 26.7999 5.2 27.9999 6.66667 27.9999H13.3333V25.3333ZM16 3.99992C16.7333 3.99992 17.3333 4.59992 17.3333 5.33325C17.3333 6.06659 16.7333 6.66658 16 6.66658C15.2667 6.66658 14.6667 6.06659 14.6667 5.33325C14.6667 4.59992 15.2667 3.99992 16 3.99992Z"
        fill="#0C66E4"
      />
      <path
        d="M24.0133 17.3333L22.12 19.2133L24.2267 21.3199H16V23.9866H24.2267L22.12 26.1066L24.0133 27.9866L29.3333 22.6533L24.0133 17.3333Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const ClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="#788CA5"
      />
      <path
        d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const AssetDisposeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const PriceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM17 14H3V6H17V14ZM10 7C8.34 7 7 8.34 7 10C7 11.66 8.34 13 10 13C11.66 13 13 11.66 13 10C13 8.34 11.66 7 10 7ZM23 7V18C23 19.1 22.1 20 21 20H4V18H21V7H23Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const PercentageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 4C5.57 4 4 5.57 4 7.5C4 9.43 5.57 11 7.5 11C9.43 11 11 9.43 11 7.5C11 5.57 9.43 4 7.5 4ZM7.5 9C6.67 9 6 8.33 6 7.5C6 6.67 6.67 6 7.5 6C8.33 6 9 6.67 9 7.5C9 8.33 8.33 9 7.5 9ZM16.5 13C14.57 13 13 14.57 13 16.5C13 18.43 14.57 20 16.5 20C18.43 20 20 18.43 20 16.5C20 14.57 18.43 13 16.5 13ZM16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18ZM5.41 20L4 18.59L18.59 4L20 5.41L5.41 20Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const DetailsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 16H14V18H7V16ZM7 12H17V14H7V12ZM7 8H17V10H7V8ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const ItemsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM19 19H5V5H19V19Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const CalenderGreyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const LogicIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3333 2.49959C11.0333 2.49959 9.16667 4.36626 9.16667 6.66626V13.3329C9.16667 14.7163 8.05 15.8329 6.66667 15.8329C5.28333 15.8329 4.16667 14.7163 4.16667 13.3329V7.49959H4.85833C6.2 7.49959 7.40833 6.51626 7.5 5.17459C7.6 3.76626 6.53333 2.59126 5.16667 2.49959C3.7 2.40792 2.5 3.68292 2.5 5.15792V13.3329C2.5 15.6329 4.36667 17.4996 6.66667 17.4996C8.96667 17.4996 10.8333 15.6329 10.8333 13.3329V6.66626C10.8333 5.28292 11.95 4.16626 13.3333 4.16626C14.7167 4.16626 15.8333 5.28292 15.8333 6.66626V12.4996H15.1417C13.8 12.4996 12.5917 13.4829 12.5 14.8246C12.4 16.2329 13.4667 17.4079 14.8333 17.4996C16.3 17.5996 17.5 16.3163 17.5 14.8496V6.66626C17.5 4.36626 15.6333 2.49959 13.3333 2.49959ZM4.16667 4.99959C4.16667 4.54126 4.54167 4.16626 5 4.16626C5.45833 4.16626 5.83333 4.54126 5.83333 4.99959C5.83333 5.45792 5.45833 5.83292 5 5.83292H4.16667V4.99959ZM15.8333 14.9996C15.8333 15.4579 15.4583 15.8329 15 15.8329C14.5417 15.8329 14.1667 15.4579 14.1667 14.9996C14.1667 14.5413 14.5417 14.1663 15 14.1663H15.8333V14.9996Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const FilePresentIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6663 1.66699H4.99967C4.08301 1.66699 3.33301 2.41699 3.33301 3.33366V16.667C3.33301 17.5837 4.08301 18.3337 4.99967 18.3337H14.9997C15.9163 18.3337 16.6663 17.5837 16.6663 16.667V6.66699L11.6663 1.66699ZM14.9997 16.667H4.99967V3.33366H11.6663V6.66699H14.9997V16.667ZM9.99967 14.167C9.08301 14.167 8.33301 13.417 8.33301 12.5003V7.91699C8.33301 7.68366 8.51634 7.50033 8.74967 7.50033C8.98301 7.50033 9.16634 7.68366 9.16634 7.91699V12.5003H10.833V7.91699C10.833 6.76699 9.89967 5.83366 8.74967 5.83366C7.59967 5.83366 6.66634 6.76699 6.66634 7.91699V12.5003C6.66634 14.342 8.15801 15.8337 9.99967 15.8337C11.8413 15.8337 13.333 14.342 13.333 12.5003V9.16699H11.6663V12.5003C11.6663 13.417 10.9163 14.167 9.99967 14.167Z"
        fill="#788CA5"
      />
      <path
        d="M15.3304 10.4014C12.5907 10.4014 10.3672 12.6249 10.3672 15.3646C10.3672 18.1043 12.5907 20.3278 15.3304 20.3278C18.0701 20.3278 20.2937 18.1043 20.2937 15.3646C20.2937 12.6249 18.0701 10.4014 15.3304 10.4014ZM17.812 15.8609H15.8267V17.8462H14.8341V15.8609H12.8488V14.8683H14.8341V12.883H15.8267V14.8683H17.812V15.8609Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const FilePresentGreyIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6663 1.66675H4.99967C4.08301 1.66675 3.33301 2.41675 3.33301 3.33341V16.6667C3.33301 17.5834 4.08301 18.3334 4.99967 18.3334H14.9997C15.9163 18.3334 16.6663 17.5834 16.6663 16.6667V6.66675L11.6663 1.66675ZM14.9997 16.6667H4.99967V3.33341H11.6663V6.66675H14.9997V16.6667ZM9.99967 14.1667C9.08301 14.1667 8.33301 13.4167 8.33301 12.5001V7.91675C8.33301 7.68341 8.51634 7.50008 8.74967 7.50008C8.98301 7.50008 9.16634 7.68341 9.16634 7.91675V12.5001H10.833V7.91675C10.833 6.76675 9.89967 5.83342 8.74967 5.83342C7.59967 5.83342 6.66634 6.76675 6.66634 7.91675V12.5001C6.66634 14.3417 8.15801 15.8334 9.99967 15.8334C11.8413 15.8334 13.333 14.3417 13.333 12.5001V9.16675H11.6663V12.5001C11.6663 13.4167 10.9163 14.1667 9.99967 14.1667Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const EditChatIcon = ({
  width = "15",
  height = "15",
  color = "#788CA5",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 13.75C1.53125 13.75 1.23698 13.6276 0.992188 13.3828C0.747396 13.138 0.625 12.8438 0.625 12.5V3.75C0.625 3.40625 0.747396 3.11198 0.992188 2.86719C1.23698 2.6224 1.53125 2.5 1.875 2.5H7.45312L6.20312 3.75H1.875V12.5H10.625V8.15625L11.875 6.90625V12.5C11.875 12.8438 11.7526 13.138 11.5078 13.3828C11.263 13.6276 10.9688 13.75 10.625 13.75H1.875ZM4.375 10V7.34375L10.1094 1.60938C10.2344 1.48438 10.375 1.39062 10.5312 1.32812C10.6875 1.26562 10.8438 1.23438 11 1.23438C11.1667 1.23438 11.3255 1.26562 11.4766 1.32812C11.6276 1.39062 11.7656 1.48438 11.8906 1.60938L12.7656 2.5C12.8802 2.625 12.9688 2.76302 13.0312 2.91406C13.0938 3.0651 13.125 3.21875 13.125 3.375C13.125 3.53125 13.0964 3.6849 13.0391 3.83594C12.9818 3.98698 12.8906 4.125 12.7656 4.25L7.03125 10H4.375ZM5.625 8.75H6.5L10.125 5.125L9.6875 4.6875L9.23438 4.25L5.625 7.85938V8.75Z"
        fill={color}
      />
    </svg>
  );
};

export const AssetIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M5 5V19H19V5H5ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
        fill="#172B4D"
      />
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const AssetNewIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M12 16.1702L16 13.8702V9.24023L12 11.5702V16.1702Z"
        fill="#172B4D"
      />
      <path
        opacity="0.3"
        d="M11 5.25L7.04004 7.53L11 9.84L14.96 7.53L11 5.25Z"
        fill="#172B4D"
      />
      <path
        opacity="0.3"
        d="M6 13.8702L10 16.1702V11.5702L6 9.24023V13.8702Z"
        fill="#172B4D"
      />
      <path
        d="M2 3C2 2.45 2.45 2 3 2H5V0H3C1.34 0 0 1.34 0 3V5H2V3Z"
        fill="#172B4D"
      />
      <path
        d="M2 19V17H0V19C0 20.66 1.34 22 3 22H5V20H3C2.45 20 2 19.55 2 19Z"
        fill="#172B4D"
      />
      <path
        d="M19 0H17V2H19C19.55 2 20 2.45 20 3V5H22V3C22 1.34 20.66 0 19 0Z"
        fill="#172B4D"
      />
      <path
        d="M20 19C20 19.55 19.55 20 19 20H17V22H19C20.66 22 22 20.66 22 19V17H20V19Z"
        fill="#172B4D"
      />
      <path
        d="M18 13.87V8.13C18 7.41 17.62 6.75 17 6.4L12 3.52C11.69 3.34 11.35 3.25 11 3.25C10.65 3.25 10.31 3.34 10 3.52L5 6.39C4.38 6.75 4 7.41 4 8.13V13.87C4 14.59 4.38 15.25 5 15.6L10 18.48C10.31 18.66 10.65 18.75 11 18.75C11.35 18.75 11.69 18.66 12 18.48L17 15.6C17.62 15.25 18 14.59 18 13.87ZM10 16.17L6 13.87V9.24L10 11.57V16.17ZM11 9.84L7.04 7.53L11 5.25L14.96 7.53L11 9.84ZM16 13.87L12 16.17V11.57L16 9.24V13.87Z"
        fill="#172B4D"
      />
    </svg>
  );
};

export const WRIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM17 10C17.34 10 17.67 10.03 18 10.08V5H16V8H8V5H6V20H10.68C10.25 19.09 10 18.08 10 17C10 13.13 13.13 10 17 10ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z"
        fill="#172B4D"
      />
      <path
        d="M17 12C14.24 12 12 14.24 12 17C12 19.76 14.24 22 17 22C19.76 22 22 19.76 22 17C22 14.24 19.76 12 17 12ZM18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM18 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H6C4.9 3 4 3.9 4 5V20C4 21.1 4.9 22 6 22H12.11C11.52 21.43 11.04 20.75 10.69 20H6V5H8V8H16V5H18V10.08C18.71 10.18 19.38 10.39 20 10.68V5C20 3.9 19.1 3 18 3ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const JobtitleIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M15 17H9V16H5V19H19V16H15V17ZM4 14H9V11H15V14H20V9H4V14Z"
        fill="#172B4D"
      />
      <path
        d="M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM19 19H5V16H9V17H15V16H19V19ZM11 15V13H13V15H11ZM20 14H15V11H9V14H4V9H20V14Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const CategoryIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M4 18H20V6H4V18ZM13 7H17V11H13V7ZM13 13H17V17H13V13ZM7 7H11V11H7V7ZM7 13H11V17H7V13Z"
        fill="#172B4D"
      />
      <path d="M11 7H7V11H11V7Z" fill="#172B4D" />
      <path d="M17 7H13V11H17V7Z" fill="#172B4D" />
      <path d="M11 13H7V17H11V13Z" fill="#172B4D" />
      <path d="M17 13H13V17H17V13Z" fill="#172B4D" />
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
        fill="#172B4D"
      />
    </svg>
  );
};

export const CategoryEditIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1025 10.39L20.1625 9.33C20.9425 8.55 20.9425 7.28 20.1625 6.5L18.7525 5.09C17.9725 4.31 16.7025 4.31 15.9225 5.09L14.8625 6.15L19.1025 10.39ZM14.8625 11.81L7.6625 19H6.2525V17.59L13.4425 10.4L14.8625 11.81ZM13.4425 7.56L4.2525 16.76V21H8.4925L17.6825 11.81L13.4425 7.56ZM19.2525 17.5C19.2525 19.69 16.7125 21 14.2525 21C13.7025 21 13.2525 20.55 13.2525 20C13.2525 19.45 13.7025 19 14.2525 19C15.7925 19 17.2525 18.27 17.2525 17.5C17.2525 17.03 16.7725 16.63 16.0225 16.3L17.5025 14.82C18.5725 15.45 19.2525 16.29 19.2525 17.5ZM4.8325 13.35C3.8625 12.79 3.2525 12.06 3.2525 11C3.2525 9.2 5.1425 8.37 6.8125 7.64C7.8425 7.18 9.2525 6.56 9.2525 6C9.2525 5.59 8.4725 5 7.2525 5C5.9925 5 5.4525 5.61 5.4225 5.64C5.0725 6.05 4.4425 6.1 4.0225 5.76C3.6125 5.42 3.5325 4.81 3.8725 4.38C3.9825 4.24 5.0125 3 7.2525 3C9.4925 3 11.2525 4.32 11.2525 6C11.2525 7.87 9.3225 8.72 7.6125 9.47C6.6725 9.88 5.2525 10.5 5.2525 11C5.2525 11.31 5.6825 11.6 6.3225 11.86L4.8325 13.35Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const CustomerPlusIcon = ({ width = "20px", height = "20px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8334 5.83329H9.16675V9.16663H5.83342V10.8333H9.16675V14.1666H10.8334V10.8333H14.1667V9.16663H10.8334V5.83329ZM10.0001 1.66663C5.40008 1.66663 1.66675 5.39996 1.66675 9.99996C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6001 1.66663 10.0001 1.66663ZM10.0001 16.6666C6.32508 16.6666 3.33341 13.675 3.33341 9.99996C3.33341 6.32496 6.32508 3.33329 10.0001 3.33329C13.6751 3.33329 16.6667 6.32496 16.6667 9.99996C16.6667 13.675 13.6751 16.6666 10.0001 16.6666Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const AssigneesIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.22 3.75 12.41 3.85 12.55 4C12.67 4.13 12.75 4.31 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.31 11.33 4.13 11.45 4C11.59 3.85 11.78 3.75 12 3.75ZM19 20H5V6H19V20ZM12 7C10.35 7 9 8.35 9 10C9 11.65 10.35 13 12 13C13.65 13 15 11.65 15 10C15 8.35 13.65 7 12 7ZM12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11ZM6 17.47V19H18V17.47C18 14.97 14.03 13.89 12 13.89C9.97 13.89 6 14.96 6 17.47ZM8.31 17C9 16.44 10.69 15.88 12 15.88C13.31 15.88 15.01 16.44 15.69 17H8.31Z"
        fill="#44546F"
      />
    </svg>
  );
};
export const LocationMapIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
        fill="#44546F"
      />
      <path
        d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const LocationIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M12 4C9.24 4 7 6.24 7 9C7 11.85 9.92 16.21 12 18.88C14.11 16.19 17 11.88 17 9C17 6.24 14.76 4 12 4ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill="#172B4D"
      />
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
        fill="#172B4D"
      />
      <path
        d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const LocationWhiteIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill="white"
      />
    </svg>
  );
};
export const LocationBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M40 13.3333C30.8 13.3333 23.3333 20.7999 23.3333 29.9999C23.3333 39.4999 33.0667 54.0333 40 62.9333C47.0333 53.9666 56.6667 39.5999 56.6667 29.9999C56.6667 20.7999 49.2 13.3333 40 13.3333ZM40 38.3333C35.4 38.3333 31.6667 34.5999 31.6667 29.9999C31.6667 25.3999 35.4 21.6666 40 21.6666C44.6 21.6666 48.3333 25.3999 48.3333 29.9999C48.3333 34.5999 44.6 38.3333 40 38.3333Z"
          fill="#0C66E4"
        />
        <path
          d="M40 6.66675C27.1 6.66675 16.6667 17.1001 16.6667 30.0001C16.6667 47.5001 40 73.3334 40 73.3334C40 73.3334 63.3333 47.5001 63.3333 30.0001C63.3333 17.1001 52.9 6.66675 40 6.66675ZM23.3333 30.0001C23.3333 20.8001 30.8 13.3334 40 13.3334C49.2 13.3334 56.6667 20.8001 56.6667 30.0001C56.6667 39.6001 47.0667 53.9667 40 62.9334C33.0667 54.0334 23.3333 39.5001 23.3333 30.0001Z"
          fill="#0C66E4"
        />
        <path
          d="M40 38.3334C44.6024 38.3334 48.3333 34.6025 48.3333 30.0001C48.3333 25.3977 44.6024 21.6667 40 21.6667C35.3976 21.6667 31.6667 25.3977 31.6667 30.0001C31.6667 34.6025 35.3976 38.3334 40 38.3334Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const VendorBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M56.6667 36.6665H63.3333V43.3332H56.6667V49.9998H63.3333V56.6665H56.6667V63.3332H70V16.6665H40V21.3332L56.6667 33.2332V36.6665ZM56.6667 23.3332H63.3333V29.9998H56.6667V23.3332Z"
          fill="#0C66E4"
        />
        <path
          d="M33.3333 10V16.5667L36.5333 18.8667L40 21.3333V16.6667H70V63.3333H56.6667V70H76.6667V10H33.3333Z"
          fill="#0C66E4"
        />
        <path
          opacity="0.3"
          d="M10 40.0002V63.3335H16.6667V46.6668H36.6667V63.3335H43.3333V40.0002L26.6667 28.3335L10 40.0002Z"
          fill="#0C66E4"
        />
        <path
          d="M63.3333 23.3335H56.6667V30.0002H63.3333V23.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M63.3333 36.6665H56.6667V43.3332H63.3333V36.6665Z"
          fill="#0C66E4"
        />
        <path d="M63.3333 50H56.6667V56.6667H63.3333V50Z" fill="#0C66E4" />
        <path
          d="M3.33334 36.6667V70H23.3333V53.3333H30V70H50V36.6667L26.6667 20L3.33334 36.6667ZM43.3333 63.3333H36.6667V46.6667H16.6667V63.3333H10V40L26.6667 28.3333L43.3333 40V63.3333Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const PartsBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M69.9998 38.3333L74.9998 43.3333L51.6998 66.6666L36.6665 51.6666L41.6665 46.6666L51.6998 56.6666L69.9998 38.3333Z"
        fill="#0C66E4"
      />
      <path
        opacity="0.3"
        d="M56.6665 16.6665V26.6665H23.3332V16.6665H16.6665V63.3332H38.9332L27.2332 51.6665L41.6665 37.2332L51.6998 47.2332L63.3332 35.5665V16.6665H56.6665Z"
        fill="#0C66E4"
      />
      <path
        d="M16.6667 63.3333V16.6666H23.3333V26.6666H56.6667V16.6666H63.3333V35.5666L70 28.8999V16.6666C70 12.9999 67 9.99992 63.3333 9.99992H49.4C48 6.13325 44.3333 3.33325 40 3.33325C35.6667 3.33325 32 6.13325 30.6 9.99992H16.6667C13 9.99992 10 12.9999 10 16.6666V63.3333C10 66.9999 13 69.9999 16.6667 69.9999H45.6L38.9333 63.3333H16.6667ZM40 9.99992C41.8333 9.99992 43.3333 11.4999 43.3333 13.3333C43.3333 15.1666 41.8333 16.6666 40 16.6666C38.1667 16.6666 36.6667 15.1666 36.6667 13.3333C36.6667 11.4999 38.1667 9.99992 40 9.99992Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const PurchaseBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M33.8332 56.667C33.8332 45.6337 42.7998 36.667 53.8332 36.667H63.8332V16.667H57.1665V26.667H23.8332V16.667H17.1665V63.3337H33.8332V56.667Z"
          fill="#0C66E4"
        />
        <path
          d="M33.8333 63.3335H17.1667V16.6668H23.8333V26.6668H57.1667V16.6668H63.8333V36.6668H70.5V16.6668C70.5 13.0002 67.5 10.0002 63.8333 10.0002H49.9C48.5 6.1335 44.8333 3.3335 40.5 3.3335C36.1667 3.3335 32.5 6.1335 31.1 10.0002H17.1667C13.5 10.0002 10.5 13.0002 10.5 16.6668V63.3335C10.5 67.0002 13.5 70.0002 17.1667 70.0002H33.8333V63.3335ZM40.5 10.0002C42.3333 10.0002 43.8333 11.5002 43.8333 13.3335C43.8333 15.1668 42.3333 16.6668 40.5 16.6668C38.6667 16.6668 37.1667 15.1668 37.1667 13.3335C37.1667 11.5002 38.6667 10.0002 40.5 10.0002Z"
          fill="#0C66E4"
        />
        <path
          d="M60.5333 43.3335L55.8 48.0335L61.0667 53.3002H40.5V59.9668H61.0667L55.8 65.2668L60.5333 69.9668L73.8333 56.6335L60.5333 43.3335Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const WRBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M62.6667 64.5L55.5 57.3333V46.6667H58.8333V55.9667L65 62.1333L62.6667 64.5ZM57.1667 33.3333C58.3 33.3333 59.4 33.4333 60.5 33.6V16.6667H53.8333V26.6667H27.1667V16.6667H20.5V66.6667H36.1C34.6667 63.6333 33.8333 60.2667 33.8333 56.6667C33.8333 43.7667 44.2667 33.3333 57.1667 33.3333ZM40.5 16.6667C38.6667 16.6667 37.1667 15.1667 37.1667 13.3333C37.1667 11.5 38.6667 10 40.5 10C42.3333 10 43.8333 11.5 43.8333 13.3333C43.8333 15.1667 42.3333 16.6667 40.5 16.6667Z"
        fill="#0C66E4"
      />
      <path
        d="M57.1668 39.9987C47.9668 39.9987 40.5002 47.4654 40.5002 56.6654C40.5002 65.8654 47.9668 73.332 57.1668 73.332C66.3668 73.332 73.8335 65.8654 73.8335 56.6654C73.8335 47.4654 66.3668 39.9987 57.1668 39.9987ZM62.6668 64.4987L55.5002 57.332V46.6654H58.8335V55.9654L65.0002 62.132L62.6668 64.4987ZM60.5002 9.9987H49.9002C48.5002 6.13203 44.8335 3.33203 40.5002 3.33203C36.1668 3.33203 32.5002 6.13203 31.1002 9.9987H20.5002C16.8335 9.9987 13.8335 12.9987 13.8335 16.6654V66.6654C13.8335 70.332 16.8335 73.332 20.5002 73.332H40.8668C38.9002 71.432 37.3002 69.1654 36.1335 66.6654H20.5002V16.6654H27.1668V26.6654H53.8335V16.6654H60.5002V33.5987C62.8668 33.932 65.1002 34.632 67.1668 35.5987V16.6654C67.1668 12.9987 64.1668 9.9987 60.5002 9.9987ZM40.5002 16.6654C38.6668 16.6654 37.1668 15.1654 37.1668 13.332C37.1668 11.4987 38.6668 9.9987 40.5002 9.9987C42.3335 9.9987 43.8335 11.4987 43.8335 13.332C43.8335 15.1654 42.3335 16.6654 40.5002 16.6654Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const JobTitleBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M50 56.6667H30V53.3333H16.6667V63.3333H63.3333V53.3333H50V56.6667ZM13.3333 46.6667H30V36.6667H50V46.6667H66.6667V30H13.3333V46.6667Z"
        fill="#0C66E4"
      />
      <path
        d="M66.6667 23.3333H53.3333V16.6667L46.6667 10H33.3333L26.6667 16.6667V23.3333H13.3333C9.66666 23.3333 6.66666 26.3333 6.66666 30V46.6667C6.66666 49.1667 8 51.2667 10 52.4333V63.3333C10 67.0333 12.9667 70 16.6667 70H63.3333C67.0333 70 70 67.0333 70 63.3333V52.4C71.9667 51.2333 73.3333 49.1 73.3333 46.6667V30C73.3333 26.3333 70.3333 23.3333 66.6667 23.3333ZM33.3333 16.6667H46.6667V23.3333H33.3333V16.6667ZM63.3333 63.3333H16.6667V53.3333H30V56.6667H50V53.3333H63.3333V63.3333ZM36.6667 50V43.3333H43.3333V50H36.6667ZM66.6667 46.6667H50V36.6667H30V46.6667H13.3333V30H66.6667V46.6667Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const CategoryBlueIcon = ({ width = "80px", height = "80px" }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M13.3333 60H66.6667V20H13.3333V60ZM43.3333 23.3333H56.6667V36.6667H43.3333V23.3333ZM43.3333 43.3333H56.6667V56.6667H43.3333V43.3333ZM23.3333 23.3333H36.6667V36.6667H23.3333V23.3333ZM23.3333 43.3333H36.6667V56.6667H23.3333V43.3333Z"
          fill="#0C66E4"
        />
        <path
          d="M36.6667 23.3335H23.3333V36.6668H36.6667V23.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M56.6667 23.3335H43.3333V36.6668H56.6667V23.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M36.6667 43.3335H23.3333V56.6668H36.6667V43.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M56.6667 43.3335H43.3333V56.6668H56.6667V43.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M66.6667 13.3335H13.3333C9.66666 13.3335 6.66666 16.3335 6.66666 20.0002V60.0002C6.66666 63.6668 9.66666 66.6668 13.3333 66.6668H66.6667C70.3333 66.6668 73.3333 63.6668 73.3333 60.0002V20.0002C73.3333 16.3335 70.3333 13.3335 66.6667 13.3335ZM66.6667 60.0002H13.3333V20.0002H66.6667V60.0002Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const LocationBlueNoBackground = ({
  width = "80px",
  height = "80px",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
        fill="#0C66E4"
      />
      <path
        d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const TimesheetIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4ZM16.25 16.15L11 13V7H12.5V12.25L17 14.92L16.25 16.15Z"
        fill="#172B4D"
      />
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
        fill="#172B4D"
      />
    </svg>
  );
};

export const EditWhiteIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37236 6.01333L9.98569 6.62667L3.94569 12.6667H3.33236V12.0533L9.37236 6.01333ZM11.7724 2C11.6057 2 11.4324 2.06667 11.3057 2.19333L10.0857 3.41333L12.5857 5.91333L13.8057 4.69333C14.0657 4.43333 14.0657 4.01333 13.8057 3.75333L12.2457 2.19333C12.1124 2.06 11.9457 2 11.7724 2ZM9.37236 4.12667L1.99902 11.5V14H4.49902L11.8724 6.62667L9.37236 4.12667Z"
        fill="white"
      />
    </svg>
  );
};

export const Printer = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 8H18V3H6V8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8 5H16V8H8V5ZM16 19H8V15H16V19ZM18 15V13H6V15H4V11C4 10.45 4.45 10 5 10H19C19.55 10 20 10.45 20 11V15H18Z"
        fill="#788CA5"
      />
      <path
        d="M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const GreySearchIcon = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.6967 12.5708L16.98 15.9125C17.1271 16.0715 17.2065 16.2815 17.2015 16.498C17.1964 16.7145 17.1072 16.9206 16.9528 17.0725C16.7984 17.2244 16.5909 17.3102 16.3744 17.3117C16.1578 17.3133 15.9491 17.2305 15.7925 17.0808L12.5109 13.7425C11.2447 14.6964 9.66328 15.1334 8.08694 14.9652C6.51059 14.7969 5.05708 14.036 4.02072 12.8363C2.98436 11.6367 2.44259 10.0881 2.50511 8.50399C2.56763 6.91993 3.22978 5.41881 4.35747 4.3046C5.48516 3.19038 6.99412 2.54632 8.57883 2.50284C10.1635 2.45936 11.7055 3.0197 12.8926 4.07041C14.0797 5.12111 14.8232 6.58366 14.9725 8.16192C15.1218 9.74017 14.6657 11.3162 13.6967 12.5708ZM8.75004 13.3333C9.96562 13.3333 11.1314 12.8505 11.9909 11.9909C12.8505 11.1314 13.3334 9.96558 13.3334 8.75C13.3334 7.53443 12.8505 6.36864 11.9909 5.5091C11.1314 4.64956 9.96562 4.16667 8.75004 4.16667C7.53446 4.16667 6.36868 4.64956 5.50913 5.5091C4.64959 6.36864 4.16671 7.53443 4.16671 8.75C4.16671 9.96558 4.64959 11.1314 5.50913 11.9909C6.36868 12.8505 7.53446 13.3333 8.75004 13.3333Z"
        fill="#626F86"
      />
    </svg>
  );
};

export const Repeat = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z"
        fill="#0C66E4"
      />
    </svg>
  );
};

export const AddImage = ({ width = "25px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M18 20.5H4V6.5H13V4.5H4C2.9 4.5 2 5.4 2 6.5V20.5C2 21.6 2.9 22.5 4 22.5H18C19.1 22.5 20 21.6 20 20.5V11.5H18V20.5ZM10.21 17.33L8.25 14.97L5.5 18.5H16.5L12.96 13.79L10.21 17.33ZM20 4.5V1.5H18V4.5H15C15.01 4.51 15 6.5 15 6.5H18V9.49C18.01 9.5 20 9.49 20 9.49V6.5H23V4.5H20Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const AddFile = ({ width = "25px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        d="M13.0625 8.9375V13.0625H8.9375V8.9375H13.0625ZM15.125 6.875H6.875V15.125H15.125V6.875ZM13.0625 19.9375V24.0625H8.9375V19.9375H13.0625ZM15.125 17.875H6.875V26.125H15.125V17.875ZM24.0625 8.9375V13.0625H19.9375V8.9375H24.0625ZM26.125 6.875H17.875V15.125H26.125V6.875ZM17.875 17.875H19.9375V19.9375H17.875V17.875ZM19.9375 19.9375H22V22H19.9375V19.9375ZM22 17.875H24.0625V19.9375H22V17.875ZM17.875 22H19.9375V24.0625H17.875V22ZM19.9375 24.0625H22V26.125H19.9375V24.0625ZM22 22H24.0625V24.0625H22V22ZM24.0625 19.9375H26.125V22H24.0625V19.9375ZM24.0625 24.0625H26.125V26.125H24.0625V24.0625ZM30.25 9.625H27.5V5.5H23.375V2.75H30.25V9.625ZM30.25 30.25V23.375H27.5V27.5H23.375V30.25H30.25ZM2.75 30.25H9.625V27.5H5.5V23.375H2.75V30.25ZM2.75 2.75V9.625H5.5V5.5H9.625V2.75H2.75Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const TextSnippet = ({ width = "36px", height = "36px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M21.255 7.5L28.5 14.745V28.5H7.5V7.5H21.255ZM21.255 4.5H7.5C5.85 4.5 4.5 5.85 4.5 7.5V28.5C4.5 30.15 5.85 31.5 7.5 31.5H28.5C30.15 31.5 31.5 30.15 31.5 28.5V14.745C31.5 13.95 31.185 13.185 30.615 12.63L23.37 5.385C22.815 4.815 22.05 4.5 21.255 4.5ZM10.5 22.5H25.5V25.5H10.5V22.5ZM10.5 16.5H25.5V19.5H10.5V16.5ZM10.5 10.5H21V13.5H10.5V10.5Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const ContractIcon = ({ width = "36px", height = "36px" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27 18H21V20.25H27V18Z" fill="#788CA5" />
      <path d="M27 22.5H21V24.75H27V22.5Z" fill="#788CA5" />
      <path
        d="M30 10.5H22.5V6C22.5 4.35 21.15 3 19.5 3H16.5C14.85 3 13.5 4.35 13.5 6V10.5H6C4.35 10.5 3 11.85 3 13.5V30C3 31.65 4.35 33 6 33H30C31.65 33 33 31.65 33 30V13.5C33 11.85 31.65 10.5 30 10.5ZM16.5 6H19.5V13.5H16.5V6ZM30 30H6V13.5H13.5C13.5 15.15 14.85 16.5 16.5 16.5H19.5C21.15 16.5 22.5 15.15 22.5 13.5H30V30Z"
        fill="#788CA5"
      />
      <path
        d="M13.5 22.5C14.7426 22.5 15.75 21.4926 15.75 20.25C15.75 19.0074 14.7426 18 13.5 18C12.2574 18 11.25 19.0074 11.25 20.25C11.25 21.4926 12.2574 22.5 13.5 22.5Z"
        fill="#788CA5"
      />
      <path
        d="M16.62 24.27C15.66 23.85 14.61 23.625 13.5 23.625C12.39 23.625 11.34 23.85 10.38 24.27C9.54 24.63 9 25.44 9 26.355V27H18V26.355C18 25.44 17.46 24.63 16.62 24.27Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const PassportIcon = ({ width = "36px", height = "36px" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.755 6L27 13.245V30H9V6H19.755ZM21 3H9C7.35 3 6 4.35 6 6V30C6 31.65 7.35 33 9 33H27C28.65 33 30 31.65 30 30V12L21 3ZM18 21C19.65 21 21 19.65 21 18C21 16.35 19.65 15 18 15C16.35 15 15 16.35 15 18C15 19.65 16.35 21 18 21ZM24 26.145C24 24.93 23.28 23.85 22.17 23.37C20.895 22.815 19.485 22.5 18 22.5C16.515 22.5 15.105 22.815 13.83 23.37C12.72 23.85 12 24.93 12 26.145V27H24V26.145Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const VisaIcon = ({ width = "36px", height = "36px" }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5 4.5H7.5C5.85 4.5 4.5 5.85 4.5 7.5V28.5C4.5 30.15 5.85 31.5 7.5 31.5H28.5C30.15 31.5 31.5 30.15 31.5 28.5V7.5C31.5 5.85 30.15 4.5 28.5 4.5ZM28.5 28.5H7.5V7.5H28.5V28.5Z"
        fill="#788CA5"
      />
      <path
        d="M18 27C22.965 27 27 22.965 27 18C27 13.035 22.965 9 18 9C13.035 9 9 13.035 9 18C9 22.965 13.035 27 18 27ZM23.16 15C23.55 15.675 23.82 16.44 23.925 17.25H12.075C12.18 16.44 12.435 15.675 12.84 15H23.16ZM23.925 18.75C23.82 19.56 23.565 20.325 23.16 21H12.84C12.45 20.325 12.18 19.56 12.075 18.75H23.925ZM14.07 22.5H21.93C20.88 23.415 19.515 24 18 24C16.485 24 15.135 23.415 14.07 22.5ZM21.93 13.5H14.07C15.12 12.585 16.485 12 18 12C19.515 12 20.865 12.585 21.93 13.5Z"
        fill="#788CA5"
      />
    </svg>
  );
};

export const Fail = ({ width = "65px", height = "64px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 65 64"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M32.4998 10.6666C20.7398 10.6666 11.1665 20.24 11.1665 32C11.1665 43.76 20.7398 53.3333 32.4998 53.3333C44.2598 53.3333 53.8332 43.76 53.8332 32C53.8332 20.24 44.2598 10.6666 32.4998 10.6666ZM43.1665 38.9066L39.4065 42.6666L32.4998 35.76L25.5932 42.6666L21.8332 38.9066L28.7398 32L21.8332 25.0933L25.5932 21.3333L32.4998 28.24L39.4065 21.3333L43.1665 25.0933L36.2598 32L43.1665 38.9066Z"
        fill="#D14040"
      />
      <path
        d="M39.4068 21.3334L32.5002 28.24L25.5935 21.3334L21.8335 25.0934L28.7402 32L21.8335 38.9067L25.5935 42.6667L32.5002 35.76L39.4068 42.6667L43.1668 38.9067L36.2602 32L43.1668 25.0934L39.4068 21.3334ZM32.5002 5.33337C17.7535 5.33337 5.8335 17.2534 5.8335 32C5.8335 46.7467 17.7535 58.6667 32.5002 58.6667C47.2468 58.6667 59.1668 46.7467 59.1668 32C59.1668 17.2534 47.2468 5.33337 32.5002 5.33337ZM32.5002 53.3334C20.7402 53.3334 11.1668 43.76 11.1668 32C11.1668 20.24 20.7402 10.6667 32.5002 10.6667C44.2602 10.6667 53.8335 20.24 53.8335 32C53.8335 43.76 44.2602 53.3334 32.5002 53.3334Z"
        fill="#D14040"
      />
    </svg>
  );
};

export const WorkOrderIcon = ({ width = "21px", height = "21px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M2 6V17H9.08C9.03 16.67 9 16.34 9 16C9 12.13 12.13 9 16 9C16.7 9 17.37 9.1 18 9.29V6H2Z"
        fill="#172B4D"
      />
      <path
        d="M2 17V6H18V9.29C18.72 9.51 19.4 9.83 20 10.26V6C20 4.89 19.11 4 18 4H14V2C14 0.89 13.11 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0.00999999 4.89 0.00999999 6L0 17C0 18.11 0.89 19 2 19H9.68C9.38 18.38 9.18 17.71 9.08 17H2ZM8 2H12V4H8V2Z"
        fill="#172B4D"
      />
      <path
        d="M16 11C13.24 11 11 13.24 11 16C11 18.76 13.24 21 16 21C18.76 21 21 18.76 21 16C21 13.24 18.76 11 16 11ZM17.65 18.35L15.5 16.2V13H16.5V15.79L18.35 17.64L17.65 18.35Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const DashboardrIcon = ({ width = "21px", height = "21px" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z"
        fill="black"
      />
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z"
        fill="black"
      />
    </svg>
  );
};
export const WorkOrderIconBlue = ({ width = "70px", height = "70px" }) => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M13.8333 26.6665V63.3332H37.4333C37.2667 62.2332 37.1667 61.1332 37.1667 59.9998C37.1667 47.0998 47.6 36.6665 60.5 36.6665C62.8333 36.6665 65.0667 36.9998 67.1667 37.6332V26.6665H13.8333Z"
          fill="#0C66E4"
        />
        <path
          d="M13.8333 63.3332V26.6665H67.1667V37.6332C69.5667 38.3665 71.8333 39.4332 73.8333 40.8665V26.6665C73.8333 22.9665 70.8667 19.9998 67.1667 19.9998H53.8333V13.3332C53.8333 9.63317 50.8667 6.6665 47.1667 6.6665H33.8333C30.1333 6.6665 27.1667 9.63317 27.1667 13.3332V19.9998H13.8333C10.1333 19.9998 7.2 22.9665 7.2 26.6665L7.16666 63.3332C7.16666 67.0332 10.1333 69.9998 13.8333 69.9998H39.4333C38.4333 67.9332 37.7667 65.6998 37.4333 63.3332H13.8333ZM33.8333 13.3332H47.1667V19.9998H33.8333V13.3332Z"
          fill="#0C66E4"
        />
        <path
          d="M60.5 43.333C51.3 43.333 43.8333 50.7997 43.8333 59.9997C43.8333 69.1997 51.3 76.6663 60.5 76.6663C69.7 76.6663 77.1667 69.1997 77.1667 59.9997C77.1667 50.7997 69.7 43.333 60.5 43.333ZM66 67.833L58.8333 60.6663V49.9997H62.1667V59.2997L68.3333 65.4663L66 67.833Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const AssetsIconBlue = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M16.6667 16.6666V63.3333H63.3333V16.6666H16.6667ZM30 56.6666H23.3333V33.3333H30V56.6666ZM43.3333 56.6666H36.6667V23.3333H43.3333V56.6666ZM56.6667 56.6666H50V43.3333H56.6667V56.6666Z"
          fill="#0C66E4"
        />
        <path
          d="M63.3333 10H16.6667C13 10 10 13 10 16.6667V63.3333C10 67 13 70 16.6667 70H63.3333C67 70 70 67 70 63.3333V16.6667C70 13 67 10 63.3333 10ZM63.3333 63.3333H16.6667V16.6667H63.3333V63.3333ZM23.3333 33.3333H30V56.6667H23.3333V33.3333ZM36.6667 23.3333H43.3333V56.6667H36.6667V23.3333ZM50 43.3333H56.6667V56.6667H50V43.3333Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};
export const AssetsNewIconBlue = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M43.3335 57.2333L56.6668 49.5666V34.1333L43.3335 41.9V57.2333Z"
          fill="#0C66E4"
        />
        <path
          opacity="0.3"
          d="M40.0003 20.8335L26.8003 28.4335L40.0003 36.1335L53.2003 28.4335L40.0003 20.8335Z"
          fill="#0C66E4"
        />
        <path
          opacity="0.3"
          d="M23.3335 49.5666L36.6668 57.2333V41.9L23.3335 34.1333V49.5666Z"
          fill="#0C66E4"
        />
        <path
          d="M10.0002 13.3335C10.0002 11.5002 11.5002 10.0002 13.3335 10.0002H20.0002V3.3335H13.3335C7.80016 3.3335 3.3335 7.80016 3.3335 13.3335V20.0002H10.0002V13.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M10.0002 66.6667V60H3.3335V66.6667C3.3335 72.2 7.80016 76.6667 13.3335 76.6667H20.0002V70H13.3335C11.5002 70 10.0002 68.5 10.0002 66.6667Z"
          fill="#0C66E4"
        />
        <path
          d="M66.6667 3.3335H60V10.0002H66.6667C68.5 10.0002 70 11.5002 70 13.3335V20.0002H76.6667V13.3335C76.6667 7.80016 72.2 3.3335 66.6667 3.3335Z"
          fill="#0C66E4"
        />
        <path
          d="M70 66.6667C70 68.5 68.5 70 66.6667 70H60V76.6667H66.6667C72.2 76.6667 76.6667 72.2 76.6667 66.6667V60H70V66.6667Z"
          fill="#0C66E4"
        />
        <path
          d="M63.3337 49.567V30.4337C63.3337 28.0337 62.067 25.8337 60.0003 24.667L43.3337 15.067C42.3003 14.467 41.167 14.167 40.0003 14.167C38.8337 14.167 37.7003 14.467 36.667 15.067L20.0003 24.6337C17.9337 25.8337 16.667 28.0337 16.667 30.4337V49.567C16.667 51.967 17.9337 54.167 20.0003 55.3337L36.667 64.9337C37.7003 65.5337 38.8337 65.8337 40.0003 65.8337C41.167 65.8337 42.3003 65.5337 43.3337 64.9337L60.0003 55.3337C62.067 54.167 63.3337 51.967 63.3337 49.567ZM36.667 57.2337L23.3337 49.567V34.1337L36.667 41.9003V57.2337ZM40.0003 36.1337L26.8003 28.4337L40.0003 20.8337L53.2003 28.4337L40.0003 36.1337ZM56.667 49.567L43.3337 57.2337V41.9003L56.667 34.1337V49.567Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const AddSubLocationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill="#788CA5"
      />
    </svg>
  );
};
export const PeopleIconBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M30.5 33.3335C33.2614 33.3335 35.5 31.0949 35.5 28.3335C35.5 25.5721 33.2614 23.3335 30.5 23.3335C27.7386 23.3335 25.5 25.5721 25.5 28.3335C25.5 31.0949 27.7386 33.3335 30.5 33.3335Z"
          fill="#0C66E4"
        />
        <path
          opacity="0.3"
          d="M14.9667 56.6667H46.0333C43.2333 54.7333 36.4667 52.5 30.5 52.5C24.5333 52.5 17.7667 54.7333 14.9667 56.6667Z"
          fill="#0C66E4"
        />
        <path
          d="M30.5 39.9998C36.9333 39.9998 42.1667 34.7665 42.1667 28.3332C42.1667 21.8998 36.9333 16.6665 30.5 16.6665C24.0667 16.6665 18.8333 21.8998 18.8333 28.3332C18.8333 34.7665 24.0667 39.9998 30.5 39.9998ZM30.5 23.3332C33.2667 23.3332 35.5 25.5665 35.5 28.3332C35.5 31.0998 33.2667 33.3332 30.5 33.3332C27.7333 33.3332 25.5 31.0998 25.5 28.3332C25.5 25.5665 27.7333 23.3332 30.5 23.3332ZM30.5 45.8332C22.7 45.8332 7.16666 49.7332 7.16666 57.4998V63.3332H53.8333V57.4998C53.8333 49.7332 38.3 45.8332 30.5 45.8332ZM14.9667 56.6665C17.7667 54.7332 24.5333 52.4998 30.5 52.4998C36.4667 52.4998 43.2333 54.7332 46.0333 56.6665H14.9667ZM53.9667 46.0332C57.8333 48.8332 60.5 52.5665 60.5 57.4998V63.3332H73.8333V57.4998C73.8333 50.7665 62.1667 46.9332 53.9667 46.0332ZM50.5 39.9998C56.9333 39.9998 62.1667 34.7665 62.1667 28.3332C62.1667 21.8998 56.9333 16.6665 50.5 16.6665C48.7 16.6665 47.0333 17.0998 45.5 17.8332C47.6 20.7998 48.8333 24.4332 48.8333 28.3332C48.8333 32.2332 47.6 35.8665 45.5 38.8332C47.0333 39.5665 48.7 39.9998 50.5 39.9998Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const TimesheetBlue = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.3"
          d="M40 13.3334C25.2667 13.3334 13.3333 25.2667 13.3333 40C13.3333 54.7334 25.2667 66.6667 40 66.6667C54.7333 66.6667 66.6667 54.7334 66.6667 40C66.6667 25.2667 54.7333 13.3334 40 13.3334ZM54.1667 53.8334L36.6667 43.3334V23.3334H41.6667V40.8334L56.6667 49.7334L54.1667 53.8334Z"
          fill="#0C66E4"
        />
        <path
          d="M39.9667 6.66663C21.5667 6.66663 6.66666 21.6 6.66666 40C6.66666 58.4 21.5667 73.3333 39.9667 73.3333C58.4 73.3333 73.3333 58.4 73.3333 40C73.3333 21.6 58.4 6.66663 39.9667 6.66663ZM40 66.6666C25.2667 66.6666 13.3333 54.7333 13.3333 40C13.3333 25.2666 25.2667 13.3333 40 13.3333C54.7333 13.3333 66.6667 25.2666 66.6667 40C66.6667 54.7333 54.7333 66.6666 40 66.6666ZM41.6667 23.3333H36.6667V43.3333L54.1667 53.8333L56.6667 49.7333L41.6667 40.8333V23.3333Z"
          fill="#0C66E4"
        />
      </g>
    </svg>
  );
};

export const WorkOrderKanbarHeaderBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="332"
      height="4"
      viewBox="0 0 332 4"
      fill="none"
    >
      <path d="M0 2H332" stroke="#0C66E4" stroke-width="4" />
    </svg>
  );
};
export const WorkOrderKanbarHeaderYellow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="332"
      height="4"
      viewBox="0 0 332 4"
      fill="none"
    >
      <path d="M0 2H332" stroke="#E2B203" stroke-width="4" />
    </svg>
  );
};
export const WorkOrderKanbarHeaderRed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="333"
      height="4"
      viewBox="0 0 333 4"
      fill="none"
    >
      <path d="M0 2H333" stroke="#D14040" stroke-width="4" />
    </svg>
  );
};
export const WorkOrderKanbarHeaderGrey = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="332"
      height="4"
      viewBox="0 0 332 4"
      fill="none"
    >
      <path d="M0 2H332" stroke="#172B4D" stroke-width="4" />
    </svg>
  );
};
export const WorkOrderKanbarHeaderGreen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="332"
      height="4"
      viewBox="0 0 332 4"
      fill="none"
    >
      <path d="M0 2H332" stroke="#4FAB68" stroke-width="4" />
    </svg>
  );
};

export const WorkOrderKanbarHeaderPurple = () => {
  return (
    <svg
      width="332"
      height="4"
      viewBox="0 0 332 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 2H332" stroke="#554FEB" stroke-width="4" />
    </svg>
  );
};

export const ArrowCalendarLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M14.5 7L9.5 12L14.5 17L14.5 7Z" fill="#788CA5" />
    </svg>
  );
};
export const RepeatIcon = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.55556 4.55577H12.4444V7.22244L16 3.66688L12.4444 0.111328V2.778H1.77778V8.11133H3.55556V4.55577ZM12.4444 13.4447H3.55556V10.778L0 14.3336L3.55556 17.8891V15.2224H14.2222V9.88911H12.4444V13.4447Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const RepeatOnIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 8.25H6.75V9.75H5.25V8.25ZM15.75 4.5V15C15.75 15.825 15.075 16.5 14.25 16.5H3.75C2.9175 16.5 2.25 15.825 2.25 15L2.2575 4.5C2.2575 3.675 2.9175 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C15.075 3 15.75 3.675 15.75 4.5ZM3.75 6H14.25V4.5H3.75V6ZM14.25 15V7.5H3.75V15H14.25ZM11.25 9.75H12.75V8.25H11.25V9.75ZM8.25 9.75H9.75V8.25H8.25V9.75Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const EndSchedualIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 3H13.5V1.5H12V3H6V1.5H4.5V3H3.75C2.9175 3 2.2575 3.675 2.2575 4.5L2.25 15C2.25 15.825 2.9175 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM14.25 15H3.75V7.5H14.25V15ZM14.25 6H3.75V4.5H14.25V6ZM9 9.75H12.75V13.5H9V9.75Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const ArrowCalendarRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9.5 17L14.5 12L9.5 7V17Z" fill="#788CA5" />
    </svg>
  );
};

export const Kanbanflag = ({ fill = "#D14040" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.86 5.5L12.26 7.5H17.5V13.5H14.14L13.74 11.5H6.5V5.5H11.86ZM13.5 3.5H4.5V20.5H6.5V13.5H12.1L12.5 15.5H19.5V5.5H13.9L13.5 3.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const KanbanUser = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 15C14.7 15 17.8 16.29 18 17V18H6V17.01C6.2 16.29 9.3 15 12 15ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const KanbanOrg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M15.834 5.83333H14.1673V7.5H15.834V5.83333Z" fill="#44546F" />
      <path
        d="M15.834 9.16667H14.1673V10.8333H15.834V9.16667Z"
        fill="#44546F"
      />
      <path d="M15.834 12.5H14.1673V14.1667H15.834V12.5Z" fill="#44546F" />
      <path
        d="M0.833984 9.16667V17.5H5.83398V13.3333H7.50065V17.5H12.5007V9.16667L6.66732 5L0.833984 9.16667ZM10.834 15.8333H9.16732V11.6667H4.16732V15.8333H2.50065V10L6.66732 7.08333L10.834 10V15.8333Z"
        fill="#44546F"
      />
      <path
        d="M8.33398 2.5V4.14167L10.0007 5.33333V4.16667H17.5006V15.8333H14.1673V17.5H19.1673V2.5H8.33398Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const KanbanLocation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99935 1.66675C6.77435 1.66675 4.16602 4.27508 4.16602 7.50008C4.16602 11.8751 9.99935 18.3334 9.99935 18.3334C9.99935 18.3334 15.8327 11.8751 15.8327 7.50008C15.8327 4.27508 13.2243 1.66675 9.99935 1.66675ZM5.83268 7.50008C5.83268 5.20008 7.69935 3.33341 9.99935 3.33341C12.2993 3.33341 14.166 5.20008 14.166 7.50008C14.166 9.90008 11.766 13.4917 9.99935 15.7334C8.26602 13.5084 5.83268 9.87508 5.83268 7.50008Z"
        fill="#44546F"
      />
      <path
        d="M9.99935 9.58342C11.1499 9.58342 12.0827 8.65068 12.0827 7.50008C12.0827 6.34949 11.1499 5.41675 9.99935 5.41675C8.84876 5.41675 7.91602 6.34949 7.91602 7.50008C7.91602 8.65068 8.84876 9.58342 9.99935 9.58342Z"
        fill="#44546F"
      />
    </svg>
  );
};

export const SortIcon = () => {
  return (
    <svg
      fill="#172B4D"
      width="10px"
      height="10px"
      viewBox="-9 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#172B4D"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>sort</title>{" "}
        <path d="M0.281 13.063l5.969-7.438c0.531-0.688 1.406-0.688 1.938 0l5.969 7.438c0.531 0.688 0.281 1.25-0.625 1.25h-12.625c-0.906 0-1.156-0.563-0.625-1.25zM14.156 18.938l-5.969 7.438c-0.531 0.688-1.406 0.688-1.938 0l-5.969-7.438c-0.531-0.688-0.281-1.25 0.625-1.25h12.625c0.906 0 1.156 0.563 0.625 1.25z"></path>{" "}
      </g>
    </svg>
  );
};

export const RequiredIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.79922 15.4167V6.25H15.5992V8.99167C16.1752 9.175 16.7192 9.44167 17.1992 9.8V6.25C17.1992 5.325 16.4872 4.58333 15.5992 4.58333H12.3992V2.91667C12.3992 1.99167 11.6872 1.25 10.7992 1.25H7.59922C6.71122 1.25 5.99922 1.99167 5.99922 2.91667V4.58333H2.79922C1.91122 4.58333 1.20722 5.325 1.20722 6.25L1.19922 15.4167C1.19922 16.3417 1.91122 17.0833 2.79922 17.0833H8.94322C8.70322 16.5667 8.54322 16.0083 8.46322 15.4167H2.79922ZM7.59922 2.91667H10.7992V4.58333H7.59922V2.91667Z"
        fill="black"
      />
      <path
        d="M13.9992 10.4167C11.7912 10.4167 9.99922 12.2833 9.99922 14.5833C9.99922 16.8833 11.7912 18.75 13.9992 18.75C16.2072 18.75 17.9992 16.8833 17.9992 14.5833C17.9992 12.2833 16.2072 10.4167 13.9992 10.4167ZM15.3192 16.5417L13.5992 14.75V12.0833H14.3992V14.4083L15.8792 15.95L15.3192 16.5417Z"
        fill="black"
      />
    </svg>
  );
};
export const RefreshIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.2849C6 11.6349 6.67 10.1349 7.76 9.04491L6.34 7.62491C4.9 9.07491 4 11.0749 4 13.2849C4 17.3649 7.05 20.7249 11 21.2149V19.1949C8.17 18.7149 6 16.2549 6 13.2849ZM20 13.2849C20 8.86491 16.42 5.28491 12 5.28491C11.94 5.28491 11.88 5.29491 11.82 5.29491L12.91 4.20491L11.5 2.78491L8 6.28491L11.5 9.78491L12.91 8.37491L11.83 7.29491C11.89 7.29491 11.95 7.28491 12 7.28491C15.31 7.28491 18 9.97491 18 13.2849C18 16.2549 15.83 18.7149 13 19.1949V21.2149C16.95 20.7249 20 17.3649 20 13.2849Z"
        fill="#0C66E4"
      />
    </svg>
  );
};
export const EvidanceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9992 17.0833H2.79922V5.41667H9.99922V3.75H2.79922C1.91922 3.75 1.19922 4.5 1.19922 5.41667V17.0833C1.19922 18 1.91922 18.75 2.79922 18.75H13.9992C14.8792 18.75 15.5992 18 15.5992 17.0833V9.58333H13.9992V17.0833ZM7.76722 14.4417L6.19922 12.475L3.99922 15.4167H12.7992L9.96722 11.4917L7.76722 14.4417ZM15.5992 3.75V1.25H13.9992V3.75H11.5992C11.6072 3.75833 11.5992 5.41667 11.5992 5.41667H13.9992V7.90833C14.0072 7.91667 15.5992 7.90833 15.5992 7.90833V5.41667H17.9992V3.75H15.5992Z"
        fill="#172B4D"
      />
    </svg>
  );
};
export const NewXlsIcon = () => {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1.66699H8.88888L3.55554 6.66699V16.667C3.55554 17.5837 4.35554 18.3337 5.33332 18.3337H16C16.9778 18.3337 17.7778 17.5837 17.7778 16.667V3.33366C17.7778 2.41699 16.9778 1.66699 16 1.66699ZM16 3.33366V16.667H5.33332V7.35866L9.62665 3.33366H16Z"
        fill="#44546F"
      />
      <path
        d="M14.2222 10.8337L10.6667 14.167L7.1111 10.8337L8.36443 9.65866L9.77776 10.9753V7.51699L11.5555 7.50033V10.9753L12.9689 9.65033L14.2222 10.8337Z"
        fill="#44546F"
      />
      <rect
        x="8.88892"
        y="14.167"
        width="15.1111"
        height="5.83333"
        rx="1"
        fill="#44546F"
      />
      <path
        d="M10.5856 15.0557L11.4147 16.5346L12.2439 15.0557H13.0194L11.8387 17.0638L13.049 19.111H12.2654L11.4147 17.6042L10.5641 19.111H9.77783L10.9908 17.0638L9.80735 15.0557H10.5856Z"
        fill="white"
      />
      <path
        d="M16.0909 18.5567V19.111H14.1293V18.5567H16.0909ZM14.3171 15.0557V19.111H13.6435V15.0557H14.3171Z"
        fill="white"
      />
      <path
        d="M18.7651 18.0665C18.7651 17.983 18.7526 17.9087 18.7275 17.8437C18.7043 17.7787 18.6622 17.7193 18.6014 17.6654C18.5406 17.6116 18.4547 17.5596 18.3438 17.5095C18.2347 17.4575 18.0951 17.4046 17.9252 17.3507C17.7391 17.2913 17.5674 17.2254 17.41 17.153C17.2543 17.0787 17.1184 16.9933 17.0021 16.8967C16.8858 16.7983 16.7955 16.686 16.7311 16.5597C16.6667 16.4316 16.6344 16.284 16.6344 16.1169C16.6344 15.9516 16.6675 15.8012 16.7337 15.6657C16.8017 15.5301 16.8974 15.4131 17.0209 15.3147C17.1461 15.2145 17.2937 15.1374 17.4636 15.0836C17.6336 15.0279 17.8214 15 18.0272 15C18.317 15 18.5665 15.0557 18.7758 15.1671C18.9869 15.2785 19.1488 15.428 19.2616 15.6155C19.376 15.8031 19.4333 16.0101 19.4333 16.2366H18.7651C18.7651 16.1029 18.7374 15.985 18.6819 15.8829C18.6283 15.7789 18.546 15.6972 18.435 15.6378C18.3259 15.5784 18.1873 15.5487 18.0191 15.5487C17.8599 15.5487 17.7275 15.5738 17.622 15.6239C17.5164 15.674 17.4377 15.7418 17.3858 15.8272C17.3339 15.9126 17.308 16.0092 17.308 16.1169C17.308 16.193 17.325 16.2626 17.359 16.3258C17.393 16.387 17.4449 16.4446 17.5146 16.4984C17.5844 16.5504 17.6721 16.5996 17.7776 16.6461C17.8832 16.6925 18.0075 16.737 18.1506 16.7797C18.3671 16.8466 18.5558 16.9209 18.7168 17.0026C18.8778 17.0824 19.012 17.1734 19.1193 17.2755C19.2267 17.3776 19.3072 17.4937 19.3608 17.6237C19.4145 17.7518 19.4413 17.8975 19.4413 18.0609C19.4413 18.2318 19.4082 18.3859 19.3421 18.5233C19.2759 18.6588 19.1811 18.7749 19.0576 18.8714C18.936 18.9661 18.7893 19.0395 18.6175 19.0915C18.4476 19.1416 18.2579 19.1667 18.0486 19.1667C17.8608 19.1667 17.6756 19.1407 17.4932 19.0887C17.3125 19.0367 17.1479 18.9578 16.9994 18.8519C16.8509 18.7442 16.7328 18.6106 16.6452 18.4509C16.5575 18.2893 16.5137 18.1009 16.5137 17.8855H17.1872C17.1872 18.0173 17.2087 18.1296 17.2516 18.2225C17.2964 18.3153 17.3581 18.3915 17.4368 18.4509C17.5155 18.5084 17.6068 18.5511 17.7105 18.579C17.8161 18.6068 17.9288 18.6208 18.0486 18.6208C18.2061 18.6208 18.3376 18.5976 18.4431 18.5511C18.5504 18.5047 18.6309 18.4397 18.6846 18.3562C18.7383 18.2726 18.7651 18.1761 18.7651 18.0665Z"
        fill="white"
      />
      <path
        d="M20.6478 15.0557L21.4769 16.5346L22.3061 15.0557H23.0816L21.9009 17.0638L23.1112 19.111H22.3276L21.4769 17.6042L20.6263 19.111H19.84L21.053 17.0638L19.8695 15.0557H20.6478Z"
        fill="white"
      />
    </svg>
  );
};

export const NewSheetIcon = () => {
  return (
    <svg
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H6L0 6V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM14 2V18H2V6.83L6.83 2H14Z"
        fill="#44546F"
      />
      <rect x="8" y="15" width="17" height="7" rx="1" fill="#44546F" />
      <path
        d="M9.90869 16.0668L10.8415 17.8416L11.7744 16.0668H12.6468L11.3185 18.4766L12.68 20.9332H11.7985L10.8415 19.125L9.88453 20.9332H9L10.3645 18.4766L9.03321 16.0668H9.90869Z"
        fill="white"
      />
      <path
        d="M16.1022 20.268V20.9332H13.8953V20.268H16.1022ZM14.1067 16.0668V20.9332H13.3489V16.0668H14.1067Z"
        fill="white"
      />
      <path
        d="M19.1107 19.6798C19.1107 19.5795 19.0966 19.4904 19.0684 19.4124C19.0423 19.3344 18.995 19.2631 18.9265 19.1985C18.8581 19.1339 18.7615 19.0715 18.6367 19.0114C18.514 18.949 18.357 18.8855 18.1658 18.8209C17.9565 18.7496 17.7633 18.6705 17.5862 18.5836C17.4111 18.4944 17.2581 18.3919 17.1273 18.2761C16.9965 18.158 16.8948 18.0232 16.8224 17.8717C16.7499 17.7179 16.7137 17.5408 16.7137 17.3402C16.7137 17.1419 16.7509 16.9615 16.8254 16.7988C16.9019 16.6361 17.0095 16.4958 17.1484 16.3777C17.2893 16.2574 17.4553 16.1649 17.6465 16.1003C17.8377 16.0334 18.0491 16 18.2805 16C18.6065 16 18.8873 16.0668 19.1228 16.2005C19.3603 16.3342 19.5424 16.5136 19.6692 16.7386C19.798 16.9637 19.8624 17.2121 19.8624 17.484H19.1107C19.1107 17.3235 19.0795 17.182 19.0171 17.0595C18.9567 16.9347 18.8642 16.8367 18.7394 16.7654C18.6166 16.6941 18.4606 16.6584 18.2714 16.6584C18.0923 16.6584 17.9434 16.6885 17.8246 16.7487C17.7059 16.8088 17.6173 16.8902 17.559 16.9926C17.5006 17.0951 17.4714 17.211 17.4714 17.3402C17.4714 17.4316 17.4906 17.5152 17.5288 17.5909C17.567 17.6644 17.6254 17.7335 17.7039 17.7981C17.7824 17.8605 17.881 17.9196 17.9997 17.9753C18.1185 18.031 18.2584 18.0844 18.4194 18.1357C18.6629 18.2159 18.8752 18.305 19.0564 18.4031C19.2375 18.4989 19.3884 18.6081 19.5092 18.7306C19.6299 18.8532 19.7205 18.9924 19.7809 19.1484C19.8413 19.3021 19.8715 19.477 19.8715 19.6731C19.8715 19.8781 19.8342 20.0631 19.7598 20.2279C19.6853 20.3906 19.5786 20.5299 19.4398 20.6457C19.3029 20.7594 19.1379 20.8474 18.9447 20.9098C18.7535 20.9699 18.5401 21 18.3046 21C18.0933 21 17.885 20.9688 17.6797 20.9064C17.4765 20.844 17.2913 20.7493 17.1243 20.6223C16.9572 20.4931 16.8244 20.3327 16.7258 20.141C16.6272 19.9472 16.5778 19.721 16.5778 19.4626H17.3356C17.3356 19.6208 17.3597 19.7556 17.408 19.867C17.4584 19.9784 17.5278 20.0697 17.6163 20.141C17.7049 20.2101 17.8075 20.2614 17.9243 20.2948C18.043 20.3282 18.1698 20.3449 18.3046 20.3449C18.4818 20.3449 18.6297 20.3171 18.7484 20.2614C18.8692 20.2057 18.9597 20.1277 19.0201 20.0274C19.0805 19.9271 19.1107 19.8113 19.1107 19.6798Z"
        fill="white"
      />
      <path
        d="M21.2287 16.0668L22.1615 17.8416L23.0943 16.0668H23.9668L22.6385 18.4766L24 20.9332H23.1185L22.1615 19.125L21.2045 20.9332H20.32L21.6845 18.4766L20.3532 16.0668H21.2287Z"
        fill="white"
      />
      <path
        d="M12 10L8 6L4 10L5.41 11.41L7 9.83V13.98L9 14V9.83L10.59 11.42L12 10Z"
        fill="#44546F"
      />
    </svg>
  );
};
